const DAILY_PUZZLES = {
  "2026-08-09":   [
    {
      "category": "Islamic terms for divine decree and human agency",
      "words": [
        "Qadar",
        "Qada",
        "Tawfiq",
        "Khidlan"
      ],
      "difficulty": 1,
      "hint": "Concepts describing how divine will and human action relate"
    },
    {
      "category": "Titles of the Prophet mentioned in the Quran",
      "words": [
        "Nabi",
        "Rasul",
        "Bashir",
        "Nadhir"
      ],
      "difficulty": 2
    },
    {
      "category": "Early Islamic historical genres by short title",
      "words": [
        "Tarikh",
        "Futuh",
        "Ansab",
        "Siyar"
      ],
      "difficulty": 3
    },
    {
      "category": "Al-Ghazali's stages in the spiritual journey",
      "words": [
        "Tawba",
        "Sabr",
        "Shukr",
        "Rida"
      ],
      "difficulty": 4
    }
  ],
  "2026-08-08":   [
    {
      "category": "Phrases said at specific Islamic moments",
      "words": [
        "Basmalah",
        "Hamdala",
        "Hawqala",
        "Inna-Lillah"
      ],
      "difficulty": 1,
      "hint": "Each phrase is prescribed for a particular life moment or action"
    },
    {
      "category": "Islamic scholars who translated Greek texts into Arabic",
      "words": [
        "Hunayn",
        "Thabit",
        "Kindi",
        "Yuhanna"
      ],
      "difficulty": 2
    },
    {
      "category": "Elements of Islamic cosmology from the Quran",
      "words": [
        "Samawat",
        "Ardh",
        "Arsh",
        "Sidra"
      ],
      "difficulty": 3
    },
    {
      "category": "Regional Quranic recitation traditions (Qiraat)",
      "words": [
        "Hafs",
        "Warsh",
        "Qalun",
        "Duri"
      ],
      "difficulty": 4
    }
  ],
  "2026-08-07":   [
    {
      "category": "Months 7 through 10 of the Islamic lunar year",
      "words": [
        "Rajab",
        "Shaban",
        "Ramadan",
        "Shawwal"
      ],
      "difficulty": 1,
      "hint": "Four consecutive months in the second half of the Hijri calendar"
    },
    {
      "category": "Narrator reliability grades in Hadith science",
      "words": [
        "Thiqah",
        "Sadduq",
        "Maqbul",
        "Matruk"
      ],
      "difficulty": 2
    },
    {
      "category": "Prohibited elements in Islamic finance",
      "words": [
        "Gharar",
        "Maysir",
        "Riba",
        "Jahalah"
      ],
      "difficulty": 3
    },
    {
      "category": "The four Imams of Sunni jurisprudence",
      "words": [
        "Abu-Hanifa",
        "Malik",
        "Shafii",
        "Ahmad"
      ],
      "difficulty": 4
    }
  ],
  "2026-08-06":   [
    {
      "category": "Actions that invalidate the Salah",
      "words": [
        "Hadath",
        "Kashf",
        "Kalam",
        "Qahqaha"
      ],
      "difficulty": 1,
      "hint": "Things that break and void the Islamic prayer"
    },
    {
      "category": "Founders of major Sufi orders",
      "words": [
        "Gilani",
        "Naqshband",
        "Chishti",
        "Desouqi"
      ],
      "difficulty": 2
    },
    {
      "category": "Quranic chapters named after celestial phenomena",
      "words": [
        "Shams",
        "Qamar",
        "Najm",
        "Fajr"
      ],
      "difficulty": 3
    },
    {
      "category": "Categories of Islamic scholarly lineage",
      "words": [
        "Tabiun",
        "Tabi-Tabiun",
        "Mujtahid",
        "Mujaddid"
      ],
      "difficulty": 4
    }
  ],
  "2026-08-05":   [
    {
      "category": "Categories of accepted (Maqbul) hadith",
      "words": [
        "Sahih",
        "Hasan",
        "Mashur",
        "Aziz"
      ],
      "difficulty": 1,
      "hint": "Grades a hadith can receive when its narration is found acceptable"
    },
    {
      "category": "Companions from the Ansar of Madinah",
      "words": [
        "Ubay",
        "Abu-Ayyub",
        "Muadh",
        "Usayd"
      ],
      "difficulty": 2
    },
    {
      "category": "Cities of classical Islamic art and culture",
      "words": [
        "Cordoba",
        "Granada",
        "Fez",
        "Isfahan"
      ],
      "difficulty": 3
    },
    {
      "category": "Concepts in Islamic legal epistemology",
      "words": [
        "Qatiyyah",
        "Zanniyyah",
        "Kulliyyah",
        "Juziyyah"
      ],
      "difficulty": 4
    }
  ],
  "2026-08-04":   [
    {
      "category": "Types of congregational Islamic prayer",
      "words": [
        "Jumuah",
        "Eid",
        "Janaza",
        "Istisqa"
      ],
      "difficulty": 1,
      "hint": "Prayers performed in congregation for specific occasions"
    },
    {
      "category": "Famous Islamic creed texts (Aqida works)",
      "words": [
        "Wasitiyya",
        "Tahawiyya",
        "Fiqh-Akbar",
        "Sanusiyya"
      ],
      "difficulty": 2
    },
    {
      "category": "Gardens of Paradise (Jannah) by name",
      "words": [
        "Firdaws",
        "Adn",
        "Naim",
        "Mawa"
      ],
      "difficulty": 3
    },
    {
      "category": "Distinctive Maliki jurisprudential sources",
      "words": [
        "Amal",
        "Masalih",
        "Dhara'i",
        "Mursal"
      ],
      "difficulty": 4
    }
  ],
  "2026-08-03":   [
    {
      "category": "Sunnah acts for Yawm al-Jumuah (Friday)",
      "words": [
        "Ghusl",
        "Miswak",
        "Durud",
        "Kahf"
      ],
      "difficulty": 1,
      "hint": "Recommended acts specifically for Friday in Islamic practice"
    },
    {
      "category": "Islamic dynasties that ruled Al-Andalus",
      "words": [
        "Umayyad",
        "Almoravid",
        "Almohad",
        "Nasrid"
      ],
      "difficulty": 2
    },
    {
      "category": "Categories of heirs in Islamic inheritance (Fara'id)",
      "words": [
        "Fard",
        "Asaba",
        "Dhawil-Arham",
        "Hajb"
      ],
      "difficulty": 3
    },
    {
      "category": "Hadith defect types in Mustalah al-Hadith",
      "words": [
        "Ilah",
        "Shudhudh",
        "Idraj",
        "Qalb"
      ],
      "difficulty": 4
    }
  ],
  "2026-08-02":   [
    {
      "category": "Women's states affecting prayer in Islamic law",
      "words": [
        "Hayd",
        "Nifas",
        "Istihadah",
        "Tahara"
      ],
      "difficulty": 1,
      "hint": "Conditions related to women that affect the validity of Salah"
    },
    {
      "category": "Classical Islamic historians",
      "words": [
        "Ibn-Kathir",
        "Tabari",
        "Ibn-Khaldun",
        "Masudi"
      ],
      "difficulty": 2
    },
    {
      "category": "Surahs beginning with Alif Lam Ra",
      "words": [
        "Yunus",
        "Hud",
        "Yusuf",
        "Hijr"
      ],
      "difficulty": 3
    },
    {
      "category": "Sufi spiritual stations (Maqamat)",
      "words": [
        "Tawba",
        "Zuhd",
        "Faqr",
        "Sabr"
      ],
      "difficulty": 4
    }
  ],
  "2026-08-01":   [
    {
      "category": "The four Rightly-Guided Caliphs",
      "words": [
        "Abu-Bakr",
        "Umar",
        "Uthman",
        "Ali"
      ],
      "difficulty": 1,
      "hint": "The first four successors to lead the Muslim community"
    },
    {
      "category": "Mughal emperors of India",
      "words": [
        "Babur",
        "Humayun",
        "Akbar",
        "Aurangzeb"
      ],
      "difficulty": 2
    },
    {
      "category": "Islamic medical ethics concepts",
      "words": [
        "Maslaha",
        "Darura",
        "Tib",
        "Istihalah"
      ],
      "difficulty": 3
    },
    {
      "category": "Gates of Jannah",
      "words": [
        "Rayyan",
        "Ayman",
        "Kazimin",
        "Hajj"
      ],
      "difficulty": 4
    }
  ],
  "2026-07-31":   [
    {
      "category": "Steps in performing the ritual bath (Ghusl)",
      "words": [
        "Niyyah",
        "Basmalah",
        "Ightisal",
        "Tartib"
      ],
      "difficulty": 1,
      "hint": "Elements observed when performing the major ritual purification"
    },
    {
      "category": "Types of Nikah by legal validity",
      "words": [
        "Sahih",
        "Fasid",
        "Batil",
        "Mutah"
      ],
      "difficulty": 2
    },
    {
      "category": "Historical capitals of major Islamic caliphates",
      "words": [
        "Damascus",
        "Baghdad",
        "Cairo",
        "Constantinople"
      ],
      "difficulty": 3
    },
    {
      "category": "Scholarly positions on divine attributes (Sifat)",
      "words": [
        "Tafwid",
        "Tawil",
        "Ithbat",
        "Tanzih"
      ],
      "difficulty": 4
    }
  ],
  "2026-07-30":   [
    {
      "category": "Categories of Quranic verses by clarity",
      "words": [
        "Muhkam",
        "Mutashabih",
        "Mujmal",
        "Mubayyan"
      ],
      "difficulty": 1,
      "hint": "How Islamic scholars classify verses by how clear their meaning is"
    },
    {
      "category": "Famous classical Islamic poets",
      "words": [
        "Rumi",
        "Hafiz",
        "Iqbal",
        "Al-Mutanabbi"
      ],
      "difficulty": 2
    },
    {
      "category": "Early Islamic cities of scholarship",
      "words": [
        "Kufa",
        "Basra",
        "Fustat",
        "Nishapur"
      ],
      "difficulty": 3
    },
    {
      "category": "Concepts from Al-Farabi's ideal state theory",
      "words": [
        "Rais",
        "Fadila",
        "Niham",
        "Ittihad"
      ],
      "difficulty": 4
    }
  ],
  "2026-07-29":   [
    {
      "category": "Completes 'Abu ___' to name a famous Companion",
      "words": [
        "Bakr",
        "Hurayra",
        "Dharr",
        "Musa"
      ],
      "difficulty": 1,
      "hint": "Each word follows 'Abu' to form a well-known Companion's kunya"
    },
    {
      "category": "The remaining four books of the Kutub al-Sitta",
      "words": [
        "Abu-Dawud",
        "Tirmidhi",
        "Nasai",
        "Ibn-Majah"
      ],
      "difficulty": 2
    },
    {
      "category": "Types of dreams in Islamic tradition",
      "words": [
        "Sadiqah",
        "Nafsiyya",
        "Hulm",
        "Mubashshirah"
      ],
      "difficulty": 3
    },
    {
      "category": "Things sworn by in Quranic oaths (Aqsam)",
      "words": [
        "Shams",
        "Qamar",
        "Fajr",
        "Duha"
      ],
      "difficulty": 4
    }
  ],
  "2026-07-28":   [
    {
      "category": "Lesser-known Mothers of the Believers",
      "words": [
        "Juwayriyya",
        "Safiyya",
        "Maymuna",
        "Umm-Salamah"
      ],
      "difficulty": 1,
      "hint": "Wives of the Prophet often overlooked beyond the most famous"
    },
    {
      "category": "Muslim scientists and inventors",
      "words": [
        "Al-Jazari",
        "Ibn-Firnas",
        "Al-Zahrawi",
        "Al-Battani"
      ],
      "difficulty": 2
    },
    {
      "category": "Five principles of Mutazilah theology",
      "words": [
        "Tawhid",
        "Adl",
        "Waid",
        "Manzila"
      ],
      "difficulty": 3
    },
    {
      "category": "Stages of the Islamic funeral rite (Janaza)",
      "words": [
        "Ghusl",
        "Kafan",
        "Salat-Janaza",
        "Dafn"
      ],
      "difficulty": 4
    }
  ],
  "2026-07-27":   [
    {
      "category": "Stations on the Day of Judgment",
      "words": [
        "Mahshar",
        "Mawqif",
        "Sirat",
        "Mizan"
      ],
      "difficulty": 1,
      "hint": "Places or events that occur on Yawm al-Qiyamah"
    },
    {
      "category": "Virtues in Islamic ethics (Akhlaq)",
      "words": [
        "Sabr",
        "Shukr",
        "Tawadu",
        "Tawakkul"
      ],
      "difficulty": 2
    },
    {
      "category": "Quranic chapters named after human figures",
      "words": [
        "Luqman",
        "Maryam",
        "Nuh",
        "Muhammad"
      ],
      "difficulty": 3
    },
    {
      "category": "Specialized subjects in classical Islamic legal cases",
      "words": [
        "Khuntha",
        "Mukatab",
        "Mustahlak",
        "Ghanimat"
      ],
      "difficulty": 4
    }
  ],
  "2026-07-26":   [
    {
      "category": "Names for acts of verbal Islamic remembrance",
      "words": [
        "Tahmid",
        "Tasbih",
        "Takbir",
        "Tahlil"
      ],
      "difficulty": 1,
      "hint": "Each is a category of dhikr named for what is said"
    },
    {
      "category": "Quranic chapters named after animals",
      "words": [
        "Baqara",
        "Naml",
        "Nahl",
        "Fil"
      ],
      "difficulty": 2
    },
    {
      "category": "Categories of prayer by legal status",
      "words": [
        "Fard",
        "Wajib",
        "Sunnah",
        "Nafl"
      ],
      "difficulty": 3
    },
    {
      "category": "Scholars who developed Maqasid al-Shariah",
      "words": [
        "Ghazali",
        "Juwayni",
        "Shatibi",
        "Ibn-Ashur"
      ],
      "difficulty": 4
    }
  ],
  "2026-07-25":   [
    {
      "category": "Names of Allah (among the 99)",
      "words": [
        "Alim",
        "Qadir",
        "Sami",
        "Basir"
      ],
      "difficulty": 1,
      "hint": "Divine attributes meaning faculties of perception and power"
    },
    {
      "category": "Key events in the Prophet's mission",
      "words": [
        "Hijra",
        "Isra",
        "Miraj",
        "Fatah"
      ],
      "difficulty": 2
    },
    {
      "category": "Roles of religious authority in Islamic society",
      "words": [
        "Mufti",
        "Qadi",
        "Imam",
        "Faqih"
      ],
      "difficulty": 3
    },
    {
      "category": "Quranic rhetorical figures of sound and structure",
      "words": [
        "Tibaq",
        "Muqabala",
        "Jinas",
        "Fasila"
      ],
      "difficulty": 4
    }
  ],
  "2026-07-24":   [
    {
      "category": "Specially blessed times in the Islamic calendar",
      "words": [
        "Qadr",
        "Nisf",
        "Ashura",
        "Arafah"
      ],
      "difficulty": 1,
      "hint": "Nights or days known for heightened spiritual significance"
    },
    {
      "category": "Notable women in early Islamic history",
      "words": [
        "Umm-Salama",
        "Umm-Habiba",
        "Asma",
        "Sumayyah"
      ],
      "difficulty": 2
    },
    {
      "category": "Islamic inheritance law (Fara'id) concepts",
      "words": [
        "Asaba",
        "Furud",
        "Hajb",
        "Radd"
      ],
      "difficulty": 3
    },
    {
      "category": "Duties of the Caliph per Al-Mawardi",
      "words": [
        "Himaya",
        "Istikhraj",
        "Qada",
        "Aqd"
      ],
      "difficulty": 4
    }
  ],
  "2026-07-23":   [
    {
      "category": "Stages of Quran memorization mastery",
      "words": [
        "Hifz",
        "Muraja",
        "Dabt",
        "Itqan"
      ],
      "difficulty": 1,
      "hint": "Steps a hafiz goes through on the path to mastering the Quran"
    },
    {
      "category": "The four primary sources of Islamic law",
      "words": [
        "Quran",
        "Sunnah",
        "Ijma",
        "Qiyas"
      ],
      "difficulty": 2
    },
    {
      "category": "Famous historical Islamic centres of learning",
      "words": [
        "Azhar",
        "Qarawiyyin",
        "Zaytuna",
        "Nizamiyya"
      ],
      "difficulty": 3
    },
    {
      "category": "Faculties of the human self in Islamic philosophy",
      "words": [
        "Nafs",
        "Qalb",
        "Ruh",
        "Aql"
      ],
      "difficulty": 4
    }
  ],
  "2026-07-22":   [
    {
      "category": "Types of Islamic modest covering",
      "words": [
        "Hijab",
        "Niqab",
        "Khimar",
        "Jilbab"
      ],
      "difficulty": 1,
      "hint": "Garments associated with Islamic modesty for women"
    },
    {
      "category": "Types of Islamic endowment (Waqf)",
      "words": [
        "Ahli",
        "Khayri",
        "Mushtarak",
        "Muabbad"
      ],
      "difficulty": 2
    },
    {
      "category": "Companions who served as scribes of revelation",
      "words": [
        "Zaid",
        "Ubay",
        "Muawiya",
        "Khalid"
      ],
      "difficulty": 3
    },
    {
      "category": "Classical Islamic astronomical terms",
      "words": [
        "Falak",
        "Burj",
        "Samt",
        "Ufuq"
      ],
      "difficulty": 4
    }
  ],
  "2026-07-21":   [
    {
      "category": "Scriptures recognized in Islamic belief",
      "words": [
        "Tawrat",
        "Injil",
        "Zabur",
        "Suhuf"
      ],
      "difficulty": 1,
      "hint": "Divine books sent before the Quran, as Islam recognizes them"
    },
    {
      "category": "Celebrated Islamic calligraphers",
      "words": [
        "Ibn-Muqla",
        "Ibn-Bawwab",
        "Yaqut",
        "Hamdullah"
      ],
      "difficulty": 2
    },
    {
      "category": "Surahs that begin with Alif Lam Mim",
      "words": [
        "Baqara",
        "Imran",
        "Ankabut",
        "Rum"
      ],
      "difficulty": 3
    },
    {
      "category": "Islamic cosmological terms",
      "words": [
        "Arsh",
        "Kursi",
        "Barzakh",
        "Sidr"
      ],
      "difficulty": 4
    }
  ],
  "2026-07-20":   [
    {
      "category": "Prophets mentioned in Surah Maryam",
      "words": [
        "Zakariya",
        "Yahya",
        "Idris",
        "Ismail"
      ],
      "difficulty": 1,
      "hint": "Prophets whose stories appear in the nineteenth surah"
    },
    {
      "category": "Foundations of the five Islamic legal maxims",
      "words": [
        "Niyyah",
        "Yaqin",
        "Darar",
        "Mashaqqa"
      ],
      "difficulty": 2
    },
    {
      "category": "Types of Islamic financial instruments",
      "words": [
        "Sukuk",
        "Murabaha",
        "Mudaraba",
        "Ijarah"
      ],
      "difficulty": 3
    },
    {
      "category": "Major chapters of Islamic jurisprudence (Fiqh)",
      "words": [
        "Tahara",
        "Nikah",
        "Qisas",
        "Jihad"
      ],
      "difficulty": 4
    }
  ],
  "2026-07-19":   [
    {
      "category": "Divisions of the Quran for recitation scheduling",
      "words": [
        "Juz",
        "Hizb",
        "Rub",
        "Manzil"
      ],
      "difficulty": 1,
      "hint": "Units used to divide the Quran into manageable portions"
    },
    {
      "category": "Forms of Islamic devotional remembrance",
      "words": [
        "Dhikr",
        "Dua",
        "Istighfar",
        "Tasbih"
      ],
      "difficulty": 2
    },
    {
      "category": "Islamic legal concepts of property",
      "words": [
        "Milkiyya",
        "Tamlik",
        "Hiyaza",
        "Dayn"
      ],
      "difficulty": 3
    },
    {
      "category": "Modes of reasoning in Islamic logic (Mantiq)",
      "words": [
        "Qiyas",
        "Istiqra",
        "Tamthil",
        "Burhan"
      ],
      "difficulty": 4
    }
  ],
  "2026-07-18":   [
    {
      "category": "Rulings on water purity in Islamic law",
      "words": [
        "Mutlaq",
        "Mustamal",
        "Najis",
        "Tahir"
      ],
      "difficulty": 1,
      "hint": "How Islamic law classifies water for purification purposes"
    },
    {
      "category": "Prophets who were also rulers",
      "words": [
        "Dawud",
        "Sulayman",
        "Dhul-Qarnayn",
        "Yusuf"
      ],
      "difficulty": 2
    },
    {
      "category": "Famous Islamic geographers",
      "words": [
        "Idrisi",
        "Biruni",
        "Masudi",
        "Ibn-Hawqal"
      ],
      "difficulty": 3
    },
    {
      "category": "Sufi stages of spiritual development",
      "words": [
        "Takhalli",
        "Tahalli",
        "Tajalli",
        "Muraqaba"
      ],
      "difficulty": 4
    }
  ],
  "2026-07-17":   [
    {
      "category": "Humans mentioned by name in the Quran",
      "words": [
        "Maryam",
        "Zayd",
        "Luqman",
        "Imran"
      ],
      "difficulty": 1,
      "hint": "Non-prophet figures named explicitly in the Quran"
    },
    {
      "category": "Principles of Islamic governance",
      "words": [
        "Adl",
        "Shura",
        "Hurriya",
        "Amn"
      ],
      "difficulty": 2
    },
    {
      "category": "Technical terms in Ulum al-Quran",
      "words": [
        "Nasikh",
        "Mansukh",
        "Asbab",
        "Muhkam"
      ],
      "difficulty": 3
    },
    {
      "category": "Theological treatises by Ibn Taymiyya",
      "words": [
        "Wasitiyya",
        "Hamawiyya",
        "Tadmuriyya",
        "Safadiyya"
      ],
      "difficulty": 4
    }
  ],
  "2026-07-16":   [
    {
      "category": "Types of early Islamic narrative literature",
      "words": [
        "Sira",
        "Maghazi",
        "Tabaqat",
        "Manaqib"
      ],
      "difficulty": 1,
      "hint": "Genres of classical Islamic biography and history writing"
    },
    {
      "category": "Major Islamic empires",
      "words": [
        "Umayyad",
        "Abbasid",
        "Fatimid",
        "Ottoman"
      ],
      "difficulty": 2
    },
    {
      "category": "Surahs revealed in Madinah (Madani)",
      "words": [
        "Baqara",
        "Nisa",
        "Maidah",
        "Anfal"
      ],
      "difficulty": 3
    },
    {
      "category": "Secondary sources in Usul al-Fiqh",
      "words": [
        "Istihsan",
        "Istislah",
        "Maslaha",
        "Urf"
      ],
      "difficulty": 4
    }
  ],
  "2026-07-15":   [
    {
      "category": "Core rites of Hajj",
      "words": [
        "Ihram",
        "Tawaf",
        "Wuquf",
        "Ramy"
      ],
      "difficulty": 1,
      "hint": "Acts that are obligatory or essential during pilgrimage"
    },
    {
      "category": "Features of a classic mosque interior",
      "words": [
        "Minaret",
        "Mihrab",
        "Minbar",
        "Muqarnas"
      ],
      "difficulty": 2
    },
    {
      "category": "Companions among the Ten Promised Paradise",
      "words": [
        "Talha",
        "Zubayr",
        "Saad",
        "Abu-Ubayda"
      ],
      "difficulty": 3
    },
    {
      "category": "Arabic rhetorical devices in the Quran",
      "words": [
        "Iltifat",
        "Tashbih",
        "Kinaya",
        "Majaz"
      ],
      "difficulty": 4
    }
  ],
  "2026-07-14":   [
    {
      "category": "Historical names for the city of Madinah",
      "words": [
        "Yathrib",
        "Taybah",
        "Madinah",
        "Tabah"
      ],
      "difficulty": 1,
      "hint": "Names by which the Prophet's city has been known"
    },
    {
      "category": "Children of the Prophet Muhammad",
      "words": [
        "Qasim",
        "Ibrahim",
        "Zaynab",
        "Ruqayya"
      ],
      "difficulty": 2
    },
    {
      "category": "Types of traditional Islamic educational institutions",
      "words": [
        "Madrasa",
        "Kuttab",
        "Ribat",
        "Zawiya"
      ],
      "difficulty": 3
    },
    {
      "category": "Schools of Sunni and early Islamic theology (Kalam)",
      "words": [
        "Mutazila",
        "Ashariyya",
        "Maturidiyya",
        "Athariyya"
      ],
      "difficulty": 4
    }
  ],
  "2026-07-13":   [
    {
      "category": "The five rulings of Islamic jurisprudence (Ahkam)",
      "words": [
        "Wajib",
        "Mandub",
        "Haram",
        "Makruh"
      ],
      "difficulty": 1,
      "hint": "Legal categories that classify every human act in fiqh"
    },
    {
      "category": "Names of the levels of Jahannam",
      "words": [
        "Laza",
        "Hutama",
        "Saqar",
        "Saeer"
      ],
      "difficulty": 2
    },
    {
      "category": "Major Sufi orders (Tariqas)",
      "words": [
        "Qadiri",
        "Naqshbandi",
        "Chishti",
        "Shadhili"
      ],
      "difficulty": 3
    },
    {
      "category": "Hadith criticism terminology",
      "words": [
        "Jarh",
        "Tadil",
        "Mutawatir",
        "Ahad"
      ],
      "difficulty": 4
    }
  ],
  "2026-07-12":   [
    {
      "category": "Islamic epistemological categories",
      "words": [
        "Ilm",
        "Yaqin",
        "Zann",
        "Wahm"
      ],
      "difficulty": 1,
      "hint": "Arabic terms for levels of knowledge and certainty"
    },
    {
      "category": "Major battles of early Islam",
      "words": [
        "Badr",
        "Uhud",
        "Khandaq",
        "Hunayn"
      ],
      "difficulty": 2
    },
    {
      "category": "Types of Islamic geometric art and architecture",
      "words": [
        "Arabesque",
        "Girih",
        "Muqarnas",
        "Zellige"
      ],
      "difficulty": 3
    },
    {
      "category": "Works of Al-Ghazali",
      "words": [
        "Ihya",
        "Tahafut",
        "Maqasid",
        "Mishkat"
      ],
      "difficulty": 4
    }
  ],
  "2026-07-11":   [
    {
      "category": "Physical actions within Salah",
      "words": [
        "Takbir",
        "Ruku",
        "Sujud",
        "Tashahhud"
      ],
      "difficulty": 1,
      "hint": "Postures and acts performed during the Islamic prayer"
    },
    {
      "category": "First four months of the Islamic calendar",
      "words": [
        "Muharram",
        "Safar",
        "Rabi-Awwal",
        "Rabi-Thani"
      ],
      "difficulty": 2
    },
    {
      "category": "Classical scholars of Quranic exegesis (Tafsir)",
      "words": [
        "Tabari",
        "Zamakhshari",
        "Ibn-Kathir",
        "Baydawi"
      ],
      "difficulty": 3
    },
    {
      "category": "Divine attributes in Ashari theology",
      "words": [
        "Qidam",
        "Baqa",
        "Mukhalafa",
        "Wahdaniyya"
      ],
      "difficulty": 4
    }
  ],
  "2026-07-10":   [
    {
      "category": "Islamic terms for charitable giving",
      "words": [
        "Zakat",
        "Sadaqa",
        "Waqf",
        "Ushr"
      ],
      "difficulty": 1,
      "hint": "Ways to give in Islam, from obligatory to voluntary"
    },
    {
      "category": "Names for the Quran in Islamic tradition",
      "words": [
        "Furqan",
        "Dhikr",
        "Tanzil",
        "Kitab"
      ],
      "difficulty": 2
    },
    {
      "category": "Scholars of Islamic political theory",
      "words": [
        "Ibn-Khaldun",
        "Mawardi",
        "Ghazali",
        "Ibn-Taymiyya"
      ],
      "difficulty": 3
    },
    {
      "category": "Essential elements of a valid Nikah",
      "words": [
        "Ijab",
        "Qabul",
        "Wali",
        "Mahr"
      ],
      "difficulty": 4
    }
  ],
  "2026-07-09":   [
    {
      "category": "Types of Islamic financial contracts",
      "words": [
        "Bai",
        "Ijara",
        "Murabaha",
        "Musharaka"
      ],
      "difficulty": 1,
      "hint": "Forms of permissible Islamic trade and finance"
    },
    {
      "category": "Named angels and their duties",
      "words": [
        "Jibril",
        "Mikail",
        "Israfil",
        "Izrail"
      ],
      "difficulty": 2
    },
    {
      "category": "Major sins (Kaba'ir) in Islam",
      "words": [
        "Shirk",
        "Riba",
        "Zina",
        "Qatl"
      ],
      "difficulty": 3
    },
    {
      "category": "Sufi concepts of spiritual states (Ahwal)",
      "words": [
        "Fana",
        "Baqa",
        "Kashf",
        "Wajd"
      ],
      "difficulty": 4
    }
  ],
  "2026-07-08":   [
    {
      "category": "The four sacred months in Islam",
      "words": [
        "Rajab",
        "Muharram",
        "Dhul-Qadah",
        "Dhul-Hijjah"
      ],
      "difficulty": 1,
      "hint": "Months in which warfare was traditionally prohibited"
    },
    {
      "category": "Prophets mentioned in Surah Al-Anbiya",
      "words": [
        "Musa",
        "Isa",
        "Lut",
        "Sulayman"
      ],
      "difficulty": 2
    },
    {
      "category": "Titles of the Prophet Muhammad",
      "words": [
        "Mustafa",
        "Habibullah",
        "Khatam",
        "Amin"
      ],
      "difficulty": 3
    },
    {
      "category": "Kalam proofs for divine existence",
      "words": [
        "Huduth",
        "Imkan",
        "Tamanu",
        "Inaya"
      ],
      "difficulty": 4
    }
  ],
  "2026-07-07":   [
    {
      "category": "Articles of Islamic faith (Iman)",
      "words": [
        "Malaika",
        "Kutub",
        "Qadar",
        "Rusul"
      ],
      "difficulty": 1,
      "hint": "Things a Muslim must believe in as part of Iman"
    },
    {
      "category": "Sunni schools of jurisprudence (Madhabs)",
      "words": [
        "Hanafi",
        "Maliki",
        "Shafii",
        "Hanbali"
      ],
      "difficulty": 2
    },
    {
      "category": "Famous female Islamic scholars",
      "words": [
        "Aisha",
        "Fatima",
        "Nafisa",
        "Karima"
      ],
      "difficulty": 3
    },
    {
      "category": "Classical scholars of Hadith",
      "words": [
        "Bukhari",
        "Muslim",
        "Nawawi",
        "Dhahabi"
      ],
      "difficulty": 4
    }
  ],
  "2026-07-06":   [
    {
      "category": "Precedes 'al-Fitr' in Islamic phrases",
      "words": [
        "Eid",
        "Zakat",
        "Salat",
        "Takbir"
      ],
      "difficulty": 1,
      "hint": "Each word completes the phrase '___ al-Fitr'"
    },
    {
      "category": "Wives of the Prophet",
      "words": [
        "Khadijah",
        "Aisha",
        "Hafsa",
        "Sawda"
      ],
      "difficulty": 2
    },
    {
      "category": "Quranic chapters named after prophets",
      "words": [
        "Yunus",
        "Hud",
        "Ibrahim",
        "Nuh"
      ],
      "difficulty": 3
    },
    {
      "category": "Events of the Day of Judgment",
      "words": [
        "Hashr",
        "Mizan",
        "Sirat",
        "Hisab"
      ],
      "difficulty": 4
    }
  ],
  "2026-07-05":   [
    {
      "category": "Times of the day for worship",
      "words": [
        "Dawn",
        "Noon",
        "Sunset",
        "Night"
      ],
      "difficulty": 1,
      "hint": "Periods linked with daily prayers"
    },
    {
      "category": "Categories of pious predecessors",
      "words": [
        "Sahaba",
        "Tabiun",
        "Atba",
        "Salaf"
      ],
      "difficulty": 2
    },
    {
      "category": "Types of Shukr",
      "words": [
        "Qalb",
        "Lisan",
        "Jawarih",
        "Mal"
      ],
      "difficulty": 3
    },
    {
      "category": "Niches in Asbab al-Nuzul",
      "words": [
        "Sarih",
        "Muhtamil",
        "Amm",
        "Khass"
      ],
      "difficulty": 4
    }
  ],
  "2026-07-04":   [
    {
      "category": "Compulsory acts in Salah",
      "words": [
        "Niyya",
        "Takbir",
        "Qiraa",
        "Tasleem"
      ],
      "difficulty": 1,
      "hint": "Essential elements of valid prayer"
    },
    {
      "category": "Stories in Surah Kahf",
      "words": [
        "Sleepers",
        "Gardens",
        "Khidr",
        "Dhulqarnayn"
      ],
      "difficulty": 2
    },
    {
      "category": "Types of Ilm",
      "words": [
        "Nafi",
        "Darr",
        "Daruri",
        "Nazari"
      ],
      "difficulty": 3
    },
    {
      "category": "Levels of Yaqin",
      "words": [
        "Ilm",
        "Ayn",
        "Haqq",
        "Tahqiq"
      ],
      "difficulty": 4
    }
  ],
  "2026-07-03":   [
    {
      "category": "Common Islamic names",
      "words": [
        "Muhammad",
        "Ahmad",
        "Ali",
        "Fatima"
      ],
      "difficulty": 1,
      "hint": "Names widely used among Muslims"
    },
    {
      "category": "Categories of zakat wealth",
      "words": [
        "Gold",
        "Silver",
        "Livestock",
        "Crops"
      ],
      "difficulty": 2
    },
    {
      "category": "Types of Tawakkul",
      "words": [
        "Wajib",
        "Mandub",
        "Shirk",
        "Asbab"
      ],
      "difficulty": 3
    },
    {
      "category": "Conditions of Mutawatir",
      "words": [
        "Number",
        "Senses",
        "Impossibility",
        "Stages"
      ],
      "difficulty": 4
    }
  ],
  "2026-07-02":   [
    {
      "category": "Tools of ablution",
      "words": [
        "Water",
        "Hands",
        "Face",
        "Feet"
      ],
      "difficulty": 1,
      "hint": "Body parts washed during Wudu"
    },
    {
      "category": "Quranic surahs of the Mufassal",
      "words": [
        "Hujurat",
        "Qaf",
        "Dhariyat",
        "Tur"
      ],
      "difficulty": 2
    },
    {
      "category": "Types of Sabr",
      "words": [
        "Taa",
        "Masiya",
        "Musiba",
        "Bala"
      ],
      "difficulty": 3
    },
    {
      "category": "Categories of Mansukh",
      "words": [
        "Tilawa",
        "Hukm",
        "Kulli",
        "Juzi"
      ],
      "difficulty": 4
    }
  ],
  "2026-07-01":   [
    {
      "category": "Prophet's family members",
      "words": [
        "Khadija",
        "Fatima",
        "Hasan",
        "Husayn"
      ],
      "difficulty": 1,
      "hint": "Close relatives of the Messenger"
    },
    {
      "category": "Quranic surahs named after prophets",
      "words": [
        "Yunus",
        "Hud",
        "Yusuf",
        "Ibrahim"
      ],
      "difficulty": 2
    },
    {
      "category": "Types of Khabar Wahid",
      "words": [
        "Mashhur",
        "Aziz",
        "Gharib",
        "Fard"
      ],
      "difficulty": 3
    },
    {
      "category": "Categories of Hasana in Quran",
      "words": [
        "Imani",
        "Khuluqi",
        "Mali",
        "Badani"
      ],
      "difficulty": 4
    }
  ],
  "2026-06-30":   [
    {
      "category": "Months of Hajj",
      "words": [
        "Shawwal",
        "Qada",
        "Hijja",
        "Muharram"
      ],
      "difficulty": 1,
      "hint": "Sacred months connected to the pilgrimage season"
    },
    {
      "category": "Types of Tayammum surfaces",
      "words": [
        "Sand",
        "Stone",
        "Dust",
        "Earth"
      ],
      "difficulty": 2
    },
    {
      "category": "Names of Hellfire",
      "words": [
        "Jahim",
        "Saeer",
        "Hawiya",
        "Hutama"
      ],
      "difficulty": 3
    },
    {
      "category": "Terms in Ilm al-Mirath",
      "words": [
        "Warith",
        "Muwarrith",
        "Tarika",
        "Hajb"
      ],
      "difficulty": 4
    }
  ],
  "2026-06-29":   [
    {
      "category": "Quranic women",
      "words": [
        "Maryam",
        "Asiya",
        "Hawwa",
        "Bilqis"
      ],
      "difficulty": 1,
      "hint": "Notable women mentioned in scripture"
    },
    {
      "category": "Major surahs of protection",
      "words": [
        "Baqara",
        "Kursi",
        "Falaq",
        "Nas"
      ],
      "difficulty": 2
    },
    {
      "category": "Types of Khilafa",
      "words": [
        "Nubuwwa",
        "Rashida",
        "Mulk",
        "Jabriyya"
      ],
      "difficulty": 3
    },
    {
      "category": "Categories of Ijma",
      "words": [
        "Sarih",
        "Sukuti",
        "Sahaba",
        "Ahl"
      ],
      "difficulty": 4
    }
  ],
  "2026-06-28":   [
    {
      "category": "Stages of life in Islam",
      "words": [
        "Childhood",
        "Bulugh",
        "Adulthood",
        "Death"
      ],
      "difficulty": 1,
      "hint": "Phases marking moral responsibility"
    },
    {
      "category": "Tribes of Quraysh",
      "words": [
        "Hashim",
        "Umayya",
        "Makhzum",
        "Zuhra"
      ],
      "difficulty": 2
    },
    {
      "category": "Types of Najasa",
      "words": [
        "Mughallaza",
        "Mutawassita",
        "Mukhaffafa",
        "Hukmiyya"
      ],
      "difficulty": 3
    },
    {
      "category": "Categories in Ilm al-Kalam",
      "words": [
        "Sifat",
        "Qadar",
        "Imama",
        "Nubuwwa"
      ],
      "difficulty": 4
    }
  ],
  "2026-06-27":   [
    {
      "category": "Words for God in Quran",
      "words": [
        "Allah",
        "Rabb",
        "Ilah",
        "Mawla"
      ],
      "difficulty": 1,
      "hint": "Divine titles used throughout the Quran"
    },
    {
      "category": "Sunnah before Fard prayers",
      "words": [
        "Fajr",
        "Dhuhr",
        "Maghrib",
        "Isha"
      ],
      "difficulty": 2
    },
    {
      "category": "Categories of Sahih conditions",
      "words": [
        "Ittisal",
        "Adala",
        "Dabt",
        "Shudhudh"
      ],
      "difficulty": 3
    },
    {
      "category": "Sufi spiritual stations",
      "words": [
        "Tawba",
        "Wara",
        "Zuhd",
        "Faqr"
      ],
      "difficulty": 4
    }
  ],
  "2026-06-26":   [
    {
      "category": "Quranic gardens",
      "words": [
        "Firdaws",
        "Adn",
        "Naim",
        "Khuld"
      ],
      "difficulty": 1,
      "hint": "Levels and names of paradise"
    },
    {
      "category": "Sahaba in Badr",
      "words": [
        "Hamza",
        "Ali",
        "Bilal",
        "Miqdad"
      ],
      "difficulty": 2
    },
    {
      "category": "Types of Hadith by source",
      "words": [
        "Qudsi",
        "Marfu",
        "Mawquf",
        "Maqtu"
      ],
      "difficulty": 3
    },
    {
      "category": "Niches in Quranic abrogation",
      "words": [
        "Tilawa",
        "Hukm",
        "Both",
        "Neither"
      ],
      "difficulty": 4
    }
  ],
  "2026-06-25":   [
    {
      "category": "Halal foods",
      "words": [
        "Dates",
        "Honey",
        "Olives",
        "Milk"
      ],
      "difficulty": 1,
      "hint": "Permissible foods mentioned positively in scripture"
    },
    {
      "category": "Days of Tashriq",
      "words": [
        "Eleventh",
        "Twelfth",
        "Thirteenth",
        "Tenth"
      ],
      "difficulty": 2
    },
    {
      "category": "Types of Tahara in fiqh",
      "words": [
        "Wudu",
        "Ghusl",
        "Tayammum",
        "Masah"
      ],
      "difficulty": 3
    },
    {
      "category": "Conditions of Qiyas",
      "words": [
        "Asl",
        "Far",
        "Illa",
        "Hukm"
      ],
      "difficulty": 4
    }
  ],
  "2026-06-24":   [
    {
      "category": "Prayer call participants",
      "words": [
        "Muadhin",
        "Imam",
        "Mamum",
        "Khatib"
      ],
      "difficulty": 1,
      "hint": "Roles people fulfill in the mosque"
    },
    {
      "category": "Quranic prophets in Surah Anbiya",
      "words": [
        "Ayyub",
        "Yunus",
        "Zakariyya",
        "Yahya"
      ],
      "difficulty": 2
    },
    {
      "category": "Types of Riba",
      "words": [
        "Fadl",
        "Nasia",
        "Jahiliyya",
        "Qard"
      ],
      "difficulty": 3
    },
    {
      "category": "Categories of Ahkam",
      "words": [
        "Wajib",
        "Mandub",
        "Mubah",
        "Makruh"
      ],
      "difficulty": 4
    }
  ],
  "2026-06-23":   [
    {
      "category": "Major figures in Surah Yusuf",
      "words": [
        "Yusuf",
        "Yaqub",
        "Zulaykha",
        "Aziz"
      ],
      "difficulty": 1,
      "hint": "Characters in the Quranic story of Joseph"
    },
    {
      "category": "Types of Niyya",
      "words": [
        "Salah",
        "Sawm",
        "Hajj",
        "Zakat"
      ],
      "difficulty": 2
    },
    {
      "category": "Categories of Mufassirin",
      "words": [
        "Sahaba",
        "Tabiun",
        "Salaf",
        "Khalaf"
      ],
      "difficulty": 3
    },
    {
      "category": "Concepts in Maqasid al-Sharia",
      "words": [
        "Din",
        "Nafs",
        "Aql",
        "Nasl"
      ],
      "difficulty": 4
    }
  ],
  "2026-06-22":   [
    {
      "category": "Muslim daily duas",
      "words": [
        "Sleeping",
        "Eating",
        "Waking",
        "Travel"
      ],
      "difficulty": 1,
      "hint": "Occasions for prescribed supplications"
    },
    {
      "category": "Quranic surahs of refuge",
      "words": [
        "Falaq",
        "Nas",
        "Ikhlas",
        "Kafirun"
      ],
      "difficulty": 2
    },
    {
      "category": "Pillars of Hajj",
      "words": [
        "Ihram",
        "Wuquf",
        "Tawaf",
        "Sai"
      ],
      "difficulty": 3
    },
    {
      "category": "Types of Khabar in Hadith",
      "words": [
        "Muttasil",
        "Munqati",
        "Mursal",
        "Muallaq"
      ],
      "difficulty": 4
    }
  ],
  "2026-06-21":   [
    {
      "category": "Sahaba caliphs",
      "words": [
        "Bakr",
        "Umar",
        "Uthman",
        "Ali"
      ],
      "difficulty": 1,
      "hint": "The first four leaders after the Prophet"
    },
    {
      "category": "Things prohibited in Ihram",
      "words": [
        "Hunting",
        "Perfume",
        "Cutting",
        "Argument"
      ],
      "difficulty": 2
    },
    {
      "category": "Types of Tafsir",
      "words": [
        "Tahlili",
        "Mawdui",
        "Ijmali",
        "Muqaran"
      ],
      "difficulty": 3
    },
    {
      "category": "Categories of Hadith chains",
      "words": [
        "Mutawatir",
        "Mashhur",
        "Aziz",
        "Gharib"
      ],
      "difficulty": 4
    }
  ],
  "2026-06-20":   [
    {
      "category": "Prophetic miracles",
      "words": [
        "Israa",
        "Miraj",
        "Quran",
        "Moon"
      ],
      "difficulty": 1,
      "hint": "Extraordinary signs given to the Prophet"
    },
    {
      "category": "Stations of the Hereafter",
      "words": [
        "Qabr",
        "Bath",
        "Hashr",
        "Hisab"
      ],
      "difficulty": 2
    },
    {
      "category": "Types of Qiyas",
      "words": [
        "Awla",
        "Musawi",
        "Adna",
        "Khafi"
      ],
      "difficulty": 3
    },
    {
      "category": "Levels of Wilaya in tasawwuf",
      "words": [
        "Sughra",
        "Kubra",
        "Khassa",
        "Amma"
      ],
      "difficulty": 4
    }
  ],
  "2026-06-19":   [
    {
      "category": "Animals in the Quran",
      "words": [
        "Naqa",
        "Hud",
        "Naml",
        "Fil"
      ],
      "difficulty": 1,
      "hint": "Creatures featured in Quranic stories"
    },
    {
      "category": "Types of fasting",
      "words": [
        "Ramadan",
        "Ashura",
        "Arafa",
        "Ayyam"
      ],
      "difficulty": 2
    },
    {
      "category": "Names of the Quran",
      "words": [
        "Furqan",
        "Dhikr",
        "Kitab",
        "Tanzil"
      ],
      "difficulty": 3
    },
    {
      "category": "Categories in Mawarith",
      "words": [
        "Asaba",
        "Furud",
        "Hajb",
        "Awl"
      ],
      "difficulty": 4
    }
  ],
  "2026-06-18":   [
    {
      "category": "Festivals and special days",
      "words": [
        "Fitr",
        "Adha",
        "Ashura",
        "Mawlid"
      ],
      "difficulty": 1,
      "hint": "Notable dates in the Muslim calendar"
    },
    {
      "category": "Quranic prophets in one surah",
      "words": [
        "Ibrahim",
        "Ismail",
        "Ishaq",
        "Yaqub"
      ],
      "difficulty": 2
    },
    {
      "category": "Types of Waqf in recitation",
      "words": [
        "Lazim",
        "Jaiz",
        "Mujawwaz",
        "Mamnu"
      ],
      "difficulty": 3
    },
    {
      "category": "Conditions for valid Ijma",
      "words": [
        "Mujtahidin",
        "Asr",
        "Ittifaq",
        "Masala"
      ],
      "difficulty": 4
    }
  ],
  "2026-06-17":   [
    {
      "category": "Prophets given scriptures",
      "words": [
        "Musa",
        "Dawud",
        "Isa",
        "Muhammad"
      ],
      "difficulty": 1,
      "hint": "Recipients of revealed holy books"
    },
    {
      "category": "Times when prayer is forbidden",
      "words": [
        "Sunrise",
        "Zenith",
        "Sunset",
        "Twilight"
      ],
      "difficulty": 2
    },
    {
      "category": "Categories of Bida",
      "words": [
        "Hasana",
        "Sayyia",
        "Haqiqiyya",
        "Idafiyya"
      ],
      "difficulty": 3
    },
    {
      "category": "Quranic linguistic devices",
      "words": [
        "Majaz",
        "Kinaya",
        "Istiara",
        "Tashbih"
      ],
      "difficulty": 4
    }
  ],
  "2026-06-16":   [
    {
      "category": "Islamic greetings",
      "words": [
        "Salam",
        "Marhaba",
        "Ahlan",
        "Tahiyya"
      ],
      "difficulty": 1,
      "hint": "Phrases used when meeting fellow Muslims"
    },
    {
      "category": "Quranic stories of destruction",
      "words": [
        "Aad",
        "Thamud",
        "Madyan",
        "Lut"
      ],
      "difficulty": 2
    },
    {
      "category": "Types of Dhikr",
      "words": [
        "Tahlil",
        "Tasbih",
        "Tahmid",
        "Takbir"
      ],
      "difficulty": 3
    },
    {
      "category": "Niches in Tafsir methodology",
      "words": [
        "Mathur",
        "Rayi",
        "Ishari",
        "Fiqhi"
      ],
      "difficulty": 4
    }
  ],
  "2026-06-15":   [
    {
      "category": "Adhan phrases",
      "words": [
        "Takbir",
        "Shahada",
        "Hayya",
        "Falah"
      ],
      "difficulty": 1,
      "hint": "Key declarations in the call to prayer"
    },
    {
      "category": "Daughters of the Prophet",
      "words": [
        "Fatima",
        "Zaynab",
        "Ruqayya",
        "Kulthum"
      ],
      "difficulty": 2
    },
    {
      "category": "Types of Khushu",
      "words": [
        "Qalb",
        "Basar",
        "Lisan",
        "Jawarih"
      ],
      "difficulty": 3
    },
    {
      "category": "Schools of Aqeedah",
      "words": [
        "Athari",
        "Ashari",
        "Maturidi",
        "Mutazili"
      ],
      "difficulty": 4
    }
  ],
  "2026-06-14":   [
    {
      "category": "Quranic chapters by length",
      "words": [
        "Baqara",
        "Imran",
        "Nisa",
        "Maida"
      ],
      "difficulty": 1,
      "hint": "The longest surahs after Fatiha"
    },
    {
      "category": "Companions known as scribes",
      "words": [
        "Zayd",
        "Muawiya",
        "Ubayy",
        "Khalid"
      ],
      "difficulty": 2
    },
    {
      "category": "Types of charity",
      "words": [
        "Zakat",
        "Sadaqa",
        "Waqf",
        "Hiba"
      ],
      "difficulty": 3
    },
    {
      "category": "Quranic Makki themes",
      "words": [
        "Tawhid",
        "Akhira",
        "Qisas",
        "Akhlaq"
      ],
      "difficulty": 4
    }
  ],
  "2026-06-13":   [
    {
      "category": "Items of Hajj attire",
      "words": [
        "Ihram",
        "Izar",
        "Rida",
        "Sandals"
      ],
      "difficulty": 1,
      "hint": "Garments worn by male pilgrims"
    },
    {
      "category": "Caliphate dynasties",
      "words": [
        "Rashidun",
        "Umayyad",
        "Abbasid",
        "Ottoman"
      ],
      "difficulty": 2
    },
    {
      "category": "Conditions of Salah",
      "words": [
        "Tahara",
        "Qibla",
        "Waqt",
        "Niyya"
      ],
      "difficulty": 3
    },
    {
      "category": "Categories of Tahara",
      "words": [
        "Hadath",
        "Khabath",
        "Janaba",
        "Hayd"
      ],
      "difficulty": 4
    }
  ],
  "2026-06-12":   [
    {
      "category": "Components of Iman",
      "words": [
        "Allah",
        "Angels",
        "Books",
        "Messengers"
      ],
      "difficulty": 1,
      "hint": "Articles of faith every Muslim affirms"
    },
    {
      "category": "Types of Salah",
      "words": [
        "Fard",
        "Sunnah",
        "Nafl",
        "Witr"
      ],
      "difficulty": 2
    },
    {
      "category": "Gates of Paradise",
      "words": [
        "Salah",
        "Sadaqa",
        "Rayyan",
        "Jihad"
      ],
      "difficulty": 3
    },
    {
      "category": "Quranic legal verses",
      "words": [
        "Mudayana",
        "Mawarith",
        "Qisas",
        "Hudud"
      ],
      "difficulty": 4
    }
  ],
  "2026-06-11":   [
    {
      "category": "Prophets sent to Arabia",
      "words": [
        "Hud",
        "Salih",
        "Shuayb",
        "Muhammad"
      ],
      "difficulty": 1,
      "hint": "Messengers to ancient Arabian peoples"
    },
    {
      "category": "Sons of Prophet Yaqub",
      "words": [
        "Yusuf",
        "Binyamin",
        "Yahuda",
        "Rubel"
      ],
      "difficulty": 2
    },
    {
      "category": "Types of Nafs",
      "words": [
        "Ammara",
        "Lawwama",
        "Mutmainna",
        "Radiya"
      ],
      "difficulty": 3
    },
    {
      "category": "Sciences of Hadith",
      "words": [
        "Riwaya",
        "Diraya",
        "Jarh",
        "Tadil"
      ],
      "difficulty": 4
    }
  ],
  "2026-06-10":   [
    {
      "category": "Eid practices",
      "words": [
        "Takbir",
        "Salah",
        "Sadaqa",
        "Feast"
      ],
      "difficulty": 1,
      "hint": "Customs observed on Islamic holidays"
    },
    {
      "category": "Categories of Sunnah",
      "words": [
        "Qawli",
        "Fili",
        "Taqriri",
        "Wasfi"
      ],
      "difficulty": 2
    },
    {
      "category": "Hellfire descriptions",
      "words": [
        "Jahannam",
        "Saqar",
        "Hutama",
        "Lazza"
      ],
      "difficulty": 3
    },
    {
      "category": "Terms in Usul al-Fiqh",
      "words": [
        "Amm",
        "Khass",
        "Mutlaq",
        "Muqayyad"
      ],
      "difficulty": 4
    }
  ],
  "2026-06-09":   [
    {
      "category": "Wives of the Prophet",
      "words": [
        "Khadija",
        "Aisha",
        "Hafsa",
        "Zaynab"
      ],
      "difficulty": 1,
      "hint": "Mothers of the Believers"
    },
    {
      "category": "Quranic surahs about Mary",
      "words": [
        "Maryam",
        "Imran",
        "Anbiya",
        "Tahrim"
      ],
      "difficulty": 2
    },
    {
      "category": "Types of Tawassul",
      "words": [
        "Asma",
        "Amal",
        "Nabi",
        "Salihin"
      ],
      "difficulty": 3
    },
    {
      "category": "Conditions of Shahada",
      "words": [
        "Ilm",
        "Yaqin",
        "Ikhlas",
        "Sidq"
      ],
      "difficulty": 4
    }
  ],
  "2026-06-08":   [
    {
      "category": "Sources of Sharia",
      "words": [
        "Quran",
        "Sunnah",
        "Ijma",
        "Qiyas"
      ],
      "difficulty": 1,
      "hint": "Foundations from which Islamic law is derived"
    },
    {
      "category": "Acts of purification",
      "words": [
        "Wudu",
        "Ghusl",
        "Tayammum",
        "Istinja"
      ],
      "difficulty": 2
    },
    {
      "category": "Names of Paradise",
      "words": [
        "Firdaws",
        "Adn",
        "Naim",
        "Mawa"
      ],
      "difficulty": 3
    },
    {
      "category": "Quranic recitation styles",
      "words": [
        "Tahqiq",
        "Tartil",
        "Tadwir",
        "Hadr"
      ],
      "difficulty": 4
    }
  ],
  "2026-06-07":   [
    {
      "category": "Mosques of significance",
      "words": [
        "Haram",
        "Nabawi",
        "Aqsa",
        "Quba"
      ],
      "difficulty": 1,
      "hint": "Sacred houses of worship in Islam"
    },
    {
      "category": "Battles in early Islam",
      "words": [
        "Badr",
        "Uhud",
        "Khandaq",
        "Hunayn"
      ],
      "difficulty": 2
    },
    {
      "category": "Terms in Aqeedah",
      "words": [
        "Iman",
        "Kufr",
        "Shirk",
        "Nifaq"
      ],
      "difficulty": 3
    },
    {
      "category": "Categories of Hadith narrators",
      "words": [
        "Thiqa",
        "Saduq",
        "Layyin",
        "Matruk"
      ],
      "difficulty": 4
    }
  ],
  "2026-06-06":   [
    {
      "category": "Things that break fasting",
      "words": [
        "Eating",
        "Drinking",
        "Smoking",
        "Intercourse"
      ],
      "difficulty": 1,
      "hint": "Actions that nullify the daily fast"
    },
    {
      "category": "Rightly guided caliphs",
      "words": [
        "Abu Bakr",
        "Umar",
        "Uthman",
        "Ali"
      ],
      "difficulty": 2
    },
    {
      "category": "Quranic oaths",
      "words": [
        "Tin",
        "Asr",
        "Fajr",
        "Layl"
      ],
      "difficulty": 3
    },
    {
      "category": "Types of Ijtihad",
      "words": [
        "Mutlaq",
        "Madhhab",
        "Masala",
        "Tarjih"
      ],
      "difficulty": 4
    }
  ],
  "2026-06-05":   [
    {
      "category": "Prayer positions",
      "words": [
        "Qiyam",
        "Ruku",
        "Sujud",
        "Julus"
      ],
      "difficulty": 1,
      "hint": "Physical postures during Salah"
    },
    {
      "category": "Ramadan terms",
      "words": [
        "Suhur",
        "Iftar",
        "Taraweeh",
        "Itikaf"
      ],
      "difficulty": 2
    },
    {
      "category": "Schools of fiqh",
      "words": [
        "Hanafi",
        "Maliki",
        "Shafii",
        "Hanbali"
      ],
      "difficulty": 3
    },
    {
      "category": "Levels of certainty",
      "words": [
        "Ilm",
        "Ayn",
        "Haqq",
        "Yaqin"
      ],
      "difficulty": 4
    }
  ],
  "2026-06-04":   [
    {
      "category": "Hajj rituals",
      "words": [
        "Tawaf",
        "Sai",
        "Wuquf",
        "Ramy"
      ],
      "difficulty": 1,
      "hint": "Actions performed during pilgrimage"
    },
    {
      "category": "Places in Mecca",
      "words": [
        "Kaaba",
        "Safa",
        "Marwa",
        "Mina"
      ],
      "difficulty": 2
    },
    {
      "category": "Types of Tawhid",
      "words": [
        "Rububiyya",
        "Uluhiyya",
        "Asma",
        "Sifat"
      ],
      "difficulty": 3
    },
    {
      "category": "Sufi spiritual states",
      "words": [
        "Qabd",
        "Bast",
        "Khawf",
        "Raja"
      ],
      "difficulty": 4
    }
  ],
  "2026-06-03":   [
    {
      "category": "Holy books",
      "words": [
        "Quran",
        "Tawrat",
        "Injil",
        "Zabur"
      ],
      "difficulty": 1,
      "hint": "Divine scriptures revealed to prophets"
    },
    {
      "category": "Angels named in revelation",
      "words": [
        "Jibril",
        "Mikail",
        "Israfil",
        "Malik"
      ],
      "difficulty": 2
    },
    {
      "category": "Sciences of the Quran",
      "words": [
        "Tajwid",
        "Tafsir",
        "Asbab",
        "Nasikh"
      ],
      "difficulty": 3
    },
    {
      "category": "Stations of the soul",
      "words": [
        "Ammara",
        "Lawwama",
        "Mutmainna",
        "Mulhama"
      ],
      "difficulty": 4
    }
  ],
  "2026-06-02":   [
    {
      "category": "Major prophets",
      "words": [
        "Adam",
        "Nuh",
        "Ibrahim",
        "Musa"
      ],
      "difficulty": 1,
      "hint": "Messengers sent with scriptures"
    },
    {
      "category": "Islamic months",
      "words": [
        "Muharram",
        "Safar",
        "Rajab",
        "Shaban"
      ],
      "difficulty": 2
    },
    {
      "category": "Hadith grading terms",
      "words": [
        "Sahih",
        "Hasan",
        "Daif",
        "Mawdu"
      ],
      "difficulty": 3
    },
    {
      "category": "Categories of Zakat recipients",
      "words": [
        "Fuqara",
        "Masakin",
        "Amilin",
        "Mualafa"
      ],
      "difficulty": 4
    }
  ],
  "2026-06-01":   [
    {
      "category": "Pillars of Islam",
      "words": [
        "Shahada",
        "Salah",
        "Zakat",
        "Hajj"
      ],
      "difficulty": 1,
      "hint": "The five obligations every Muslim must fulfill"
    },
    {
      "category": "Daily prayers",
      "words": [
        "Fajr",
        "Dhuhr",
        "Asr",
        "Isha"
      ],
      "difficulty": 2
    },
    {
      "category": "Names meaning The Merciful",
      "words": [
        "Rahman",
        "Rahim",
        "Rauf",
        "Wadud"
      ],
      "difficulty": 3
    },
    {
      "category": "Companions of the Cave",
      "words": [
        "Maximilian",
        "Martinian",
        "Dionysius",
        "Yamliha"
      ],
      "difficulty": 4
    }
  ],
  "2026-05-31":   [
    {
      "category": "Surahs with Feminine or Women-Related Names",
      "words": [
        "nisa",
        "mujadilah",
        "mumtahinah",
        "maryam"
      ],
      "difficulty": 1,
      "hint": "Quranic chapters named after women or women-related themes"
    },
    {
      "category": "Types of Prophetic Intercession",
      "words": [
        "uzma",
        "khassa",
        "ammah",
        "tawbah"
      ],
      "difficulty": 2
    },
    {
      "category": "Strength of Evidence in Usul",
      "words": [
        "qati",
        "zanni",
        "mashkuk",
        "mawhum"
      ],
      "difficulty": 3
    },
    {
      "category": "Major Sufi Tariqahs",
      "words": [
        "qadiri",
        "naqshbandi",
        "shadhili",
        "rifai"
      ],
      "difficulty": 4
    }
  ],
  "2026-05-30":   [
    {
      "category": "Famous Hadith Scholars of Rijal Criticism",
      "words": [
        "daraqutni",
        "dhahabi",
        "nawawi",
        "mizzi"
      ],
      "difficulty": 1,
      "hint": "Scholars known for evaluating hadith narrators"
    },
    {
      "category": "Parts of a Jumu'ah Khutbah",
      "words": [
        "hamd",
        "shahadah",
        "wasiyyah",
        "tilawah"
      ],
      "difficulty": 2
    },
    {
      "category": "Types of Hukm Wadi (Circumstantial Ruling)",
      "words": [
        "sabab",
        "shart",
        "mani",
        "rukhsah"
      ],
      "difficulty": 3
    },
    {
      "category": "Figures of Speech in Balaghah",
      "words": [
        "tashbih",
        "istiara",
        "majaz",
        "tawriyah"
      ],
      "difficulty": 4
    }
  ],
  "2026-05-29":   [
    {
      "category": "Forms of Sadaqa Jariyah",
      "words": [
        "waqf",
        "ilm",
        "walad",
        "quran"
      ],
      "difficulty": 1,
      "hint": "Deeds whose reward continues flowing after a person's death"
    },
    {
      "category": "Types of Kaffarah (Expiation)",
      "words": [
        "yamin",
        "zihar",
        "qatl",
        "jima"
      ],
      "difficulty": 2
    },
    {
      "category": "Milestones of the Prophetic Biography",
      "words": [
        "mawlid",
        "hijrah",
        "miraj",
        "wafah"
      ],
      "difficulty": 3
    },
    {
      "category": "Hadith Chain Continuity Terms",
      "words": [
        "musnad",
        "mursul",
        "munqati",
        "muallaq"
      ],
      "difficulty": 4
    }
  ],
  "2026-05-28":   [
    {
      "category": "Names and Titles of the Prophet",
      "words": [
        "taha",
        "yasin",
        "khatam",
        "nabi"
      ],
      "difficulty": 1,
      "hint": "Names by which Prophet Muhammad is referred to in Islamic sources"
    },
    {
      "category": "Famous Classical Tafsir Authors",
      "words": [
        "tabari",
        "qurtubi",
        "kathir",
        "suyuti"
      ],
      "difficulty": 2
    },
    {
      "category": "Types of Shirk",
      "words": [
        "akbar",
        "asghar",
        "khafi",
        "jali"
      ],
      "difficulty": 3
    },
    {
      "category": "Faculties of Perception in Islamic Philosophy",
      "words": [
        "hiss",
        "khayal",
        "wahm",
        "aql"
      ],
      "difficulty": 4
    }
  ],
  "2026-05-27":   [
    {
      "category": "Acts That Invalidate the Fast",
      "words": [
        "akl",
        "shurb",
        "jimah",
        "riddah"
      ],
      "difficulty": 1,
      "hint": "Things that break the Ramadan fast according to fiqh"
    },
    {
      "category": "Types of Tawaf",
      "words": [
        "qudum",
        "ifadah",
        "wada",
        "tatawwu"
      ],
      "difficulty": 2
    },
    {
      "category": "Levels of Fiqh Study",
      "words": [
        "usul",
        "furu",
        "qawaid",
        "nazariyyah"
      ],
      "difficulty": 3
    },
    {
      "category": "Categories of Prophetic Miracle",
      "words": [
        "hissiyyah",
        "aqliyyah",
        "khabariyyah",
        "tashriiyyah"
      ],
      "difficulty": 4
    }
  ],
  "2026-05-26":   [
    {
      "category": "The Five Pillars of Islam",
      "words": [
        "salah",
        "sawm",
        "hajj",
        "zakat"
      ],
      "difficulty": 1,
      "hint": "Core acts of worship that every Muslim must perform"
    },
    {
      "category": "Classifications of Quranic Qiraat",
      "words": [
        "mutawatir",
        "mashhur",
        "shadh",
        "mawdu"
      ],
      "difficulty": 2
    },
    {
      "category": "Types of Bay'ah in Early Islam",
      "words": [
        "ridwan",
        "harb",
        "imrah",
        "aqabah"
      ],
      "difficulty": 3
    },
    {
      "category": "Concepts in Islamic Political Theory",
      "words": [
        "shura",
        "bayah",
        "hisbah",
        "wilayah"
      ],
      "difficulty": 4
    }
  ],
  "2026-05-25":   [
    {
      "category": "Major Signs of the Last Hour",
      "words": [
        "dajjal",
        "yajuj",
        "dukhan",
        "dabbah"
      ],
      "difficulty": 1,
      "hint": "Events mentioned in hadith as major signs before the Day of Judgment"
    },
    {
      "category": "Historical Islamic Caliphate Dynasties",
      "words": [
        "rashidun",
        "umayyad",
        "abbasid",
        "fatimid"
      ],
      "difficulty": 2
    },
    {
      "category": "Branches of Islamic Jurisprudence",
      "words": [
        "ibadat",
        "muamalat",
        "munakahah",
        "jinayat"
      ],
      "difficulty": 3
    },
    {
      "category": "Types of Scholarly Dispute in Usul",
      "words": [
        "lafzi",
        "maanawi",
        "haqiqi",
        "tanazul"
      ],
      "difficulty": 4
    }
  ],
  "2026-05-24":   [
    {
      "category": "Sacred Months in the Islamic Calendar",
      "words": [
        "muharram",
        "rajab",
        "dhulqidah",
        "dhulhijja"
      ],
      "difficulty": 1,
      "hint": "The four months in which traditional warfare was forbidden"
    },
    {
      "category": "Disputed Types of Marriage Contracts",
      "words": [
        "mutah",
        "misyar",
        "urfi",
        "tahlil"
      ],
      "difficulty": 2
    },
    {
      "category": "Types of Dhikr Phrases",
      "words": [
        "tasbih",
        "tahmid",
        "takbir",
        "hawqala"
      ],
      "difficulty": 3
    },
    {
      "category": "Advanced Islamic Finance Instruments",
      "words": [
        "urbun",
        "tawriq",
        "sukuk",
        "hawala"
      ],
      "difficulty": 4
    }
  ],
  "2026-05-23":   [
    {
      "category": "Prophets in Surah al-Anbiya",
      "words": [
        "musa",
        "ibrahim",
        "lut",
        "dawud"
      ],
      "difficulty": 1,
      "hint": "Prophets whose stories are told in the Chapter of the Prophets"
    },
    {
      "category": "Famous Muslim Scientists by Surname",
      "words": [
        "biruni",
        "khwarizmi",
        "battani",
        "farghani"
      ],
      "difficulty": 2
    },
    {
      "category": "Types of Hukm Shari (Legal Ruling)",
      "words": [
        "taklifi",
        "wadi",
        "rakhsah",
        "azimah"
      ],
      "difficulty": 3
    },
    {
      "category": "Kalam Arguments for Gods Existence",
      "words": [
        "imkan",
        "wujub",
        "tartib",
        "inayah"
      ],
      "difficulty": 4
    }
  ],
  "2026-05-22":   [
    {
      "category": "Categories of Prayer by Obligation",
      "words": [
        "fard",
        "nafl",
        "witr",
        "sunnah"
      ],
      "difficulty": 1,
      "hint": "How Islamic prayers are classified by their legal status"
    },
    {
      "category": "Steps in Performing Wudu",
      "words": [
        "niyyah",
        "tasmiyah",
        "masah",
        "khilal"
      ],
      "difficulty": 2
    },
    {
      "category": "Types of Riba",
      "words": [
        "fadl",
        "nasiah",
        "jahiliyyah",
        "qardh"
      ],
      "difficulty": 3
    },
    {
      "category": "Conditions for Valid Ijtihad",
      "words": [
        "istifragh",
        "taqwa",
        "istiqlal",
        "itqan"
      ],
      "difficulty": 4
    }
  ],
  "2026-05-21":   [
    {
      "category": "Conditions That Make Zakat Obligatory",
      "words": [
        "nisab",
        "hawl",
        "tamlik",
        "hurriyah"
      ],
      "difficulty": 1,
      "hint": "Requirements that trigger the obligation to pay zakat"
    },
    {
      "category": "Core Topics of Islamic Creed Texts",
      "words": [
        "tawhid",
        "nubuwwah",
        "maad",
        "samiyyat"
      ],
      "difficulty": 2
    },
    {
      "category": "Defects That Weaken a Hadith Chain",
      "words": [
        "illah",
        "shudhudh",
        "tadlis",
        "inqita"
      ],
      "difficulty": 3
    },
    {
      "category": "Quran Recitation Pause Rules",
      "words": [
        "lazim",
        "mutlaq",
        "jaiz",
        "mamnu"
      ],
      "difficulty": 4
    }
  ],
  "2026-05-20":   [
    {
      "category": "Surahs Named After Prophets",
      "words": [
        "yunus",
        "hud",
        "ibrahim",
        "nuh"
      ],
      "difficulty": 1,
      "hint": "Quranic chapters bearing the name of a prophet"
    },
    {
      "category": "Prohibited Foods in Islam",
      "words": [
        "khamr",
        "khinzir",
        "dam",
        "maitah"
      ],
      "difficulty": 2
    },
    {
      "category": "Technical Terms for Quranic Clarity",
      "words": [
        "mujmal",
        "mufassar",
        "mubayyan",
        "mubham"
      ],
      "difficulty": 3
    },
    {
      "category": "Categories of Scholarly Disagreement",
      "words": [
        "ikhtilaf",
        "tanawwu",
        "tarjih",
        "talfiq"
      ],
      "difficulty": 4
    }
  ],
  "2026-05-19":   [
    {
      "category": "Animals Mentioned in the Quran",
      "words": [
        "fil",
        "baqar",
        "naml",
        "himar"
      ],
      "difficulty": 1,
      "hint": "Creatures that appear in Quranic stories or verses"
    },
    {
      "category": "Companions Known by a Single Name",
      "words": [
        "bilal",
        "zayd",
        "salman",
        "ammar"
      ],
      "difficulty": 2
    },
    {
      "category": "Approaches to Quranic Tafsir",
      "words": [
        "athari",
        "ilmi",
        "fiqhi",
        "sufi"
      ],
      "difficulty": 3
    },
    {
      "category": "Divine Attributes Debated in Kalam",
      "words": [
        "huduth",
        "qidam",
        "iradah",
        "qudrah"
      ],
      "difficulty": 4
    }
  ],
  "2026-05-18":   [
    {
      "category": "Battles in the Prophetic Era",
      "words": [
        "badr",
        "uhud",
        "khandaq",
        "hunayn"
      ],
      "difficulty": 1,
      "hint": "Military encounters during the lifetime of the Prophet"
    },
    {
      "category": "Hadith Narrator Reliability Grades",
      "words": [
        "hafiz",
        "hujjah",
        "thabt",
        "dabit"
      ],
      "difficulty": 2
    },
    {
      "category": "Categories of Qiyas (Analogy)",
      "words": [
        "jali",
        "khafi",
        "adna",
        "awla"
      ],
      "difficulty": 3
    },
    {
      "category": "Terms from Islamic Falsafa",
      "words": [
        "hayula",
        "surah",
        "jism",
        "quwwah"
      ],
      "difficulty": 4
    }
  ],
  "2026-05-17":   [
    {
      "category": "Mothers of the Believers",
      "words": [
        "khadijah",
        "aisha",
        "hafsah",
        "zaynab"
      ],
      "difficulty": 1,
      "hint": "Wives of Prophet Muhammad known by this title"
    },
    {
      "category": "Categories of Prophetic Sunnah",
      "words": [
        "qawliyyah",
        "filiyyah",
        "taqririyyah",
        "hammiyyah"
      ],
      "difficulty": 2
    },
    {
      "category": "Types of Scholarly Ijma",
      "words": [
        "sarih",
        "sukuti",
        "muntashir",
        "qati"
      ],
      "difficulty": 3
    },
    {
      "category": "Advanced Sufi Stations",
      "words": [
        "fana",
        "baqa",
        "mahw",
        "sahw"
      ],
      "difficulty": 4
    }
  ],
  "2026-05-16":   [
    {
      "category": "Types of Quranic Content",
      "words": [
        "ahkam",
        "aqaid",
        "qisas",
        "amthal"
      ],
      "difficulty": 1,
      "hint": "Subject-matter categories found throughout the Quran"
    },
    {
      "category": "Types of Guardianship (Walayah) in Fiqh",
      "words": [
        "ijbar",
        "ikhtiyar",
        "tafwid",
        "tawkil"
      ],
      "difficulty": 2
    },
    {
      "category": "Spiritual States in Tasawwuf",
      "words": [
        "zuhd",
        "tawakkul",
        "ridha",
        "sabr"
      ],
      "difficulty": 3
    },
    {
      "category": "Layers of Meaning in Sufi Interpretation",
      "words": [
        "zahir",
        "batin",
        "ibarat",
        "isharah"
      ],
      "difficulty": 4
    }
  ],
  "2026-05-15":   [
    {
      "category": "Conditions for the Shahadah to be Valid",
      "words": [
        "ilm",
        "yaqin",
        "ikhlas",
        "sidq"
      ],
      "difficulty": 1,
      "hint": "What a person must have for the declaration of faith to be accepted"
    },
    {
      "category": "Fixed Hudud Offenses",
      "words": [
        "qadhf",
        "sariqah",
        "harabah",
        "shurb"
      ],
      "difficulty": 2
    },
    {
      "category": "Levels of Scholarly Agreement",
      "words": [
        "muttafaq",
        "mukhtalaf",
        "mutawatir",
        "mahjur"
      ],
      "difficulty": 3
    },
    {
      "category": "Terms in Islamic Mantiq (Logic)",
      "words": [
        "hadd",
        "burhan",
        "qiyas",
        "istiqra"
      ],
      "difficulty": 4
    }
  ],
  "2026-05-14":   [
    {
      "category": "Common Islamic Phrases",
      "words": [
        "salam",
        "alhamdulillah",
        "subhanallah",
        "bismillah"
      ],
      "difficulty": 1,
      "hint": "Everyday Arabic phrases used by Muslims in speech and prayer"
    },
    {
      "category": "Categories of Zakatable Wealth",
      "words": [
        "nuqud",
        "maashi",
        "zaraah",
        "tijarah"
      ],
      "difficulty": 2
    },
    {
      "category": "Categories in Ilm al-Kalam",
      "words": [
        "zat",
        "sifat",
        "afal",
        "asma"
      ],
      "difficulty": 3
    },
    {
      "category": "Disciplines of Quran Preservation",
      "words": [
        "qiraat",
        "tajwid",
        "rasm",
        "dabt"
      ],
      "difficulty": 4
    }
  ],
  "2026-05-13":   [
    {
      "category": "Mosques Known by a Single Name",
      "words": [
        "haram",
        "nabawi",
        "aqsa",
        "umayyad"
      ],
      "difficulty": 1,
      "hint": "Celebrated mosques referred to by a single identifying word"
    },
    {
      "category": "Forms of Prophetic Hadith",
      "words": [
        "qawli",
        "fili",
        "taqriri",
        "sifati"
      ],
      "difficulty": 2
    },
    {
      "category": "Elements of an Islamic Contract",
      "words": [
        "aqidain",
        "mahall",
        "sighah",
        "sabab"
      ],
      "difficulty": 3
    },
    {
      "category": "Foundational Quran Sciences Terms",
      "words": [
        "muhkam",
        "mutashabih",
        "nasikh",
        "mansukh"
      ],
      "difficulty": 4
    }
  ],
  "2026-05-12":   [
    {
      "category": "Days with Recommended Fasting",
      "words": [
        "ashura",
        "arafah",
        "tasuaa",
        "bidh"
      ],
      "difficulty": 1,
      "hint": "Specific days the Prophet recommended fasting outside of Ramadan"
    },
    {
      "category": "Features of Islamic Architecture",
      "words": [
        "qubba",
        "minara",
        "sahn",
        "iwan"
      ],
      "difficulty": 2
    },
    {
      "category": "Types of Islamic Waqf",
      "words": [
        "khayri",
        "ahli",
        "mushtarak",
        "muhaddad"
      ],
      "difficulty": 3
    },
    {
      "category": "Islamic Administrative and Legal Titles",
      "words": [
        "qadi",
        "muhtasib",
        "naqib",
        "hajib"
      ],
      "difficulty": 4
    }
  ],
  "2026-05-11":   [
    {
      "category": "Prophetic Titles by Relationship to Allah",
      "words": [
        "khalilullah",
        "kalimullah",
        "ruhullah",
        "khatam"
      ],
      "difficulty": 1,
      "hint": "Special titles showing how each prophet relates to God"
    },
    {
      "category": "Times When Prayer is Forbidden",
      "words": [
        "tuluu",
        "istiwa",
        "ghurub",
        "isfraar"
      ],
      "difficulty": 2
    },
    {
      "category": "Types of Sawm Beyond Ramadan",
      "words": [
        "kaffarah",
        "qada",
        "nadhr",
        "tatawwu"
      ],
      "difficulty": 3
    },
    {
      "category": "Sub-disciplines of Hadith Science",
      "words": [
        "dirayah",
        "riwayah",
        "jarh",
        "tadil"
      ],
      "difficulty": 4
    }
  ],
  "2026-05-10":   [
    {
      "category": "Forms of Islamic Supplication",
      "words": [
        "masalah",
        "shukr",
        "tawbah",
        "thana"
      ],
      "difficulty": 1,
      "hint": "Different purposes for which a Muslim makes dua"
    },
    {
      "category": "Components of the Salah",
      "words": [
        "iqamah",
        "qiraah",
        "ruku",
        "sujud"
      ],
      "difficulty": 2
    },
    {
      "category": "Classical Scholars of Aqeedah",
      "words": [
        "wasiti",
        "tahawi",
        "bayjuri",
        "laqqani"
      ],
      "difficulty": 3
    },
    {
      "category": "Legal Effects of Sharia Rulings",
      "words": [
        "wujub",
        "tahrim",
        "nadb",
        "ibahah"
      ],
      "difficulty": 4
    }
  ],
  "2026-05-09":   [
    {
      "category": "Etiquette of Quran Recitation",
      "words": [
        "taawwudh",
        "tartil",
        "wuquf",
        "tabayyun"
      ],
      "difficulty": 1,
      "hint": "Recommended practices observed while reciting the Quran"
    },
    {
      "category": "Ribawi Commodities in Classical Fiqh",
      "words": [
        "dhahab",
        "fidda",
        "burr",
        "tamr"
      ],
      "difficulty": 2
    },
    {
      "category": "Dimensions of the Qurans Inimitability",
      "words": [
        "balaghah",
        "tashri",
        "ilmi",
        "khabari"
      ],
      "difficulty": 3
    },
    {
      "category": "Levels of Maqasid al-Shariah",
      "words": [
        "daruriyyat",
        "hajiyyat",
        "tahsiniyyat",
        "kulliyyat"
      ],
      "difficulty": 4
    }
  ],
  "2026-05-08":   [
    {
      "category": "Months in the Islamic Calendar",
      "words": [
        "safar",
        "shawwal",
        "jumada",
        "rabic"
      ],
      "difficulty": 1,
      "hint": "Names from the Islamic lunar calendar"
    },
    {
      "category": "Categories of Water for Purification",
      "words": [
        "mutlaq",
        "mustamal",
        "mudaf",
        "najis"
      ],
      "difficulty": 2
    },
    {
      "category": "Islamic Finance Contracts",
      "words": [
        "musharakah",
        "murabahah",
        "ijarah",
        "wakalah"
      ],
      "difficulty": 3
    },
    {
      "category": "Technical Terms in Ilm al-Rijal",
      "words": [
        "thiqah",
        "sadduq",
        "daif",
        "matruk"
      ],
      "difficulty": 4
    }
  ],
  "2026-05-07":   [
    {
      "category": "Rituals Performed on the 10th of Dhul Hijjah",
      "words": [
        "rami",
        "nahr",
        "halq",
        "tawaf"
      ],
      "difficulty": 1,
      "hint": "Hajj acts carried out on the Day of Eid al-Adha"
    },
    {
      "category": "Sources of Marriage Prohibition",
      "words": [
        "nasab",
        "rada",
        "musahara",
        "shirk"
      ],
      "difficulty": 2
    },
    {
      "category": "Ranks in Islamic Legal Authority",
      "words": [
        "mujtahid",
        "mufti",
        "muqallid",
        "faqih"
      ],
      "difficulty": 3
    },
    {
      "category": "Types of Talaq",
      "words": [
        "sunni",
        "bidi",
        "raji",
        "bain"
      ],
      "difficulty": 4
    }
  ],
  "2026-05-06":   [
    {
      "category": "Four of the Six Pillars of Iman",
      "words": [
        "malaikah",
        "kutub",
        "rusul",
        "qadar"
      ],
      "difficulty": 1,
      "hint": "Articles of Islamic faith mentioned in the hadith of Jibril"
    },
    {
      "category": "Classification of Bidah in Scholarship",
      "words": [
        "hasanah",
        "sayyiah",
        "mubah",
        "wajibah"
      ],
      "difficulty": 2
    },
    {
      "category": "Types of Scholarly Ijazah",
      "words": [
        "mutlaqah",
        "muqayyadah",
        "mufahamah",
        "murattabah"
      ],
      "difficulty": 3
    },
    {
      "category": "Defects in Hadith Matn Criticism",
      "words": [
        "shadh",
        "munkar",
        "mudraj",
        "maqlub"
      ],
      "difficulty": 4
    }
  ],
  "2026-05-05":   [
    {
      "category": "Prophetic Manners When Eating",
      "words": [
        "tasmiyah",
        "yamin",
        "qasad",
        "hamd"
      ],
      "difficulty": 1,
      "hint": "Etiquette observed at mealtimes according to the Sunnah"
    },
    {
      "category": "Signs of Hypocrisy (Nifaq)",
      "words": [
        "kidhb",
        "khiyanah",
        "ikhlaf",
        "fujur"
      ],
      "difficulty": 2
    },
    {
      "category": "Conditions for Valid Waqf (Endowment)",
      "words": [
        "tabid",
        "ilzam",
        "qurbah",
        "ahliyyah"
      ],
      "difficulty": 3
    },
    {
      "category": "Advanced Usul al-Fiqh Principles",
      "words": [
        "istishab",
        "baraa",
        "istihsan",
        "darurah"
      ],
      "difficulty": 4
    }
  ],
  "2026-05-04":   [
    {
      "category": "Other Names of the Quran",
      "words": [
        "furqan",
        "dhikr",
        "kitab",
        "tanzil"
      ],
      "difficulty": 1,
      "hint": "Titles by which the Quran is referred to in Islamic sources"
    },
    {
      "category": "Types of Divine Communication (Wahy)",
      "words": [
        "ilham",
        "kashf",
        "ruya",
        "wahy"
      ],
      "difficulty": 2
    },
    {
      "category": "Things Allah Swears By in the Quran",
      "words": [
        "shams",
        "qamar",
        "fajr",
        "duha"
      ],
      "difficulty": 3
    },
    {
      "category": "Advanced Quran Sciences Terms",
      "words": [
        "tadabbur",
        "tawatur",
        "ijaz",
        "mushkil"
      ],
      "difficulty": 4
    }
  ],
  "2026-05-03":   [
    {
      "category": "Types of Charitable Transfer in Fiqh",
      "words": [
        "waqf",
        "wasiyyah",
        "hiba",
        "qard"
      ],
      "difficulty": 1,
      "hint": "Islamic ways of transferring wealth for good"
    },
    {
      "category": "Parts of the Masjid",
      "words": [
        "mihrab",
        "minbar",
        "maqsurah",
        "riwaq"
      ],
      "difficulty": 2
    },
    {
      "category": "Fixed Shares in Islamic Inheritance",
      "words": [
        "nisf",
        "rub",
        "thuluth",
        "thumn"
      ],
      "difficulty": 3
    },
    {
      "category": "Types of Bay (Sale) Contracts",
      "words": [
        "salam",
        "murabaha",
        "istisna",
        "musawama"
      ],
      "difficulty": 4
    }
  ],
  "2026-05-02":   [
    {
      "category": "Divine Attributes (Sifat) of Allah",
      "words": [
        "hayy",
        "alim",
        "qadir",
        "sami"
      ],
      "difficulty": 1,
      "hint": "Names describing Allah's eternal qualities"
    },
    {
      "category": "Prophets Featured in Quranic Stories",
      "words": [
        "yusuf",
        "musa",
        "ibrahim",
        "isa"
      ],
      "difficulty": 2
    },
    {
      "category": "Degrees of Recommended Acts",
      "words": [
        "fard",
        "wajib",
        "sunnah",
        "nafl"
      ],
      "difficulty": 3
    },
    {
      "category": "Theological Errors Refuted in Kalam",
      "words": [
        "hulul",
        "ittihad",
        "tajsim",
        "tashbih"
      ],
      "difficulty": 4
    }
  ],
  "2026-05-01":   [
    {
      "category": "Pillars of Hajj",
      "words": [
        "ihram",
        "wuquf",
        "tawaf",
        "saiy"
      ],
      "difficulty": 1,
      "hint": "Essential acts that make the pilgrimage valid"
    },
    {
      "category": "Types of Ritual Purification",
      "words": [
        "ghusl",
        "wudu",
        "tayammum",
        "istinja"
      ],
      "difficulty": 2
    },
    {
      "category": "Acts Forbidden During Ihram",
      "words": [
        "sayd",
        "tib",
        "nikah",
        "qass"
      ],
      "difficulty": 3
    },
    {
      "category": "Pillars of the Nikah Contract",
      "words": [
        "wali",
        "ijab",
        "qabul",
        "mahr"
      ],
      "difficulty": 4
    }
  ],
  "2026-04-30":   [
    {
      "category": "Titles of Prophet Muhammad",
      "words": [
        "mustafa",
        "ahmad",
        "mahmud",
        "amin"
      ],
      "difficulty": 1,
      "hint": "Honorific names given to the Prophet"
    },
    {
      "category": "Authors of the Six Major Hadith Collections",
      "words": [
        "bukhari",
        "muslim",
        "tirmidhi",
        "nasai"
      ],
      "difficulty": 2
    },
    {
      "category": "Types of Islamic Divorce",
      "words": [
        "talaq",
        "khul",
        "faskh",
        "mubarat"
      ],
      "difficulty": 3
    },
    {
      "category": "Theological Schools in Islamic Thought",
      "words": [
        "ashari",
        "maturidi",
        "mutazila",
        "salafi"
      ],
      "difficulty": 4
    }
  ],
  "2026-04-29":   [
    {
      "category": "Quranic Names for Paradise",
      "words": [
        "firdaus",
        "naim",
        "adn",
        "mawa"
      ],
      "difficulty": 1,
      "hint": "Terms in the Quran referring to the abodes of the righteous"
    },
    {
      "category": "Quranic Names for Hellfire",
      "words": [
        "jahannam",
        "saqar",
        "hutama",
        "laza"
      ],
      "difficulty": 2
    },
    {
      "category": "Islamic Months with Major Events",
      "words": [
        "muharram",
        "rajab",
        "shaban",
        "dhulhijja"
      ],
      "difficulty": 3
    },
    {
      "category": "Hadith Authenticity Grades",
      "words": [
        "mutawatir",
        "ahad",
        "mashhur",
        "gharib"
      ],
      "difficulty": 4
    }
  ],
  "2026-04-28":   [
    {
      "category": "Voluntary Prayer Types",
      "words": [
        "tahajjud",
        "duha",
        "tarawih",
        "witr"
      ],
      "difficulty": 1,
      "hint": "Optional prayers that earn extra reward"
    },
    {
      "category": "Maqasid al-Shariah Objectives",
      "words": [
        "nasl",
        "aql",
        "din",
        "mal"
      ],
      "difficulty": 2
    },
    {
      "category": "Tajweed Rules",
      "words": [
        "idgham",
        "ikhfa",
        "iqlab",
        "izhar"
      ],
      "difficulty": 3
    },
    {
      "category": "Maliki Usul Concepts",
      "words": [
        "masalih",
        "sadd",
        "istislah",
        "urf"
      ],
      "difficulty": 4
    }
  ],
  "2026-04-27":   [
    {
      "category": "Divisions of the Quran",
      "words": [
        "surah",
        "ayah",
        "juz",
        "manzil"
      ],
      "difficulty": 1,
      "hint": "Units used to structure the holy text"
    },
    {
      "category": "Named Angels in Islam",
      "words": [
        "jibril",
        "mikail",
        "israfil",
        "azrail"
      ],
      "difficulty": 2
    },
    {
      "category": "Stages of the Afterlife",
      "words": [
        "barzakh",
        "hashr",
        "sirat",
        "mizan"
      ],
      "difficulty": 3
    },
    {
      "category": "Arabic Rhetorical Devices in the Quran",
      "words": [
        "iltifat",
        "istifham",
        "istiara",
        "kinayah"
      ],
      "difficulty": 4
    }
  ],
  "2026-04-26":   [
    {
      "category": "Miqat Stations",
      "words": [
        "dhulhulaifah",
        "juhfah",
        "qarn",
        "yalamlam"
      ],
      "difficulty": 1,
      "hint": "Boundary points for entering ihram"
    },
    {
      "category": "Commercial Contract Flaws",
      "words": [
        "gharar",
        "riba",
        "najash",
        "ghabn"
      ],
      "difficulty": 2
    },
    {
      "category": "Usul Commands Analysis",
      "words": [
        "amr",
        "nahy",
        "fawr",
        "tarakhi"
      ],
      "difficulty": 3
    },
    {
      "category": "Tafsir Source Layers",
      "words": [
        "mathur",
        "ray",
        "lughah",
        "asbab"
      ],
      "difficulty": 4
    }
  ],
  "2026-04-25":   [
    {
      "category": "Madani Surahs",
      "words": [
        "baqarah",
        "nisa",
        "maidah",
        "nur"
      ],
      "difficulty": 1,
      "hint": "Surahs revealed after migration to Madinah"
    },
    {
      "category": "Marriage Contract Terms",
      "words": [
        "mahr",
        "wali",
        "shuhud",
        "sighah"
      ],
      "difficulty": 2
    },
    {
      "category": "Fiqh Maxims",
      "words": [
        "yaqin",
        "darar",
        "umur",
        "mashaqqah"
      ],
      "difficulty": 3
    },
    {
      "category": "Quranic Pause Signs",
      "words": [
        "lazim",
        "jaiz",
        "mamnu",
        "saktah"
      ],
      "difficulty": 4
    }
  ],
  "2026-04-24":   [
    {
      "category": "Hadith Compilers",
      "words": [
        "bukhari",
        "muslim",
        "tirmidhi",
        "nasai"
      ],
      "difficulty": 1,
      "hint": "Compilers of major Sunni hadith books"
    },
    {
      "category": "Zakah Recipients",
      "words": [
        "fuqara",
        "masakin",
        "gharimin",
        "ibnsabil"
      ],
      "difficulty": 2
    },
    {
      "category": "Hadith Defect Terms",
      "words": [
        "illah",
        "shudhudh",
        "idtirab",
        "inqita"
      ],
      "difficulty": 3
    },
    {
      "category": "Inheritance Blocking Terms",
      "words": [
        "hajb",
        "hirman",
        "nuqsan",
        "asabah"
      ],
      "difficulty": 4
    }
  ],
  "2026-04-23":   [
    {
      "category": "Major Battle Sites",
      "words": [
        "badr",
        "uhud",
        "khandaq",
        "hunayn"
      ],
      "difficulty": 1,
      "hint": "Locations of key battles in the prophetic era"
    },
    {
      "category": "Hajj Obligations",
      "words": [
        "ihram",
        "arafah",
        "tawaf",
        "sai"
      ],
      "difficulty": 2
    },
    {
      "category": "Hadith Authenticity Ranks",
      "words": [
        "sahih",
        "hasan",
        "daif",
        "mawdu"
      ],
      "difficulty": 3
    },
    {
      "category": "Narrator Critique Labels",
      "words": [
        "thiqa",
        "saduq",
        "matruk",
        "majhul"
      ],
      "difficulty": 4
    }
  ],
  "2026-04-22":   [
    {
      "category": "Ulul Azm Prophets",
      "words": [
        "nuh",
        "ibrahim",
        "musa",
        "isa"
      ],
      "difficulty": 1,
      "hint": "Prophets singled out for great resolve"
    },
    {
      "category": "Wudu Nullifiers",
      "words": [
        "nawm",
        "ghait",
        "bawl",
        "rih"
      ],
      "difficulty": 2
    },
    {
      "category": "Usul Language Categories",
      "words": [
        "aam",
        "khaas",
        "mutlaq",
        "muqayyad"
      ],
      "difficulty": 3
    },
    {
      "category": "Qiraat Technicals",
      "words": [
        "sakt",
        "ishmam",
        "imalah",
        "tashil"
      ],
      "difficulty": 4
    }
  ],
  "2026-04-21":   [
    {
      "category": "Rashidun Caliphs",
      "words": [
        "abubakr",
        "umar",
        "uthman",
        "ali"
      ],
      "difficulty": 1,
      "hint": "Leaders known as the rightly guided caliphs"
    },
    {
      "category": "Tayammum Elements",
      "words": [
        "turab",
        "masah",
        "yadayn",
        "qasd"
      ],
      "difficulty": 2
    },
    {
      "category": "Hadith Reception Modes",
      "words": [
        "sama",
        "qiraah",
        "ijazah",
        "munawalah"
      ],
      "difficulty": 3
    },
    {
      "category": "Usul Semantic Boundaries",
      "words": [
        "mujmal",
        "mubayyan",
        "mantuq",
        "mafhum"
      ],
      "difficulty": 4
    }
  ],
  "2026-04-20":   [
    {
      "category": "Great Mosques",
      "words": [
        "haram",
        "nabawi",
        "aqsa",
        "quba"
      ],
      "difficulty": 1,
      "hint": "Mosques with central status in Islamic history"
    },
    {
      "category": "Prayer Preconditions",
      "words": [
        "taharah",
        "niyyah",
        "qiblah",
        "waqt"
      ],
      "difficulty": 2
    },
    {
      "category": "Balaghah Sciences",
      "words": [
        "maani",
        "bayan",
        "badi",
        "ijaz"
      ],
      "difficulty": 3
    },
    {
      "category": "Qiraat Morphological Variants",
      "words": [
        "ifrad",
        "jam",
        "tadhkir",
        "tanith"
      ],
      "difficulty": 4
    }
  ],
  "2026-04-19":   [
    {
      "category": "Sunni Law Schools",
      "words": [
        "hanafi",
        "maliki",
        "shafii",
        "hanbali"
      ],
      "difficulty": 1,
      "hint": "Major madhhabs in Sunni legal tradition"
    },
    {
      "category": "Legal Value Terms",
      "words": [
        "fardh",
        "wajib",
        "sunnah",
        "mubah"
      ],
      "difficulty": 2
    },
    {
      "category": "Usul Evidence Types",
      "words": [
        "istishab",
        "istihsan",
        "ijma",
        "qiyas"
      ],
      "difficulty": 3
    },
    {
      "category": "Arabic Syntax Governance",
      "words": [
        "amil",
        "mamool",
        "taalluq",
        "taqdim"
      ],
      "difficulty": 4
    }
  ],
  "2026-04-18":   [
    {
      "category": "Sacred Months",
      "words": [
        "muharram",
        "rajab",
        "dhulqadah",
        "dhulhijjah"
      ],
      "difficulty": 1,
      "hint": "Months traditionally treated as inviolable"
    },
    {
      "category": "Friday Sermon Elements",
      "words": [
        "khutbah",
        "hamd",
        "salawat",
        "wasiyyah"
      ],
      "difficulty": 2
    },
    {
      "category": "Hadith Chain Gaps",
      "words": [
        "mursal",
        "munqati",
        "muallaq",
        "mudallas"
      ],
      "difficulty": 3
    },
    {
      "category": "Hadith Terminology Depth",
      "words": [
        "munkar",
        "mahfuz",
        "muallal",
        "maqbul"
      ],
      "difficulty": 4
    }
  ],
  "2026-04-17":   [
    {
      "category": "Pillars of Islam",
      "words": [
        "shahada",
        "salah",
        "zakah",
        "sawm"
      ],
      "difficulty": 1,
      "hint": "Core obligations that structure Muslim worship"
    },
    {
      "category": "Financial Ethics Terms",
      "words": [
        "amanah",
        "adl",
        "ihsan",
        "wafa"
      ],
      "difficulty": 2
    },
    {
      "category": "Usul Legal Capacity Terms",
      "words": [
        "ahliyah",
        "taklif",
        "bulugh",
        "rushd"
      ],
      "difficulty": 3
    },
    {
      "category": "Qiraat Pronunciation Cases",
      "words": [
        "ibdal",
        "naql",
        "silah",
        "taqlil"
      ],
      "difficulty": 4
    }
  ],
  "2026-04-16":   [
    {
      "category": "Companions at Badr",
      "words": [
        "miqdad",
        "ubaydah",
        "zubayr",
        "bilal"
      ],
      "difficulty": 1,
      "hint": "Companions present at the battle of badr"
    },
    {
      "category": "Risk Sharing Contracts",
      "words": [
        "mudarabah",
        "musharakah",
        "wakalah",
        "jualah"
      ],
      "difficulty": 2
    },
    {
      "category": "Aqidah Evidence Modes",
      "words": [
        "naqli",
        "aqli",
        "fitri",
        "hissi"
      ],
      "difficulty": 3
    },
    {
      "category": "Hadith Collection Metadata",
      "words": [
        "tabaqat",
        "fahrasah",
        "mustakhraj",
        "mustadrak"
      ],
      "difficulty": 4
    }
  ],
  "2026-04-15":   [
    {
      "category": "Maqam in Tilawah",
      "words": [
        "bayat",
        "hijaz",
        "saba",
        "rast"
      ],
      "difficulty": 1,
      "hint": "Melodic modes often used in recitation"
    },
    {
      "category": "Pilgrim Garment Terms",
      "words": [
        "rida",
        "izar",
        "nalin",
        "idtiba"
      ],
      "difficulty": 2
    },
    {
      "category": "Tafsir Legal Extraction",
      "words": [
        "ahkam",
        "istinbat",
        "takhrij",
        "tawjih"
      ],
      "difficulty": 3
    },
    {
      "category": "Arabic Semantics Layers",
      "words": [
        "mutabaqah",
        "tadammun",
        "iltizam",
        "mafhum"
      ],
      "difficulty": 4
    }
  ],
  "2026-04-14":   [
    {
      "category": "Great Hadith Imams",
      "words": [
        "ahmad",
        "darimi",
        "ibnmajah",
        "abudawud"
      ],
      "difficulty": 1,
      "hint": "Major hadith authorities and compilers"
    },
    {
      "category": "Charity Distribution Terms",
      "words": [
        "tamlik",
        "qurbah",
        "nisab",
        "hawl"
      ],
      "difficulty": 2
    },
    {
      "category": "Hadith Classification Breadth",
      "words": [
        "mutawatir",
        "mashhur",
        "aziz",
        "ahad"
      ],
      "difficulty": 3
    },
    {
      "category": "Hadith Isnad Elevation",
      "words": [
        "nazil",
        "musawat",
        "mushafahah",
        "mudhakarah"
      ],
      "difficulty": 4
    }
  ],
  "2026-04-13":   [
    {
      "category": "Sources of Law",
      "words": [
        "quran",
        "sunnah",
        "ijma",
        "qiyas"
      ],
      "difficulty": 1,
      "hint": "Core sources used for deriving rulings"
    },
    {
      "category": "Judicial Procedure Terms",
      "words": [
        "qadi",
        "bayyinah",
        "yamin",
        "iqrar"
      ],
      "difficulty": 2
    },
    {
      "category": "Qawaid Juristic Scope",
      "words": [
        "kulli",
        "aghlab",
        "mustathna",
        "takhsis"
      ],
      "difficulty": 3
    },
    {
      "category": "Quranic Coherence Terms",
      "words": [
        "siyag",
        "nazm",
        "munasabah",
        "fasilah"
      ],
      "difficulty": 4
    }
  ],
  "2026-04-12":   [
    {
      "category": "Women Hadith Scholars",
      "words": [
        "karimah",
        "amah",
        "shuhdah",
        "zaynab"
      ],
      "difficulty": 1,
      "hint": "Women known for hadith transmission and teaching"
    },
    {
      "category": "Family Law Finance",
      "words": [
        "nafaqah",
        "mutah",
        "khul",
        "mithl"
      ],
      "difficulty": 2
    },
    {
      "category": "Usul Speech Acts",
      "words": [
        "khabar",
        "insha",
        "haqiqah",
        "majaz"
      ],
      "difficulty": 3
    },
    {
      "category": "Hadith Route Mapping",
      "words": [
        "muqrin",
        "musalsal",
        "afrad",
        "aali"
      ],
      "difficulty": 4
    }
  ],
  "2026-04-11":   [
    {
      "category": "Famous Qaris",
      "words": [
        "minshawi",
        "husary",
        "abdulbasit",
        "shuraim"
      ],
      "difficulty": 1,
      "hint": "Renowned reciters of the Quran"
    },
    {
      "category": "Fasting Exemptions",
      "words": [
        "marid",
        "musafir",
        "hamil",
        "murdi"
      ],
      "difficulty": 2
    },
    {
      "category": "Quran Sciences Topics",
      "words": [
        "makkiyat",
        "madaniyat",
        "nasikh",
        "mansukh"
      ],
      "difficulty": 3
    },
    {
      "category": "Quranic Variant Study",
      "words": [
        "ahruf",
        "wujuh",
        "sabaq",
        "lahq"
      ],
      "difficulty": 4
    }
  ],
  "2026-04-10":   [
    {
      "category": "Names of the Quran",
      "words": [
        "furqan",
        "kitab",
        "dhikr",
        "huda"
      ],
      "difficulty": 1,
      "hint": "Titles used in revelation for the Quran"
    },
    {
      "category": "Witness Procedure Terms",
      "words": [
        "shahadah",
        "tazkiyah",
        "jarh",
        "rujoo"
      ],
      "difficulty": 2
    },
    {
      "category": "Usul Text Clarity Levels",
      "words": [
        "zahir",
        "nass",
        "mufassar",
        "muhkam"
      ],
      "difficulty": 3
    },
    {
      "category": "Arabic Eloquence Faults",
      "words": [
        "taqid",
        "hushw",
        "tanafir",
        "takalluf"
      ],
      "difficulty": 4
    }
  ],
  "2026-04-09":   [
    {
      "category": "Historic Islamic Cities",
      "words": [
        "kufah",
        "basrah",
        "dimashq",
        "qayrawan"
      ],
      "difficulty": 1,
      "hint": "Early centers of scholarship and governance"
    },
    {
      "category": "Loan Contract Terms",
      "words": [
        "qard",
        "rahn",
        "kafalah",
        "hawalah"
      ],
      "difficulty": 2
    },
    {
      "category": "Hadith Book Components",
      "words": [
        "bab",
        "kitab",
        "sanad",
        "matn"
      ],
      "difficulty": 3
    },
    {
      "category": "Mantiq Borrowed Terms",
      "words": [
        "tasawwur",
        "tasdiq",
        "burhan",
        "qadiyyah"
      ],
      "difficulty": 4
    }
  ],
  "2026-04-08":   [
    {
      "category": "Noted Mufassirun",
      "words": [
        "tabari",
        "qurtubi",
        "razi",
        "ibnkathir"
      ],
      "difficulty": 1,
      "hint": "Influential Quran commentators"
    },
    {
      "category": "Hudud Crime Labels",
      "words": [
        "sariqah",
        "hirabah",
        "qadhf",
        "zina"
      ],
      "difficulty": 2
    },
    {
      "category": "Usul Indication Types",
      "words": [
        "ibarah",
        "isharah",
        "dalalah",
        "iqtida"
      ],
      "difficulty": 3
    },
    {
      "category": "Qiraat Articulation Terms",
      "words": [
        "tahqiq",
        "tarqiq",
        "tafkhim",
        "tadwir"
      ],
      "difficulty": 4
    }
  ],
  "2026-04-07":   [
    {
      "category": "Daily Prayers",
      "words": [
        "subh",
        "zuhr",
        "asr",
        "isha"
      ],
      "difficulty": 1,
      "hint": "Names of obligatory daily prayer times"
    },
    {
      "category": "Funeral Prayer Elements",
      "words": [
        "takbirat",
        "dua",
        "qiyam",
        "taslim"
      ],
      "difficulty": 2
    },
    {
      "category": "Quran Preservation Terms",
      "words": [
        "hifz",
        "mushaf",
        "ardah",
        "jam"
      ],
      "difficulty": 3
    },
    {
      "category": "Hadith Comparative Critique",
      "words": [
        "mutabaah",
        "shawahid",
        "ittifaq",
        "ikhtilaf"
      ],
      "difficulty": 4
    }
  ],
  "2026-04-06":   [
    {
      "category": "Meccan Valleys",
      "words": [
        "batha",
        "muhassar",
        "aqiq",
        "namirah"
      ],
      "difficulty": 1,
      "hint": "Valleys tied to sacred geography and rites"
    },
    {
      "category": "Trading Contract Types",
      "words": [
        "murabaha",
        "salam",
        "istisna",
        "ijarah"
      ],
      "difficulty": 2
    },
    {
      "category": "Hadith Narrative Forms",
      "words": [
        "marfu",
        "mawquf",
        "maqtu",
        "athar"
      ],
      "difficulty": 3
    },
    {
      "category": "Advanced Nahw Concepts",
      "words": [
        "irab",
        "bina",
        "tamyiz",
        "hal"
      ],
      "difficulty": 4
    }
  ],
  "2026-04-05":   [
    {
      "category": "Hijrah Locales",
      "words": [
        "makkah",
        "thawr",
        "quba",
        "madinah"
      ],
      "difficulty": 1,
      "hint": "Places linked to the migration journey"
    },
    {
      "category": "Pilgrimage Violations",
      "words": [
        "fidyah",
        "dam",
        "jidal",
        "fusuq"
      ],
      "difficulty": 2
    },
    {
      "category": "Hadith Acceptance Conditions",
      "words": [
        "adalah",
        "dabt",
        "ittisal",
        "salamah"
      ],
      "difficulty": 3
    },
    {
      "category": "Usul Contradiction Handling",
      "words": [
        "jam",
        "tarjih",
        "naskh",
        "tawaqquf"
      ],
      "difficulty": 4
    }
  ],
  "2026-04-04":   [
    {
      "category": "Prophetic Household",
      "words": [
        "khadijah",
        "aishah",
        "fatimah",
        "hasan"
      ],
      "difficulty": 1,
      "hint": "Family members tied closely to the Prophet"
    },
    {
      "category": "Inheritance Share Terms",
      "words": [
        "sudus",
        "rub",
        "thuluth",
        "nisf"
      ],
      "difficulty": 2
    },
    {
      "category": "Arabic Case Endings",
      "words": [
        "raf",
        "nasb",
        "jarr",
        "jazm"
      ],
      "difficulty": 3
    },
    {
      "category": "Qiraat Chains",
      "words": [
        "rawi",
        "tariq",
        "wajh",
        "isnad"
      ],
      "difficulty": 4
    }
  ],
  "2026-04-03":   [
    {
      "category": "Articles of Faith",
      "words": [
        "allah",
        "malaikah",
        "kutub",
        "rusul"
      ],
      "difficulty": 1,
      "hint": "Beliefs listed in hadith of jibril"
    },
    {
      "category": "Endowment Terms",
      "words": [
        "waqf",
        "nazir",
        "mawquf",
        "istibdal"
      ],
      "difficulty": 2
    },
    {
      "category": "Usul Consensus Types",
      "words": [
        "sarih",
        "sukuti",
        "qati",
        "zanni"
      ],
      "difficulty": 3
    },
    {
      "category": "Hadith Narration Faults",
      "words": [
        "idraj",
        "qalb",
        "tasif",
        "tashif"
      ],
      "difficulty": 4
    }
  ],
  "2026-04-02":   [
    {
      "category": "Quranic Oaths",
      "words": [
        "tin",
        "asr",
        "duha",
        "fajr"
      ],
      "difficulty": 1,
      "hint": "Created signs invoked in Quranic oaths"
    },
    {
      "category": "Oath Expiation Options",
      "words": [
        "itam",
        "kiswah",
        "tahrir",
        "siyam"
      ],
      "difficulty": 2
    },
    {
      "category": "Hadith Book Arrangement",
      "words": [
        "musnad",
        "sunan",
        "jami",
        "muwatta"
      ],
      "difficulty": 3
    },
    {
      "category": "Arabic Rhetoric Devices",
      "words": [
        "tibaq",
        "jinas",
        "iltifat",
        "tawriyah"
      ],
      "difficulty": 4
    }
  ],
  "2026-04-01":   [
    {
      "category": "Miqat Stations",
      "words": [
        "dhulhulaifah",
        "juhfah",
        "qarn",
        "yalamlam"
      ],
      "difficulty": 1,
      "hint": "Boundary points for entering ihram"
    },
    {
      "category": "Waiting Period Terms",
      "words": [
        "quru",
        "wada",
        "haml",
        "ashhur"
      ],
      "difficulty": 2
    },
    {
      "category": "Tafsir Method Labels",
      "words": [
        "tahlili",
        "mawdui",
        "muqaran",
        "ijmali"
      ],
      "difficulty": 3
    },
    {
      "category": "Ilm Kalam Terms",
      "words": [
        "jauhar",
        "arad",
        "huduth",
        "qidam"
      ],
      "difficulty": 4
    }
  ],
  "2026-03-31":   [
    {
      "category": "Madani Surahs",
      "words": [
        "baqarah",
        "nisa",
        "maidah",
        "nur"
      ],
      "difficulty": 1,
      "hint": "Surahs revealed after migration to Madinah"
    },
    {
      "category": "Purification Categories",
      "words": [
        "hadath",
        "khabath",
        "najasah",
        "tahir"
      ],
      "difficulty": 2
    },
    {
      "category": "Usul Commands Analysis",
      "words": [
        "amr",
        "nahy",
        "fawr",
        "tarakhi"
      ],
      "difficulty": 3
    },
    {
      "category": "Quran Orthography Terms",
      "words": [
        "rasm",
        "dabt",
        "naqt",
        "fawasil"
      ],
      "difficulty": 4
    }
  ],
  "2026-03-30":   [
    {
      "category": "Hadith Compilers",
      "words": [
        "bukhari",
        "muslim",
        "tirmidhi",
        "nasai"
      ],
      "difficulty": 1,
      "hint": "Compilers of major Sunni hadith books"
    },
    {
      "category": "Commercial Contract Flaws",
      "words": [
        "gharar",
        "riba",
        "najash",
        "ghabn"
      ],
      "difficulty": 2
    },
    {
      "category": "Fiqh Maxims",
      "words": [
        "yaqin",
        "darar",
        "umur",
        "mashaqqah"
      ],
      "difficulty": 3
    },
    {
      "category": "Advanced Tajwid Traits",
      "words": [
        "hams",
        "jahr",
        "istiila",
        "istifal"
      ],
      "difficulty": 4
    }
  ],
  "2026-03-29":   [
    {
      "category": "Major Battle Sites",
      "words": [
        "badr",
        "uhud",
        "khandaq",
        "hunayn"
      ],
      "difficulty": 1,
      "hint": "Locations of key battles in the prophetic era"
    },
    {
      "category": "Marriage Contract Terms",
      "words": [
        "mahr",
        "wali",
        "shuhud",
        "sighah"
      ],
      "difficulty": 2
    },
    {
      "category": "Hadith Defect Terms",
      "words": [
        "illah",
        "shudhudh",
        "idtirab",
        "inqita"
      ],
      "difficulty": 3
    },
    {
      "category": "Quranic Reading Schools",
      "words": [
        "nafi",
        "asim",
        "hamzah",
        "kisai"
      ],
      "difficulty": 4
    }
  ],
  "2026-03-28":   [
    {
      "category": "Ulul Azm Prophets",
      "words": [
        "nuh",
        "ibrahim",
        "musa",
        "isa"
      ],
      "difficulty": 1,
      "hint": "Prophets singled out for great resolve"
    },
    {
      "category": "Zakah Recipients",
      "words": [
        "fuqara",
        "masakin",
        "gharimin",
        "ibnsabil"
      ],
      "difficulty": 2
    },
    {
      "category": "Hadith Authenticity Ranks",
      "words": [
        "sahih",
        "hasan",
        "daif",
        "mawdu"
      ],
      "difficulty": 3
    },
    {
      "category": "Arabic Morphology Patterns",
      "words": [
        "mujarrad",
        "mazid",
        "iallal",
        "idgham"
      ],
      "difficulty": 4
    }
  ],
  "2026-03-27":   [
    {
      "category": "Rashidun Caliphs",
      "words": [
        "abubakr",
        "umar",
        "uthman",
        "ali"
      ],
      "difficulty": 1,
      "hint": "Leaders known as the rightly guided caliphs"
    },
    {
      "category": "Hajj Obligations",
      "words": [
        "ihram",
        "arafah",
        "tawaf",
        "sai"
      ],
      "difficulty": 2
    },
    {
      "category": "Usul Language Categories",
      "words": [
        "aam",
        "khaas",
        "mutlaq",
        "muqayyad"
      ],
      "difficulty": 3
    },
    {
      "category": "Tafsir Source Layers",
      "words": [
        "mathur",
        "ray",
        "lughah",
        "asbab"
      ],
      "difficulty": 4
    }
  ],
  "2026-03-26":   [
    {
      "category": "Great Mosques",
      "words": [
        "haram",
        "nabawi",
        "aqsa",
        "quba"
      ],
      "difficulty": 1,
      "hint": "Mosques with central status in Islamic history"
    },
    {
      "category": "Wudu Nullifiers",
      "words": [
        "nawm",
        "ghait",
        "bawl",
        "rih"
      ],
      "difficulty": 2
    },
    {
      "category": "Hadith Reception Modes",
      "words": [
        "sama",
        "qiraah",
        "ijazah",
        "munawalah"
      ],
      "difficulty": 3
    },
    {
      "category": "Quranic Pause Signs",
      "words": [
        "lazim",
        "jaiz",
        "mamnu",
        "saktah"
      ],
      "difficulty": 4
    }
  ],
  "2026-03-25":   [
    {
      "category": "Sunni Law Schools",
      "words": [
        "hanafi",
        "maliki",
        "shafii",
        "hanbali"
      ],
      "difficulty": 1,
      "hint": "Major madhhabs in Sunni legal tradition"
    },
    {
      "category": "Tayammum Elements",
      "words": [
        "turab",
        "masah",
        "yadayn",
        "qasd"
      ],
      "difficulty": 2
    },
    {
      "category": "Balaghah Sciences",
      "words": [
        "maani",
        "bayan",
        "badi",
        "ijaz"
      ],
      "difficulty": 3
    },
    {
      "category": "Inheritance Blocking Terms",
      "words": [
        "hajb",
        "hirman",
        "nuqsan",
        "asabah"
      ],
      "difficulty": 4
    }
  ],
  "2026-03-24":   [
    {
      "category": "Sacred Months",
      "words": [
        "muharram",
        "rajab",
        "dhulqadah",
        "dhulhijjah"
      ],
      "difficulty": 1,
      "hint": "Months traditionally treated as inviolable"
    },
    {
      "category": "Prayer Preconditions",
      "words": [
        "taharah",
        "niyyah",
        "qiblah",
        "waqt"
      ],
      "difficulty": 2
    },
    {
      "category": "Usul Evidence Types",
      "words": [
        "istishab",
        "istihsan",
        "ijma",
        "qiyas"
      ],
      "difficulty": 3
    },
    {
      "category": "Narrator Critique Labels",
      "words": [
        "thiqa",
        "saduq",
        "matruk",
        "majhul"
      ],
      "difficulty": 4
    }
  ],
  "2026-03-23":   [
    {
      "category": "Pillars of Islam",
      "words": [
        "shahada",
        "salah",
        "zakah",
        "sawm"
      ],
      "difficulty": 1,
      "hint": "Core obligations that structure Muslim worship"
    },
    {
      "category": "Legal Value Terms",
      "words": [
        "fardh",
        "wajib",
        "sunnah",
        "mubah"
      ],
      "difficulty": 2
    },
    {
      "category": "Hadith Chain Gaps",
      "words": [
        "mursal",
        "munqati",
        "muallaq",
        "mudallas"
      ],
      "difficulty": 3
    },
    {
      "category": "Qiraat Technicals",
      "words": [
        "sakt",
        "ishmam",
        "imalah",
        "tashil"
      ],
      "difficulty": 4
    }
  ],
    "2026-03-22": [
      {
        "category": "Quranic Oaths",
        "words": ["Tin", "Asr", "Duha", "Fajr"],
        "difficulty": 1,
        "hint": "Created things Allah swears by in the Quran"
      },
      {
        "category": "Hadith Acceptance Terms",
        "words": ["Sahih", "Hasan", "Daif", "Mawdu"],
        "difficulty": 2
      },
      {
        "category": "Usul Al-Fiqh",
        "words": ["Amr", "Nahy", "Aam", "Khaas"],
        "difficulty": 3
      },
      {
        "category": "Qiraat Vocabulary",
        "words": ["Idgham", "Iqlab", "Ishmam", "Imalah"],
        "difficulty": 4
      }
    ],
    "2026-03-21": [
      {
        "category": "Madinah Locales",
        "words": ["Quba", "Baqi", "Uhud", "Rawdah"],
        "difficulty": 1,
        "hint": "Landmarks connected to the Prophet's city"
      },
      {
        "category": "Inheritance Terms",
        "words": ["Asabah", "Fardh", "Hajb", "Awl"],
        "difficulty": 2
      },
      {
        "category": "Hadith Narrator Critique",
        "words": ["Thiqa", "Saduq", "Matruk", "Majhul"],
        "difficulty": 3
      },
      {
        "category": "Arabic Grammar Labels",
        "words": ["Marfu", "Mansub", "Majrur", "Majzum"],
        "difficulty": 4
      }
    ],
    "2026-03-20": [
      {
        "category": "Battle Year Labels",
        "words": ["Badr", "Uhud", "Ahzab", "Hunayn"],
        "difficulty": 1,
        "hint": "Major expeditions from the Prophetic era"
      },
      {
        "category": "Quranic Story Names",
        "words": ["Kahf", "Yasin", "Yusuf", "Maryam"],
        "difficulty": 2
      },
      {
        "category": "Legal Maxims",
        "words": ["Yaqin", "Darar", "Mashaqqah", "Urf"],
        "difficulty": 3
      },
      {
        "category": "Hadith Collection Terms",
        "words": ["Musnad", "Muwatta", "Sunan", "Mustadrak"],
        "difficulty": 4
      }
    ],
    "2026-03-19": [
      {
        "category": "Sunnah Fasts",
        "words": ["Arafah", "Ashura", "AyyamBid", "Shawwal6"],
        "difficulty": 1,
        "hint": "Voluntary fasting occasions"
      },
      {
        "category": "Tajwid Rules",
        "words": ["Ghunnah", "Qalqalah", "Madd", "Ikhfa"],
        "difficulty": 2
      },
      {
        "category": "Seerah Covenants",
        "words": ["Aqabah1", "Aqabah2", "Hudaybiyyah", "MadinahCharter"],
        "difficulty": 3
      },
      {
        "category": "Ilm Al-Kalam Schools",
        "words": ["Maturidi", "Ashari", "Athari", "Mutazili"],
        "difficulty": 4
      }
    ],
    "2026-03-18": [
      {
        "category": "Quran Revelation Context",
        "words": ["Makki", "Madani", "Asbab", "Naskh"],
        "difficulty": 1,
        "hint": "Core terms for understanding revelation background"
      },
      {
        "category": "Prayer Integrals",
        "words": ["Niyyah", "Takbir", "Fatiha", "Tasleem"],
        "difficulty": 2
      },
      {
        "category": "Hadith Chain Terms",
        "words": ["Isnad", "Matan", "Ananah", "Ittisal"],
        "difficulty": 3
      },
      {
        "category": "Qiraat Imams",
        "words": ["Nafi", "Kathir", "Asim", "Kisai"],
        "difficulty": 4
      }
    ],
    "2026-03-17": [
      {
        "category": "Hajj Locations",
        "words": ["Mina", "Arafat", "Muzdalifah", "Jamrat"],
        "difficulty": 1,
        "hint": "Places visited in the Hajj sequence"
      },
      {
        "category": "Quranic Openings",
        "words": ["AlifLamMim", "HaMim", "Qaf", "Nun"],
        "difficulty": 2
      },
      {
        "category": "Fiqh Evidence Ranking",
        "words": ["Quran", "Sunnah", "Ijma", "Qiyas"],
        "difficulty": 3
      },
      {
        "category": "Rijal Terminology",
        "words": ["Jarh", "Tadil", "Ikhtilat", "Tadlees"],
        "difficulty": 4
      }
    ],
    "2026-03-16": [
      {
        "category": "Foundational Aqidah Terms",
        "words": ["Tawhid", "Rububiyyah", "Uluhiyyah", "AsmaSifat"],
        "difficulty": 1,
        "hint": "Belief structure terminology"
      },
      {
        "category": "Quranic Punishment Words",
        "words": ["Saqar", "Hutamah", "Laza", "Hawiyah"],
        "difficulty": 2
      },
      {
        "category": "Usul Conflicts",
        "words": ["Tarjih", "Jam", "Nasikh", "Mansukh"],
        "difficulty": 3
      },
      {
        "category": "Maqasid Categories",
        "words": ["Din", "Nafs", "Aql", "Nasl"],
        "difficulty": 4
      }
    ],
    "2026-03-15": [
      {
        "category": "Companion Titles",
        "words": ["Siddiq", "Faruq", "DhunNurayn", "Murtada"],
        "difficulty": 1,
        "hint": "Honorifics tied to major companions"
      },
      {
        "category": "Arabic Balaghah",
        "words": ["Bayan", "Maani", "Badi", "Iltifat"],
        "difficulty": 2
      },
      {
        "category": "Salah Mistake Terms",
        "words": ["Sahw", "Qada", "Iadah", "Jabr"],
        "difficulty": 3
      },
      {
        "category": "Hadith Defect Terms",
        "words": ["Shadh", "Munkar", "Mudtarib", "Muallal"],
        "difficulty": 4
      }
    ],
    "2026-03-14": [
      {
        "category": "Quranic People",
        "words": ["Luqman", "DhulQarnayn", "Talut", "Jalut"],
        "difficulty": 1,
        "hint": "Figures named in Quran narratives"
      },
      {
        "category": "Masjid Etiquettes",
        "words": ["Tahiyyah", "Sakinah", "Saff", "Khushu"],
        "difficulty": 2
      },
      {
        "category": "Fatwa Process Terms",
        "words": ["Nawazil", "Takhrij", "Tahqiq", "Tahrir"],
        "difficulty": 3
      },
      {
        "category": "Quran Counting Terms",
        "words": ["Ayah", "Juz", "Hizb", "RubHizb"],
        "difficulty": 4
      }
    ],
    "2026-03-13": [
      {
        "category": "Historic Mosques",
        "words": ["Quba", "Qiblatayn", "Nabawi", "Aqsa"],
        "difficulty": 1,
        "hint": "Early and sacred mosques"
      },
      {
        "category": "Nikah Conditions",
        "words": ["Wali", "Mahr", "Shahid", "IjabQabul"],
        "difficulty": 2
      },
      {
        "category": "Sarf Patterns",
        "words": ["Faala", "Yafalu", "Ifaal", "Tafaul"],
        "difficulty": 3
      },
      {
        "category": "Quranic Variant Reading Terms",
        "words": ["Harf", "Wajh", "Rawi", "Tariq"],
        "difficulty": 4
      }
    ],
    "2026-03-12": [
      {
        "category": "Ramadan Acts",
        "words": ["Qiyam", "Itikaf", "Tilawah", "Sadaqah"],
        "difficulty": 1,
        "hint": "Common worship in Ramadan"
      },
      {
        "category": "Fiqh Purity Terms",
        "words": ["Najasah", "Taharah", "Istihalah", "Mutanajjis"],
        "difficulty": 2
      },
      {
        "category": "Hadith Transmission Modes",
        "words": ["Samaa", "Qiraah", "Ijazah", "Munawalah"],
        "difficulty": 3
      },
      {
        "category": "Usul Inference Terms",
        "words": ["Dalalah", "Mafhum", "Manthuq", "Iqtida"],
        "difficulty": 4
      }
    ],
    "2026-03-11": [
      {
        "category": "Revealed Books",
        "words": ["Tawrah", "Zabur", "Injil", "Quran"],
        "difficulty": 1,
        "hint": "Scriptures acknowledged in Islam"
      },
      {
        "category": "Sujud Types",
        "words": ["Tilawah", "Shukr", "Salah", "Sahw"],
        "difficulty": 2
      },
      {
        "category": "Ijtihad Terms",
        "words": ["Qiyas", "Istihsan", "Istislah", "Istishab"],
        "difficulty": 3
      },
      {
        "category": "Hadith Compilation Eras",
        "words": ["Tadwin", "Tasnif", "Mustalah", "Takhrij"],
        "difficulty": 4
      }
    ],
    "2026-03-10": [
      {
        "category": "Pillars of Iman",
        "words": ["Allah", "Angels", "Books", "Messengers"],
        "difficulty": 1,
        "hint": "Core faith components"
      },
      {
        "category": "Quran Pause Marks",
        "words": ["Meem", "Jeem", "La", "Qaf"],
        "difficulty": 2
      },
      {
        "category": "Waqf Types",
        "words": ["Taam", "Kafi", "Hasan", "Qabih"],
        "difficulty": 3
      },
      {
        "category": "Maqasid Extensions",
        "words": ["Mal", "Ird", "Amn", "Hurriyyah"],
        "difficulty": 4
      }
    ],
    "2026-03-09": [
      {
        "category": "Seerah Phases",
        "words": ["Makkah", "Hijrah", "Madinah", "Fath"],
        "difficulty": 1,
        "hint": "Major timeline stages in the Prophetic mission"
      },
      {
        "category": "Fasting Breakers",
        "words": ["Akl", "Shurb", "Jima", "Hayd"],
        "difficulty": 2
      },
      {
        "category": "Hadith Collection Geography",
        "words": ["Rayy", "Kufah", "Basrah", "Nishapur"],
        "difficulty": 3
      },
      {
        "category": "Arabic Rhetoric Devices",
        "words": ["Tashbih", "Istiara", "Kinayah", "Majaz"],
        "difficulty": 4
      }
    ],
    "2026-03-08": [
      {
        "category": "Haram Boundaries",
        "words": ["Makkah", "Madinah", "Arafat", "Hill"],
        "difficulty": 1,
        "hint": "Sacred boundary context terms"
      },
      {
        "category": "Quranic River Names",
        "words": ["Kawthar", "Salsabil", "Tasnim", "Rahiq"],
        "difficulty": 2
      },
      {
        "category": "Fiqh Capacity Terms",
        "words": ["Baligh", "Aqil", "Mukallaf", "Mumayyiz"],
        "difficulty": 3
      },
      {
        "category": "Usul Command Nuances",
        "words": ["Wujub", "Nadb", "Ibaha", "Karahah"],
        "difficulty": 4
      }
    ],
    "2026-03-07": [
      {
        "category": "Sunan Abu Dawud Topics",
        "words": ["Taharah", "Salah", "Zakah", "Hajj"],
        "difficulty": 1,
        "hint": "Core chapter themes in hadith books"
      },
      {
        "category": "Quranic Dialogue Figures",
        "words": ["Musa", "Harun", "Firawn", "Samiri"],
        "difficulty": 2
      },
      {
        "category": "Hadith Route Terms",
        "words": ["Mutawatir", "Mashhur", "Aziz", "Gharib"],
        "difficulty": 3
      },
      {
        "category": "Advanced Tajwid",
        "words": ["Ishmam", "Sakt", "Naql", "Tashil"],
        "difficulty": 4
      }
    ],
    "2026-03-06": [
      {
        "category": "Adhkar Timing",
        "words": ["Sabah", "Masa", "Nawm", "Safar"],
        "difficulty": 1,
        "hint": "Common remembrance time contexts"
      },
      {
        "category": "Quranic Ethical Terms",
        "words": ["Birr", "Ihsan", "Adl", "Taqwa"],
        "difficulty": 2
      },
      {
        "category": "Zakat Asset Types",
        "words": ["Nuqud", "Anam", "Zurua", "Urud"],
        "difficulty": 3
      },
      {
        "category": "Quran Sciences",
        "words": ["Muhkam", "Mutashabih", "Mujmal", "Mubayyan"],
        "difficulty": 4
      }
    ],
    "2026-03-05": [
      {
        "category": "Women in Seerah",
        "words": ["Khadijah", "Aisha", "Sumayyah", "Nusaybah"],
        "difficulty": 1,
        "hint": "Prominent women in early Islam"
      },
      {
        "category": "Prayer Prohibitions",
        "words": ["Laughing", "Eating", "Talking", "Turning"],
        "difficulty": 2
      },
      {
        "category": "Ifta Roles",
        "words": ["Mufti", "Mustafti", "Qadi", "Muhtasib"],
        "difficulty": 3
      },
      {
        "category": "Hadith Text Issues",
        "words": ["Idraj", "Qalb", "Tasheef", "Tahrif"],
        "difficulty": 4
      }
    ],
    "2026-03-04": [
      {
        "category": "Quranic Family Terms",
        "words": ["Walid", "Umm", "Zawj", "Dhurriah"],
        "difficulty": 1,
        "hint": "Kinship language found in Quran"
      },
      {
        "category": "Masjid Functions",
        "words": ["Salah", "Ilm", "Shura", "Itiqaf"],
        "difficulty": 2
      },
      {
        "category": "Usul Debate Terms",
        "words": ["Illa", "Hikmah", "Sabab", "Shart"],
        "difficulty": 3
      },
      {
        "category": "Qiraat Narrators",
        "words": ["Warsh", "Qalun", "Hafs", "Shubah"],
        "difficulty": 4
      }
    ],
    "2026-03-03": [
      {
        "category": "Prophetic Occupations",
        "words": ["Shepherd", "Trader", "Judge", "Leader"],
        "difficulty": 1,
        "hint": "Roles embodied by prophets"
      },
      {
        "category": "Fasting Excuses",
        "words": ["Travel", "Illness", "Hayd", "Nifas"],
        "difficulty": 2
      },
      {
        "category": "Classical Tafsir Works",
        "words": ["Tabari", "Qurtubi", "Baghawi", "Kathir"],
        "difficulty": 3
      },
      {
        "category": "Linguistic Usul Terms",
        "words": ["Haqiqah", "Majaz", "Mushtarak", "Muradif"],
        "difficulty": 4
      }
    ],
    "2026-03-02": [
      {
        "category": "Hijri Calendar Markers",
        "words": ["Muharram", "Rajab", "Ramadan", "Dhulhijjah"],
        "difficulty": 1,
        "hint": "Notable months in the lunar year"
      },
      {
        "category": "Wudu Sunnahs",
        "words": ["Siwak", "Tasmiyah", "Muwalat", "Tathleeth"],
        "difficulty": 2
      },
      {
        "category": "Hadith Book Structures",
        "words": ["Kitab", "Bab", "Athar", "Tarjamah"],
        "difficulty": 3
      },
      {
        "category": "Advanced Faraid",
        "words": ["Kalalah", "Rad", "Munasakhah", "Tasheeh"],
        "difficulty": 4
      }
    ],
    "2026-03-01": [
      {
        "category": "Quranic Weather Signs",
        "words": ["Rain", "Wind", "Cloud", "Lightning"],
        "difficulty": 1,
        "hint": "Natural signs cited in the Quran"
      },
      {
        "category": "Salah Congregation Terms",
        "words": ["Imam", "Mamum", "Saff", "Iqamah"],
        "difficulty": 2
      },
      {
        "category": "Hadith Collection Methods",
        "words": ["Tasnif", "Jami", "Mustakhraj", "Ajza"],
        "difficulty": 3
      },
      {
        "category": "Quranic Coherence Terms",
        "words": ["Nazm", "Munasabah", "Siyak", "Sibaq"],
        "difficulty": 4
      }
    ],
    "2026-02-28": [
      {
        "category": "Righteous Caliphs",
        "words": ["Siddiq", "Umar", "Uthman", "Ali"],
        "difficulty": 1,
        "hint": "Leaders of the Rashidun era"
      },
      {
        "category": "Quranic Places",
        "words": ["Sinai", "Makkah", "Bakkah", "Arafat"],
        "difficulty": 2
      },
      {
        "category": "Waqf Ibtida Terms",
        "words": ["Waqf", "Ibtida", "Saktah", "Wasl"],
        "difficulty": 3
      },
      {
        "category": "Hadith Categorization Depth",
        "words": ["Marfu", "Mawquf", "Maqtu", "Mursal"],
        "difficulty": 4
      }
    ],
    "2026-02-27": [
      {
        "category": "Angels and Roles",
        "words": ["Jibreel", "Mikaeel", "Malik", "Ridwan"],
        "difficulty": 1,
        "hint": "Named angels in Islamic literature"
      },
      {
        "category": "Acts Nullifying Prayer",
        "words": ["Hadath", "Kalaam", "Qahqahah", "Inkishaf"],
        "difficulty": 2
      },
      {
        "category": "Legal Ruling Levels",
        "words": ["Fard", "Wajib", "Sunnah", "Mubah"],
        "difficulty": 3
      },
      {
        "category": "Variant Reading Chains",
        "words": ["Samman", "Azraq", "Duri", "Susi"],
        "difficulty": 4
      }
    ],
    "2026-02-26": [
      {
        "category": "Quranic Animal Mentions",
        "words": ["Naml", "Nahl", "Ankabut", "Fil"],
        "difficulty": 1,
        "hint": "Animals lending names to Quran chapters"
      },
      {
        "category": "Friday Essentials",
        "words": ["Ghusl", "Khutbah", "Jumuah", "Dua"],
        "difficulty": 2
      },
      {
        "category": "Ijtihad Qualification Terms",
        "words": ["Mujtahid", "Muqallid", "Muntasib", "Mutlaq"],
        "difficulty": 3
      },
      {
        "category": "Mustalah Hadith Core",
        "words": ["Mudallas", "Muallaq", "Munqati", "Mubham"],
        "difficulty": 4
      }
    ],
    "2026-02-25": [
      {
        "category": "Quranic Supplications",
        "words": ["Rabbana", "Hablana", "Ihdina", "Rabbi"],
        "difficulty": 1,
        "hint": "Frequent dua openings in Quran"
      },
      {
        "category": "Zakah Calculation Terms",
        "words": ["Nisab", "Haul", "Khultah", "Taqweem"],
        "difficulty": 2
      },
      {
        "category": "Seerah Tribal Names",
        "words": ["Quraysh", "Aws", "Khazraj", "Thaqif"],
        "difficulty": 3
      },
      {
        "category": "Usul Dalalah Types",
        "words": ["Ibarah", "Isharah", "Dalalah", "Iqtida"],
        "difficulty": 4
      }
    ],
    "2026-02-24": [
      {
        "category": "Well Known Sahabah",
        "words": ["Talhah", "Zubayr", "Bilal", "Salman"],
        "difficulty": 1,
        "hint": "Prominent companions beyond the caliphs"
      },
      {
        "category": "Quran Recitation Etiquette",
        "words": ["Tartil", "Tadabbur", "Taawwudh", "Basmalah"],
        "difficulty": 2
      },
      {
        "category": "Faraid Fraction Terms",
        "words": ["Nisf", "Rub", "Thuluth", "Sudus"],
        "difficulty": 3
      },
      {
        "category": "Ilal Detection Concepts",
        "words": ["Qarinah", "Mukhalafah", "Tafarrud", "Ikhtilaf"],
        "difficulty": 4
      }
    ],
    "2026-02-23": [
      {
        "category": "Quranic Punishment Vocabulary",
        "words": ["Adhab", "Naar", "Jaheem", "Saeir"],
        "difficulty": 1,
        "hint": "Words tied to warning passages"
      },
      {
        "category": "Taharah Water Types",
        "words": ["Mutlaq", "Mustamal", "Najis", "Kur"],
        "difficulty": 2
      },
      {
        "category": "Hadith Writing Genres",
        "words": ["Arbain", "Amali", "Mashyakhah", "Fawaid"],
        "difficulty": 3
      },
      {
        "category": "Arabic Morphology Labels",
        "words": ["Sahih", "Muallal", "Mithal", "Ajwaf"],
        "difficulty": 4
      }
    ],
    "2026-02-22": [
      {
        "category": "Seerah Events",
        "words": ["Hijrah", "Isra", "Miraj", "Fath"],
        "difficulty": 1,
        "hint": "Major events in the Prophet's life"
      },
      {
        "category": "Quranic Reading Speeds",
        "words": ["Tahqiq", "Tadwir", "Hadr", "Tartil"],
        "difficulty": 2
      },
      {
        "category": "Legal Capacity Defects",
        "words": ["Sighar", "Junun", "Safah", "Ikrah"],
        "difficulty": 3
      },
      {
        "category": "Hadith Terminology Precision",
        "words": ["Mudabbaj", "Musalsal", "Muannan", "Mushafahah"],
        "difficulty": 4
      }
    ],
    "2026-02-21": [
      {
        "category": "Islamic Creed Basics",
        "words": ["Iman", "Islam", "Ihsan", "Yaqin"],
        "difficulty": 1,
        "hint": "Foundational spiritual categories"
      },
      {
        "category": "Prayer Internal States",
        "words": ["Khushu", "Hudur", "Tumaninah", "Ikhlas"],
        "difficulty": 2
      },
      {
        "category": "Quran Sciences Terms",
        "words": ["Makki", "Madani", "Nasikh", "Mansukh"],
        "difficulty": 3
      },
      {
        "category": "Advanced Usul Labels",
        "words": ["Tahqiq", "Tanqih", "Takhrij", "Sadd"],
        "difficulty": 4
      }
    ],
    "2026-02-20": [
      {
        "category": "End Times Terms",
        "words": [
          "Dajjal",
          "Mahdi",
          "Yajuj",
          "Majuj"
        ],
        "difficulty": 1,
        "hint": "Major signs discussed in Islamic eschatology"
      },
      {
        "category": "Day of Judgment Scenes",
        "words": [
          "Trumpet",
          "Gathering",
          "Scales",
          "Bridge"
        ],
        "difficulty": 2
      },
      {
        "category": "Life of the Grave",
        "words": [
          "Barzakh",
          "Munkar",
          "Nakir",
          "Question"
        ],
        "difficulty": 3
      },
      {
        "category": "Paradise Terms",
        "words": [
          "Firdaus",
          "Tuba",
          "Kawthar",
          "Sidrah"
        ],
        "difficulty": 4
      }
    ],
    "2026-02-19": [
      {
        "category": "Zakat Recipients",
        "words": [
          "Fuqara",
          "Masakeen",
          "Amileen",
          "Muallafah"
        ],
        "difficulty": 1,
        "hint": "Groups eligible to receive zakat"
      },
      {
        "category": "Trade Ethics",
        "words": [
          "Honesty",
          "Measure",
          "Contract",
          "Trust"
        ],
        "difficulty": 2
      },
      {
        "category": "Forbidden Foods",
        "words": [
          "Pork",
          "Carrion",
          "Blood",
          "Khamr"
        ],
        "difficulty": 3
      },
      {
        "category": "Nikah Elements",
        "words": [
          "Wali",
          "Mahr",
          "Witnesses",
          "Consent"
        ],
        "difficulty": 4
      }
    ],
    "2026-02-18": [
      {
        "category": "Musa Story Elements",
        "words": [
          "Sinai",
          "Pharaoh",
          "Staff",
          "Sea"
        ],
        "difficulty": 1,
        "hint": "Scenes linked to Prophet Musa"
      },
      {
        "category": "Yusuf Story Elements",
        "words": [
          "Dream",
          "Well",
          "Shirt",
          "Prison"
        ],
        "difficulty": 2
      },
      {
        "category": "Ibrahim Story Elements",
        "words": [
          "Fire",
          "Kaabah",
          "Sacrifice",
          "Stars"
        ],
        "difficulty": 3
      },
      {
        "category": "Isa Story Elements",
        "words": [
          "Injil",
          "Cradle",
          "Hawariyyun",
          "Table"
        ],
        "difficulty": 4
      }
    ],
    "2026-02-17": [
      {
        "category": "Daily Prayers",
        "words": [
          "Fajr",
          "Dhuhr",
          "Asr",
          "Maghrib"
        ],
        "difficulty": 1,
        "hint": "Names of daily obligatory prayers"
      },
      {
        "category": "Wudu Nullifiers",
        "words": [
          "Urine",
          "Stool",
          "Wind",
          "Sleep"
        ],
        "difficulty": 2
      },
      {
        "category": "Sunnah Prayers",
        "words": [
          "Witr",
          "Duha",
          "Tahajjud",
          "Rawatib"
        ],
        "difficulty": 3
      },
      {
        "category": "Islamic Character",
        "words": [
          "Truth",
          "Sabr",
          "Haya",
          "Mercy"
        ],
        "difficulty": 4
      }
    ],
    "2026-02-16": [
      {
        "category": "Early Battles",
        "words": [
          "Badr",
          "Uhud",
          "Khandaq",
          "Hunayn"
        ],
        "difficulty": 1,
        "hint": "Major battles in the seerah"
      },
      {
        "category": "Makki Surahs",
        "words": [
          "Yasin",
          "Mulk",
          "Qalam",
          "Muzzammil"
        ],
        "difficulty": 2
      },
      {
        "category": "Madinah Tribes",
        "words": [
          "Aws",
          "Khazraj",
          "Qaynuqa",
          "Nadir"
        ],
        "difficulty": 3
      },
      {
        "category": "Calligraphy Styles",
        "words": [
          "Thuluth",
          "Diwani",
          "Ruqah",
          "Nastaliq"
        ],
        "difficulty": 4
      }
    ],
    "2026-02-15": [
      {
        "category": "Quran Preservation",
        "words": [
          "Hifz",
          "Mushaf",
          "Qiraat",
          "Tajweed"
        ],
        "difficulty": 1,
        "hint": "Key concepts preserving Quran recitation and text"
      },
      {
        "category": "Halal Slaughter Terms",
        "words": [
          "Bismillah",
          "Dhabh",
          "Nahr",
          "Tasmiyah"
        ],
        "difficulty": 2
      },
      {
        "category": "Rights in Islam",
        "words": [
          "Parents",
          "Neighbors",
          "Orphans",
          "Guests"
        ],
        "difficulty": 3
      },
      {
        "category": "Gates of Jannah",
        "words": [
          "Rayyan",
          "Salah",
          "Jihad",
          "Sadaqah"
        ],
        "difficulty": 4
      }
    ],
    "2026-02-14": [
      {
        "category": "Quran Script Traditions",
        "words": [
          "Madani",
          "Uthmani",
          "Kufi",
          "Naskh"
        ],
        "difficulty": 1,
        "hint": "Common styles and conventions for Quran writing"
      },
      {
        "category": "Ahlul Bayt Names",
        "words": [
          "Fatimah",
          "Hasan",
          "Husayn",
          "Zaynab"
        ],
        "difficulty": 2
      },
      {
        "category": "Adhkar Phrases",
        "words": [
          "Tasbih",
          "Tahmid",
          "Takbir",
          "Istighfar"
        ],
        "difficulty": 3
      },
      {
        "category": "Sunnah Fast Days",
        "words": [
          "Monday",
          "Thursday",
          "Arafah",
          "Ashura"
        ],
        "difficulty": 4
      }
    ],
    "2026-02-13": [
      {
        "category": "Names of Allah",
        "words": [
          "Rahman",
          "Rahim",
          "Malik",
          "Quddus"
        ],
        "difficulty": 1,
        "hint": "From the Beautiful Names of Allah"
      },
      {
        "category": "Islamic Sciences",
        "words": [
          "Tafsir",
          "Fiqh",
          "Aqidah",
          "Seerah"
        ],
        "difficulty": 2
      },
      {
        "category": "Prayer Positions",
        "words": [
          "Qiyam",
          "Ruku",
          "Sujud",
          "Julus"
        ],
        "difficulty": 3
      },
      {
        "category": "Purification Types",
        "words": [
          "Wudu",
          "Ghusl",
          "Tayammum",
          "Istinja"
        ],
        "difficulty": 4
      }
    ],
    "2026-02-12": [
      {
        "category": "Hajj Rites",
        "words": [
          "Ihram",
          "Tawaf",
          "Sai",
          "Arafah"
        ],
        "difficulty": 1,
        "hint": "Core rituals performed during Hajj"
      },
      {
        "category": "Eid Practices",
        "words": [
          "Takbirat",
          "Qurbani",
          "Musalla",
          "Khutbah"
        ],
        "difficulty": 2
      },
      {
        "category": "Quranic Fruits",
        "words": [
          "Fig",
          "Olive",
          "Grapes",
          "Pomegranate"
        ],
        "difficulty": 3
      },
      {
        "category": "Historic Mosques",
        "words": [
          "Aqsa",
          "Nabawi",
          "Qiblatayn",
          "Quba"
        ],
        "difficulty": 4
      }
    ],
    "2026-02-11": [
      {
        "category": "Islamic Months",
        "words": [
          "Safar",
          "Muharram",
          "Rajab",
          "Shaban"
        ],
        "difficulty": 1,
        "hint": "Months in the Hijri calendar"
      },
      {
        "category": "Friday Sunnahs",
        "words": [
          "Ghusl",
          "Siwak",
          "Jumuah",
          "Kahf"
        ],
        "difficulty": 2
      },
      {
        "category": "Sunnah Foods",
        "words": [
          "Dates",
          "Honey",
          "Barley",
          "Vinegar"
        ],
        "difficulty": 3
      },
      {
        "category": "Quran Structure Terms",
        "words": [
          "Wahy",
          "Juz",
          "Hizb",
          "Ayah"
        ],
        "difficulty": 4
      }
    ],
    "2026-02-10": [
      {
        "category": "Companions",
        "words": [
          "Siddiq",
          "Umar",
          "Uthman",
          "Ali"
        ],
        "difficulty": 1,
        "hint": "The four rightly guided caliphs"
      },
      {
        "category": "Honored Women",
        "words": [
          "Khadijah",
          "Aisha",
          "Maryam",
          "Asiyah"
        ],
        "difficulty": 2
      },
      {
        "category": "Sacred Cities",
        "words": [
          "Makkah",
          "Madinah",
          "Quds",
          "Taif"
        ],
        "difficulty": 3
      },
      {
        "category": "Mandatory Charities",
        "words": [
          "Zakah",
          "Fitrah",
          "Kaffarah",
          "Nadhr"
        ],
        "difficulty": 4
      }
    ],
    "2026-02-09": [
      {
        "category": "Major Hadith Books",
        "words": [
          "Bukhari",
          "Muslim",
          "Tirmidhi",
          "Nasai"
        ],
        "difficulty": 1,
        "hint": "Foundational hadith collections"
      },
      {
        "category": "Prophets in Quran",
        "words": [
          "Nuh",
          "Hud",
          "Salih",
          "Shuayb"
        ],
        "difficulty": 2
      },
      {
        "category": "Makkah Landmarks",
        "words": [
          "Kaabah",
          "Safa",
          "Marwah",
          "Zamzam"
        ],
        "difficulty": 3
      },
      {
        "category": "Wudu Actions",
        "words": [
          "Face",
          "Arms",
          "Head",
          "Feet"
        ],
        "difficulty": 4
      }
    ],
    "2026-02-08": [
      {
        "category": "Ramadan Terms",
        "words": [
          "Suhoor",
          "Iftar",
          "Taraweeh",
          "Qadr"
        ],
        "difficulty": 1,
        "hint": "Words commonly associated with Ramadan"
      },
      {
        "category": "Major Angels",
        "words": [
          "Jibreel",
          "Mikaeel",
          "Israfeel",
          "Ridwan"
        ],
        "difficulty": 2
      },
      {
        "category": "Prayer Calls",
        "words": [
          "Adhan",
          "Iqamah",
          "Takbir",
          "Tasleem"
        ],
        "difficulty": 3
      },
      {
        "category": "Islamic Greetings",
        "words": [
          "Salam",
          "Marhaban",
          "Ahlan",
          "Tahiyyah"
        ],
        "difficulty": 4
      }
    ],
    "2026-02-07": [
      {
        "category": "Surahs of the Quran",
        "words": [
          "Baqarah",
          "Nisa",
          "Anam",
          "Kahf"
        ],
        "difficulty": 1,
        "hint": "Well-known surah names"
      },
      {
        "category": "Five Daily Prayers",
        "words": [
          "Fajr",
          "Dhuhr",
          "Asr",
          "Isha"
        ],
        "difficulty": 2
      },
      {
        "category": "Pillars of Islam",
        "words": [
          "Shahadah",
          "Salah",
          "Sawm",
          "Hajj"
        ],
        "difficulty": 3
      },
      {
        "category": "Sacred Months",
        "words": [
          "Muharram",
          "Rajab",
          "DhulQadah",
          "Dhulhijjah"
        ],
        "difficulty": 4
      }
    ],
    "2025-04-27": [
      {
        "category": "Prophetic Dreams",
        "words": [
          "Cows",
          "Moon",
          "Stars",
          "Fire"
        ],
        "difficulty": 1,
        "hint": "Symbols seen in the sleep of messengers"
      },
      {
        "category": "Islamic Games",
        "words": [
          "Archery",
          "Racing",
          "Wrestle",
          "Swim"
        ],
        "difficulty": 2
      },
      {
        "category": "Pre-Islamic Arabia",
        "words": [
          "Tribes",
          "Poets",
          "Idols",
          "Souq"
        ],
        "difficulty": 3
      },
      {
        "category": "Roles of Jinn",
        "words": [
          "Spy",
          "Whisp",
          "Guard",
          "Lead"
        ],
        "difficulty": 4
      }
    ],

    "2025-04-26": [
      {
        "category": "Terms in Aqeedah",
        "words": [
          "Shirk",
          "Bidah",
          "Tawhid",
          "Fitrah"
        ],
        "difficulty": 1,
        "hint": "Words related to belief in Islam"
      },
      {
        "category": "Islamic Tools",
        "words": [
          "Scale",
          "Pen",
          "Seal",
          "Scroll"
        ],
        "difficulty": 2
      },
      {
        "category": "Signs of Mercy",
        "words": [
          "Rain",
          "Smile",
          "Ease",
          "Help"
        ],
        "difficulty": 3
      },
      {
        "category": "Quranic Professions",
        "words": [
          "Scribe",
          "Sailor",
          "Cook",
          "Sheph"
        ],
        "difficulty": 4
      }
    ],

    "2025-04-25": [
      {
        "category": "Islamic Foods",
        "words": [
          "Dates",
          "Milk",
          "Honey",
          "Barley"
        ],
        "difficulty": 1,
        "hint": "Simple things often consumed by the Prophet"
      },
      {
        "category": "Islamic Herbs",
        "words": [
          "Black",
          "Cumin",
          "Aloe",
          "Senna"
        ],
        "difficulty": 2
      },
      {
        "category": "Wells in Islam",
        "words": [
          "Zamzam",
          "Badr",
          "Bayruha",
          "Aris"
        ],
        "difficulty": 3
      },
      {
        "category": "Historical Roles",
        "words": [
          "Judge",
          "Mufti",
          "Imam",
          "Caller"
        ],
        "difficulty": 4
      }
    ],

    "2025-04-24": [
      {
        "category": "Prophet’s Letters",
        "words": [
          "Qaysar",
          "Kisra",
          "Najashi",
          "Muqawq"
        ],
        "difficulty": 1,
        "hint": "Recipients of da'wah by message"
      },
      {
        "category": "Islamic Colors",
        "words": [
          "White",
          "Black",
          "Green",
          "Red"
        ],
        "difficulty": 2
      },
      {
        "category": "Elements of Qiyamah",
        "words": [
          "Horn",
          "Grave",
          "Fire",
          "Smoke"
        ],
        "difficulty": 3
      },
      {
        "category": "Healing in Sunnah",
        "words": [
          "Ruqyah",
          "Cupping",
          "Honey",
          "Salt"
        ],
        "difficulty": 4
      }
    ],
"2025-04-23": [
      {
        "category": "Tools of Prophets",
        "words": [
          "Asa",
          "Ark",
          "Ring",
          "Tablet"
        ],
        "difficulty": 1,
        "hint": "Objects linked to divine missions"
      },
      {
        "category": "Sacred Mountains",
        "words": [
          "Tur",
          "Uhud",
          "Noor",
          "Arafat"
        ],
        "difficulty": 2
      },
      {
        "category": "Forbidden Acts",
        "words": [
          "Riba",
          "Zina",
          "Ghiba",
          "Murder"
        ],
        "difficulty": 3
      },
      {
        "category": "Titles of Jannah",
        "words": [
          "Adn",
          "Firdaus",
          "Naeem",
          "Salam"
        ],
        "difficulty": 4
      }
    ],

    "2025-04-22": [
      {
        "category": "Sources of Sharia",
        "words": [
          "Quran",
          "Sunnah",
          "Ijma",
          "Qiyas"
        ],
        "difficulty": 1,
        "hint": "Foundations of Islamic law"
      },
      {
        "category": "Animals in Quran",
        "words": [
          "Ant",
          "Bee",
          "Dog",
          "Fish"
        ],
        "difficulty": 2
      },
      {
        "category": "Famous Caliphs",
        "words": [
          "Omar",
          "Ali",
          "Uthman",
          "Bakr"
        ],
        "difficulty": 3
      },
      {
        "category": "Islamic Courts",
        "words": [
          "Qadi",
          "Fatwa",
          "Mazalim",
          "Shura"
        ],
        "difficulty": 4
      }
    ],

    "2025-04-21": [
      {
        "category": "Pillars of Iman",
        "words": [
          "Allah",
          "Books",
          "Angels",
          "Qadar"
        ],
        "difficulty": 1,
        "hint": "Core articles of faith"
      },
      {
        "category": "Fruits of Jannah",
        "words": [
          "Dates",
          "Grape",
          "Fig",
          "Banana"
        ],
        "difficulty": 2
      },
      {
        "category": "Prophetic Traits",
        "words": [
          "Mercy",
          "Truth",
          "Trust",
          "Brave"
        ],
        "difficulty": 3
      },
      {
        "category": "Historical Empires",
        "words": [
          "Mamluk",
          "Ottoman",
          "Mughal",
          "Ayyub"
        ],
        "difficulty": 4
      }
    ],

    "2025-04-20": [
      {
        "category": "Daily Worship",
        "words": [
          "Salah",
          "Dua",
          "Dhikr",
          "Fast"
        ],
        "difficulty": 1,
        "hint": "Regular acts of devotion"
      },
      {
        "category": "Prayer Times",
        "words": [
          "Fajr",
          "Dhuhr",
          "Asr",
          "Isha"
        ],
        "difficulty": 2
      },
      {
        "category": "Islamic Ethics",
        "words": [
          "Adab",
          "Amanah",
          "Sabr",
          "Shukr"
        ],
        "difficulty": 3
      },
      {
        "category": "Seerah Sites",
        "words": [
          "Taif",
          "Badr",
          "Hira",
          "Uhud"
        ],
        "difficulty": 4
      }
    ],
"2025-04-19": [
      {
        "category": "Prophets in Quran",
        "words": [
          "Nuh",
          "Isa",
          "Lut",
          "Yunus"
        ],
        "difficulty": 1,
        "hint": "Messengers mentioned by name in the Book"
      },
      {
        "category": "Types of Zakat",
        "words": [
          "Wealth",
          "Crops",
          "Fitr",
          "Gold"
        ],
        "difficulty": 2
      },
      {
        "category": "Famous Mosques",
        "words": [
          "Haram",
          "Aqsa",
          "Quba",
          "Nabawi"
        ],
        "difficulty": 3
      },
      {
        "category": "Animals in Hadith",
        "words": [
          "Cat",
          "Camel",
          "Dog",
          "Horse"
        ],
        "difficulty": 4
      }
    ],

    "2025-04-18": [
      {
        "category": "Daily Dhikr",
        "words": [
          "Tasbih",
          "Takbir",
          "Tahmid",
          "Tahlil"
        ],
        "difficulty": 1,
        "hint": "Common forms of remembrance"
      },
      {
        "category": "Hadith Terms",
        "words": [
          "Isnad",
          "Matn",
          "Sahih",
          "Daif"
        ],
        "difficulty": 2
      },
      {
        "category": "Punished Nations",
        "words": [
          "Ad",
          "Thamud",
          "Lut",
          "Madyan"
        ],
        "difficulty": 3
      },
      {
        "category": "Types of Wudu Water",
        "words": [
          "Well",
          "Rain",
          "Sea",
          "River"
        ],
        "difficulty": 4
      }
    ],

    "2025-04-17": [
      {
        "category": "Quranic Commands",
        "words": [
          "Iqra",
          "Sabir",
          "Shukr",
          "Sallu"
        ],
        "difficulty": 1,
        "hint": "Divine imperatives found in the Quran"
      },
      {
        "category": "Companions' Titles",
        "words": [
          "Faruq",
          "Siddiq",
          "Ghani",
          "Tayyar"
        ],
        "difficulty": 2
      },
      {
        "category": "Things in Jannah",
        "words": [
          "Milk",
          "Gold",
          "Fruits",
          "Silk"
        ],
        "difficulty": 3
      },
      {
        "category": "Prophet's Tools",
        "words": [
          "Asa",
          "Seal",
          "Ring",
          "Burda"
        ],
        "difficulty": 4
      }
    ],

    "2025-04-16": [
      {
        "category": "Salah Positions",
        "words": [
          "Qiyam",
          "Ruku",
          "Sujud",
          "Jalsa"
        ],
        "difficulty": 1,
        "hint": "Postures within a single prayer"
      },
      {
        "category": "Roles of Angels",
        "words": [
          "Death",
          "Rain",
          "Guard",
          "Trumpet"
        ],
        "difficulty": 2
      },
      {
        "category": "Names of Jahannam",
        "words": [
          "Ladha",
          "Hutam",
          "Saqar",
          "Jahim"
        ],
        "difficulty": 3
      },
      {
        "category": "Islamic Cities",
        "words": [
          "Makka",
          "Kufa",
          "Basra",
          "Fustat"
        ],
        "difficulty": 4
      }
    ],
"2025-04-15": [
      {
        "category": "Quranic Metals",
        "words": [
          "Gold",
          "Iron",
          "Silver",
          "Copper"
        ],
        "difficulty": 1,
        "hint": "Elements mentioned in the Holy Book"
      },
      {
        "category": "Prophet's Relics",
        "words": [
          "Naal",
          "Asa",
          "Ring",
          "Hair"
        ],
        "difficulty": 2
      },
      {
        "category": "Famous Sahaba",
        "words": [
          "Omar",
          "Ali",
          "Zayd",
          "Bilal"
        ],
        "difficulty": 3
      },
      {
        "category": "Lost Islamic Cities",
        "words": [
          "Fustat",
          "Samara",
          "Zabid",
          "Timbuk"
        ],
        "difficulty": 4
      }
    ],
    "2025-04-14": [
      {
        "category": "Sunan of Wudu",
        "words": [
          "Wash",
          "Rinse",
          "Wipe",
          "Intend"
        ],
        "difficulty": 1,
        "hint": "Actions done during purification"
      },
      {
        "category": "Dwellers of Jannah",
        "words": [
          "Hur",
          "Ghilman",
          "Martyr",
          "Believ"
        ],
        "difficulty": 2
      },
      {
        "category": "Islamic Scholars",
        "words": [
          "Shafi",
          "Malik",
          "Nawawi",
          "Suyuti"
        ],
        "difficulty": 3
      },
      {
        "category": "Seerah Events",
        "words": [
          "Badr",
          "Hudayb",
          "Uhud",
          "Khandaq"
        ],
        "difficulty": 4
      }
    ],
    "2025-04-13": [
      {
        "category": "Forbidden Foods",
        "words": [
          "Pork",
          "Blood",
          "Dead",
          "Idol"
        ],
        "difficulty": 1,
        "hint": "Things Muslims cannot eat"
      },
      {
        "category": "Names of Quran",
        "words": [
          "Furqan",
          "Kitab",
          "Nur",
          "Huda"
        ],
        "difficulty": 2
      },
      {
        "category": "Islamic Garments",
        "words": [
          "Ihram",
          "Aba",
          "Kufi",
          "Niqab"
        ],
        "difficulty": 3
      },
      {
        "category": "Islamic Dynasties",
        "words": [
          "Ayyub",
          "Ottom",
          "Umayy",
          "Mugh"
        ],
        "difficulty": 4
      }
    ],
    "2025-04-12": [
      {
        "category": "Malaika Roles",
        "words": [
          "Death",
          "Rain",
          "Trump",
          "Record"
        ],
        "difficulty": 1,
        "hint": "Duties of celestial beings"
      },
      {
        "category": "Famous Converts",
        "words": [
          "Najash",
          "Bilal",
          "Hamza",
          "Sumay"
        ],
        "difficulty": 2
      },
      {
        "category": "Gates of Jannah",
        "words": [
          "Rayyan",
          "Salah",
          "Sadaq",
          "Jihad"
        ],
        "difficulty": 3
      },
      {
        "category": "Branches of Iman",
        "words": [
          "Tongue",
          "Heart",
          "Limbs",
          "Action"
        ],
        "difficulty": 4
      }
    ],
    "2025-04-11": [
      {
        "category": "Parts of Salah",
        "words": [
          "Qiyam",
          "Ruku",
          "Sujud",
          "Tashah"
        ],
        "difficulty": 1,
        "hint": "Movements during prayer"
      },
      {
        "category": "Prophetic Duas",
        "words": [
          "Qunoot",
          "Istigh",
          "Sabah",
          "Tawba"
        ],
        "difficulty": 2
      },
      {
        "category": "Seerah Titles",
        "words": [
          "Amin",
          "Sadiq",
          "Rasul",
          "Nabi"
        ],
        "difficulty": 3
      },
      {
        "category": "Early Muslim Cities",
        "words": [
          "Makka",
          "Madina",
          "Basra",
          "Kufa"
        ],
        "difficulty": 4
      }
    ],
      "2025-04-10": [
      {
        "category": "Salah Times",
        "words": [
          "Fajr",
          "Dhuhr",
          "Asr",
          "Isha"
        ],
        "difficulty": 1,
        "hint": "Obligatory prayers throughout the day"
      },
      {
        "category": "Famous Prophets",
        "words": [
          "Adam",
          "Nuh",
          "Musa",
          "Isa"
        ],
        "difficulty": 2
      },
      {
        "category": "Items in Masjid",
        "words": [
          "Rug",
          "Lamp",
          "Mihrab",
          "Minbar"
        ],
        "difficulty": 3
      },
      {
        "category": "Angels in Islam",
        "words": [
          "Jibril",
          "Mikail",
          "Israfil",
          "Malik"
        ],
        "difficulty": 4
      }
    ],
    "2025-04-09": [
      {
        "category": "Quranic Fruits",
        "words": [
          "Fig",
          "Date",
          "Grape",
          "Olive"
        ],
        "difficulty": 1,
        "hint": "Mentioned foods in the Holy Book"
      },
      {
        "category": "Signs of Qiyamah",
        "words": [
          "Dajjal",
          "Smoke",
          "Beast",
          "Sun"
        ],
        "difficulty": 2
      },
      {
        "category": "Early Muslim Cities",
        "words": [
          "Makka",
          "Madina",
          "Kufa",
          "Baghdad"
        ],
        "difficulty": 3
      },
      {
        "category": "Branches of Islam",
        "words": [
          "Sunni",
          "Shia",
          "Ibadi",
          "Sufi"
        ],
        "difficulty": 4
      }
    ],
    "2025-04-08": [
      {
        "category": "Islamic Months",
        "words": [
          "Rajab",
          "Shaaban",
          "Ramadan",
          "Shawwal"
        ],
        "difficulty": 1,
        "hint": "Periods in the Islamic calendar"
      },
      {
        "category": "Quranic Animals",
        "words": [
          "Ant",
          "Bee",
          "Fish",
          "Crow"
        ],
        "difficulty": 2
      },
      {
        "category": "Titles of Prophets",
        "words": [
          "Kalim",
          "Ruh",
          "Sadiq",
          "Nabi"
        ],
        "difficulty": 3
      },
      {
        "category": "Quranic Punishments",
        "words": [
          "Flood",
          "Fire",
          "Stone",
          "Wind"
        ],
        "difficulty": 4
      }
    ],
    "2025-04-07": [
      {
        "category": "Acts of Worship",
        "words": [
          "Salah",
          "Sawm",
          "Zakat",
          "Hajj"
        ],
        "difficulty": 1,
        "hint": "Pillars of Islamic practice"
      },
      {
        "category": "Names of Jannah",
        "words": [
          "Firdaus",
          "Adn",
          "Naim",
          "Daruss"
        ],
        "difficulty": 2
      },
      {
        "category": "Famous Converts",
        "words": [
          "Hamza",
          "Sumay",
          "Bilal",
          "Najashi"
        ],
        "difficulty": 3
      },
      {
        "category": "Hadith Narrators",
        "words": [
          "Bukh",
          "Musli",
          "AbuDa",
          "Tirmi"
        ],
        "difficulty": 4
      }
    ],
    "2025-04-06": [
      {
        "category": "Elements in Islam",
        "words": [
          "Fire",
          "Water",
          "Wind",
          "Earth"
        ],
        "difficulty": 1,
        "hint": "Basic components of creation"
      },
      {
        "category": "Wives of Prophet",
        "words": [
          "Aisha",
          "Hafsa",
          "Zaynab",
          "Khadija"
        ],
        "difficulty": 2
      },
      {
        "category": "Prophetic Names",
        "words": [
          "Taha",
          "Yasin",
          "Ahmed",
          "Mustafa"
        ],
        "difficulty": 3
      },
      {
        "category": "Islamic Rulings",
        "words": [
          "Haram",
          "Halal",
          "Makruh",
          "Mubah"
        ],
        "difficulty": 4
      }
    ],
     "2025-04-05": [
      {
        "category": "Duties of Angels",
        "words": [
          "Wahi",
          "Rain",
          "Soul",
          "Guard"
        ],
        "difficulty": 1,
        "hint": "Tasks assigned to celestial beings"
      },
      {
        "category": "Names of Jahannam",
        "words": [
          "Ladha",
          "Hutam",
          "Saqar",
          "Sijji"
        ],
        "difficulty": 2
      },
      {
        "category": "Early Converts",
        "words": [
          "Ali",
          "Zayd",
          "Bilal",
          "Sumay"
        ],
        "difficulty": 3
      },
      {
        "category": "Famous Hadith Books",
        "words": [
          "Bukh",
          "Musli",
          "AbuDa",
          "Tirmi"
        ],
        "difficulty": 4
      }
    ],
    "2025-04-04": [
      {
        "category": "Sacred Months",
        "words": [
          "Rajab",
          "DhulQ",
          "DhulH",
          "Muhar"
        ],
        "difficulty": 1,
        "hint": "Times of peace and worship"
      },
      {
        "category": "Prophet’s Relics",
        "words": [
          "Naal",
          "Asa",
          "Ring",
          "Cloak"
        ],
        "difficulty": 2
      },
      {
        "category": "Types of Water",
        "words": [
          "Rain",
          "Well",
          "Sea",
          "Zamza"
        ],
        "difficulty": 3
      },
      {
        "category": "Branches of Iman",
        "words": [
          "Modesty",
          "Truth",
          "Trust",
          "Grat"
        ],
        "difficulty": 4
      }
    ],
    "2025-04-03": [
      {
        "category": "Prophetic Animals",
        "words": [
          "Camel",
          "Sheep",
          "Fish",
          "Ant"
        ],
        "difficulty": 1,
        "hint": "Creatures mentioned in stories of prophets"
      },
      {
        "category": "Types of Duas",
        "words": [
          "Need",
          "Thanks",
          "Fear",
          "Hope"
        ],
        "difficulty": 2
      },
      {
        "category": "Women in Seerah",
        "words": [
          "Amina",
          "Fatima",
          "Asma",
          "Hinda"
        ],
        "difficulty": 3
      },
      {
        "category": "Quranic Metals",
        "words": [
          "Iron",
          "Gold",
          "Silver",
          "Brass"
        ],
        "difficulty": 4
      }
    ],
    "2025-04-02": [
      {
        "category": "Blessings in Islam",
        "words": [
          "Life",
          "Food",
          "Rain",
          "Health"
        ],
        "difficulty": 1,
        "hint": "Gifts given by Allah"
      },
      {
        "category": "Famous Sahaba",
        "words": [
          "Omar",
          "Ali",
          "Zubay",
          "Talha"
        ],
        "difficulty": 2
      },
      {
        "category": "Quranic Trees",
        "words": [
          "Olive",
          "Date",
          "Grape",
          "Lotus"
        ],
        "difficulty": 3
      },
      {
        "category": "Types of Kufr",
        "words": [
          "Denial",
          "Mock",
          "Reject",
          "Hypoc"
        ],
        "difficulty": 4
      }
    ],
"2025-04-01": [
      {
        "category": "Forms of Charity",
        "words": [
          "Zakat",
          "Sadaq",
          "Fidyah",
          "Kaffar"
        ],
        "difficulty": 1,
        "hint": "Different ways to give in Islam"
      },
      {
        "category": "Islamic Garments",
        "words": [
          "Ihram",
          "Jilbab",
          "Kufi",
          "Niqab"
        ],
        "difficulty": 2
      },
      {
        "category": "Titles of the Prophet",
        "words": [
          "Amin",
          "Bashir",
          "Nadhir",
          "Khatim"
        ],
        "difficulty": 3
      },
      {
        "category": "Foods in the Quran",
        "words": [
          "Tin",
          "Ankab",
          "Qithth",
          "Zanjab"
        ],
        "difficulty": 4
      }
    ],
    "2025-03-31": [
      {
        "category": "Prayer Movements",
        "words": [
          "Ruku",
          "Sujud",
          "Qiyam",
          "Tashah"
        ],
        "difficulty": 1,
        "hint": "Physical actions in Salah"
      },
      {
        "category": "Islamic Finance",
        "words": [
          "Riba",
          "Zakat",
          "Waqf",
          "Sukuk"
        ],
        "difficulty": 2
      },
      {
        "category": "Companions' Titles",
        "words": [
          "Faruq",
          "Siddiq",
          "Tayyar",
          "Ghani"
        ],
        "difficulty": 3
      },
      {
        "category": "Prophetic Medicines",
        "words": [
          "Honey",
          "Black",
          "Olive",
          "Cupping"
        ],
        "difficulty": 4
      }
    ],
      "2025-03-30": [
          {
            "category": "Blessed Places",
            "words": [
              "Makka",
              "Aqsa",
              "Madin",
              "Tur"
            ],
            "difficulty": 1,
            "hint": "Sites with great spiritual value"
          },
          {
            "category": "Angels in Islam",
            "words": [
              "Jibra",
              "Mikail",
              "Isra",
              "Malik"
            ],
            "difficulty": 2
          },
          {
            "category": "Titles of Scholars",
            "words": [
              "Imam",
              "Qadi",
              "Mufti",
              "Faqih"
            ],
            "difficulty": 3
          },
          {
            "category": "Famous Battles",
            "words": [
              "Badr",
              "Uhud",
              "Khanda",
              "Hunayn"
            ],
            "difficulty": 4
          }
        ],
  "2025-03-29": [
      {
        "category": "Names of Jannah",
        "words": [
          "Firdaus",
          "Adn",
          "Naim",
          "Salam"
        ],
        "difficulty": 1,
        "hint": "Different levels of paradise"
      },
      {
        "category": "Famous Battles",
        "words": [
          "Badr",
          "Uhud",
          "Yarmuk",
          "Hunayn"
        ],
        "difficulty": 2
      },
      {
        "category": "Sacred Sites",
        "words": [
          "Hira",
          "Mina",
          "Arafat",
          "Safa"
        ],
        "difficulty": 3
      },
      {
        "category": "Islamic Scripts",
        "words": [
          "Kufic",
          "Diwani",
          "Thuluth",
          "Naskh"
        ],
        "difficulty": 4
      }
    ],

  "2025-03-28": [
      {
        "category": "Prophetic Titles",
        "words": [
          "Amin",
          "Sadiq",
          "Nabi",
          "Rasul"
        ],
        "difficulty": 1,
        "hint": "Honorable names of prophets"
      },
      {
        "category": "Sacred Books",
        "words": [
          "Quran",
          "Tawrah",
          "Zabur",
          "Injil"
        ],
        "difficulty": 2
      },
      {
        "category": "Seerah Places",
        "words": [
          "Badr",
          "Taif",
          "Hira",
          "Hudayb"
        ],
        "difficulty": 3
      },
      {
        "category": "Legal Maxims",
        "words": [
          "Harm",
          "Need",
          "Custom",
          "Cert"
        ],
        "difficulty": 4
      }
    ],

  "2025-03-27": [
      {
        "category": "Acts of Worship",
        "words": [
          "Pray",
          "Fast",
          "Hajj",
          "Zakat"
        ],
        "difficulty": 1,
        "hint": "Core Islamic practices"
      },
      {
        "category": "Names of Hell",
        "words": [
          "Jahim",
          "Saqar",
          "Laza",
          "Hutam"
        ],
        "difficulty": 2
      },
      {
        "category": "Quranic Metals",
        "words": [
          "Iron",
          "Gold",
          "Silver",
          "Copper"
        ],
        "difficulty": 3
      },
      {
        "category": "Famous Sufis",
        "words": [
          "Jilani",
          "Rumi",
          "Attar",
          "Niffar"
        ],
        "difficulty": 4
      }
    ],

  "2025-03-26": [
      {
        "category": "Sacred Days",
        "words": [
          "Jumuah",
          "Arafa",
          "Ashura",
          "Qadr"
        ],
        "difficulty": 1,
        "hint": "Special days in Islam"
      },
      {
        "category": "Early Converts",
        "words": [
          "Ali",
          "Zayd",
          "Bilal",
          "Sumya"
        ],
        "difficulty": 2
      },
      {
        "category": "Quranic Animals",
        "words": [
          "Ant",
          "Bee",
          "Crow",
          "Fish"
        ],
        "difficulty": 3
      },
      {
        "category": "Lost Cities",
        "words": [
          "Iram",
          "Lut",
          "Madyan",
          "Thamud"
        ],
        "difficulty": 4
      }
    ],

  "2025-03-25": [
      {
        "category": "Prophet’s Kin",
        "words": [
          "Ali",
          "Fatimah",
          "Abbas",
          "Hamza"
        ],
        "difficulty": 1,
        "hint": "Close family of the Prophet"
      },
      {
        "category": "Angels in Islam",
        "words": [
          "Jibril",
          "Mikail",
          "Israfil",
          "Malik"
        ],
        "difficulty": 2
      },
      {
        "category": "Quranic Trees",
        "words": [
          "Olive",
          "Fig",
          "Cedar",
          "Lotus"
        ],
        "difficulty": 3
      },
      {
        "category": "Islamic Seas",
        "words": [
          "Red",
          "Black",
          "White",
          "Caspian"
        ],
        "difficulty": 4
      }
    ],
"2025-03-24": [
      {
        "category": "Pillars of Iman",
        "words": [
          "Allah",
          "Angels",
          "Books",
          "Prophets"
        ],
        "difficulty": 1,
        "hint": "Core beliefs in Islamic faith"
      },
      {
        "category": "Islamic Legal Schools",
        "words": [
          "Hanafi",
          "Maliki",
          "Shafi",
          "Hanbali"
        ],
        "difficulty": 2
      },
      {
        "category": "Famous Muslim Explorers",
        "words": [
          "Battuta",
          "Zheng",
          "Drake",
          "Khwarizmi"
        ],
        "difficulty": 3
      },
      {
        "category": "Early Islamic Cities",
        "words": [
          "Mecca",
          "Medina",
          "Kufa",
          "Basra"
        ],
        "difficulty": 4
      }
    ],

  "2025-03-23": [
      {
        "category": "Names of the Quran",
        "words": [
          "Furqan",
          "Kitab",
          "Nur",
          "Huda"
        ],
        "difficulty": 1,
        "hint": "Titles given to the holy book"
      },
      {
        "category": "Prophets in the Quran",
        "words": [
          "Adam",
          "Nuh",
          "Lut",
          "Idris"
        ],
        "difficulty": 2
      },
      {
        "category": "Islamic Empires",
        "words": [
          "Umayyad",
          "Abbasid",
          "Ottoman",
          "Mughal"
        ],
        "difficulty": 3
      },
      {
        "category": "Forms of Dhikr",
        "words": [
          "Tasbih",
          "Tahlil",
          "Takbir",
          "Tahmid"
        ],
        "difficulty": 4
      }
    ],

  "2025-03-22": [
      {
        "category": "Prophet’s Family",
        "words": [
          "Fatima",
          "Ali",
          "Hasan",
          "Husayn"
        ],
        "difficulty": 1,
        "hint": "Close relatives of the Messenger"
      },
      {
        "category": "Titles of Prophets",
        "words": [
          "Kalim",
          "Ruh",
          "Khatim",
          "Nabi"
        ],
        "difficulty": 2
      },
      {
        "category": "Islamic Rituals",
        "words": [
          "Hajj",
          "Umrah",
          "Salah",
          "Zakat"
        ],
        "difficulty": 3
      },
      {
        "category": "Symbols in Islamic Art",
        "words": [
          "Crescent",
          "Calligraphy",
          "Geometry",
          "Arabesque"
        ],
        "difficulty": 4
      }
    ],

  "2025-03-21": [
      {
        "category": "Sacred Mosques",
        "words": [
          "Haram",
          "Nabawi",
          "Aqsa",
          "Quba"
        ],
        "difficulty": 1,
        "hint": "Important sites in Islam"
      },
      {
        "category": "Major Islamic Scholars",
        "words": [
          "Ghazali",
          "Suyuti",
          "IbnRushd",
          "Shatibi"
        ],
        "difficulty": 2
      },
      {
        "category": "Caliphs of Islam",
        "words": [
          "Siddiq",
          "Umar",
          "Uthman",
          "Ali"
        ],
        "difficulty": 3
      },
      {
        "category": "Branches of Knowledge",
        "words": [
          "Fiqh",
          "Hadith",
          "Tafsir",
          "Aqidah"
        ],
        "difficulty": 4
      }
    ],
"2025-03-20": [
      {
        "category": "Famous Islamic Cities",
        "words": [
          "Makkah",
          "Madinah",
          "Jerusalem",
          "Cairo"
        ],
        "difficulty": 1,
        "hint": "Places of deep historical and religious significance"
      },
      {
        "category": "Sources of Islamic Law",
        "words": [
          "Quran",
          "Sunnah",
          "Ijma",
          "Qiyas"
        ],
        "difficulty": 2
      },
      {
        "category": "Types of Water in Fiqh",
        "words": [
          "Pure",
          "Impure",
          "Used",
          "Flowing"
        ],
        "difficulty": 3
      },
      {
        "category": "Caliphs of al-Andalus",
        "words": [
          "Hakam",
          "Hisham",
          "Nasr",
          "Aamir"
        ],
        "difficulty": 4
      }
    ],
  "2025-03-19": [
      {
        "category": "Aqidah Concepts",
        "words": [
          "Tawhid",
          "Qadr",
          "Akhirah",
          "Risalah"
        ],
        "difficulty": 1,
        "hint": "Islamic Studies of Belief"
      },
      {
        "category": "Quranic Sciences",
        "words": [
          "Tafsir",
          "Tajwid",
          "Qiraat",
          "Makki"
        ],
        "difficulty": 2
      },
      {
        "category": "Titles of Scholars",
        "words": [
          "Imam",
          "Sheikh",
          "Mufti",
          "Qadi"
        ],
        "difficulty": 3
      },
      {
        "category": "Branches of Islamic Ethics",
        "words": [
          "Akhlaq",
          "Adab",
          "Taqwa",
          "Sabr"
        ],
        "difficulty": 4
      }
    ],

  "2025-03-18": [
      {
        "category": "Famous Prophets",
        "words": [
          "Adam",
          "Nuh",
          "Ibrahim",
          "Musa"
        ],
        "difficulty": 1,
        "hint": "Messengers mentioned in the Quran"
      },
      {
        "category": "Acts That Break Wudu",
        "words": [
          "Sleep",
          "Bleed",
          "Vomit",
          "Intoxicants"
        ],
        "difficulty": 2
      },
      {
        "category": "Islamic Philosophers",
        "words": [
          "Farabi",
          "Avicenna",
          "Averroes",
          "Miskawayh"
        ],
        "difficulty": 3
      },
      {
        "category": "Islamic Dynasties",
        "words": [
          "Umayyad",
          "Abbasid",
          "Ottoman",
          "Mughal"
        ],
        "difficulty": 4
      }
    ],

  "2025-03-17": [
      {
        "category": "Prophet's Family",
        "words": [
          "Fatima",
          "Ali",
          "Hassan",
          "Hussain"
        ],
        "difficulty": 1,
        "hint": "Close relatives of the Prophet Muhammad (PBUH)"
      },
      {
        "category": "Key Battles in Islam",
        "words": [
          "Badr",
          "Uhud",
          "Khandaq",
          "Hunayn"
        ],
        "difficulty": 2
      },
      {
        "category": "Sacred Islamic Relics",
        "words": [
          "Cloak",
          "Sword",
          "Turban",
          "Seal"
        ],
        "difficulty": 3
      },
      {
        "category": "Islamic Astronomy Terms",
        "words": [
          "Qamar",
          "Shams",
          "Najm",
          "Buruj"
        ],
        "difficulty": 4
      }
    ],
"2025-03-16": [
      {
        "category": "Prophetic Titles",
        "words": [
          "Kalim",
          "Ruh",
          "Najiy",
          "Amin"
        ],
        "difficulty": 1,
        "hint": "Special names given to prophets"
      },
      {
        "category": "Legal Rulings",
        "words": [
          "Haram",
          "Makruh",
          "Mubah",
          "Mustahab"
        ],
        "difficulty": 2
      },
      {
        "category": "Caliph Nicknames",
        "words": [
          "Siddiq",
          "Faruq",
          "Ghani",
          "Murtada"
        ],
        "difficulty": 3
      },
      {
        "category": "Coins in Islam",
        "words": [
          "Dinar",
          "Dirham",
          "Fals",
          "Qirat"
        ],
        "difficulty": 4
      }
    ],

  "2025-03-15": [
      {
        "category": "Prophet’s Items",
        "words": [
          "Burda",
          "Staff",
          "Ring",
          "Sandals"
        ],
        "difficulty": 1,
        "hint": "Personal belongings of the Prophet"
      },
      {
        "category": "Early Sects",
        "words": [
          "Khawarij",
          "Murji'ah",
          "Mu'tazila",
          "Jahmi"
        ],
        "difficulty": 2
      },
      {
        "category": "Sacred Places",
        "words": [
          "Haram",
          "Miqat",
          "Maqam",
          "Rawdah"
        ],
        "difficulty": 3
      },
      {
        "category": "Siege Battles",
        "words": [
          "Khandaq",
          "Ta’if",
          "Tabuk",
          "Fadak"
        ],
        "difficulty": 4
      }
    ],
"2025-03-14": [
      {
        "category": "Pillars of Islam",
        "words": [
          "Shahada",
          "Prayer",
          "Fasting",
          "Zakat"
        ],
        "difficulty": 1,
        "hint": "The foundation of a Muslim's faith"
      },
      {
        "category": "Holy Books",
        "words": [
          "Quran",
          "Torah",
          "Gospel",
          "Psalms"
        ],
        "difficulty": 2
      },
      {
        "category": "Names of Angels",
        "words": [
          "Jibril",
          "Mikail",
          "Israfil",
          "Malik"
        ],
        "difficulty": 3
      },
      {
        "category": "Sacred Cities",
        "words": [
          "Mecca",
          "Medina",
          "Jerusalem",
          "Najaf"
        ],
        "difficulty": 4
      }
    ],

  "2025-03-13": [
      {
        "category": "Five Daily Prayers",
        "words": [
          "Fajr",
          "Dhuhr",
          "Asr",
          "Maghrib"
        ],
        "difficulty": 1,
        "hint": "Obligatory acts of worship throughout the day"
      },
      {
        "category": "Required To Wash During Wudhu",
        "words": [
          "Hands",
          "Mouth",
          "Face",
          "Feet"
        ],
        "difficulty": 2
      },
      {
        "category": "Islamic Months",
        "words": [
          "Ramadan",
          "Muharram",
          "Sha'ban",
          "Shawwal"
        ],
        "difficulty": 3
      },
      {
        "category": "Prophet's Family",
        "words": [
          "Fatima",
          "Hassan",
          "Hussain",
          "Khadija"
        ],
        "difficulty": 4
      }
    ],
"2025-03-12": [
    {
      "category": "Ramadan-Related Acts of Worship",
      "words": [
        "Iftar",
        "Suhoor",
        "Tarawih",
        "Itikaf"
      ],
      "difficulty": 1,
      "hint": "Practices commonly observed during Ramadan"
    },
    {
      "category": "Rarely Discussed Angels in Islam",
      "words": [
        "Munkar",
        "Nakir",
        "Harut",
        "Marut"
      ],
      "difficulty": 2
    },
    {
      "category": "Forms of Dhikr",
      "words": [
        "Tasbih",
        "Tahlil",
        "Takbir",
        "Tahmid"
      ],
      "difficulty": 3
    },
    {
      "category": "Prophetic Dreams in Islam",
      "words": [
        "Yusuf",
        "Ibrahim",
        "Aziz",
        "King"
      ],
      "difficulty": 4
    }
  ],
"2025-03-11": [
      {
        "category": "People Exempt from Fasting",
        "words": [
          "Sick",
          "Traveler",
          "Elderly",
          "Pregnant"
        ],
        "difficulty": 1,
        "hint": "Those who are not obligated to fast"
      },
      {
        "category": "Types of Charity in Ramadan",
        "words": [
          "Sadaqah",
          "Zakat",
          "Fidya",
          "Kaffarah"
        ],
        "difficulty": 2
      },
      {
        "category": "Forbidden Actions While Fasting",
        "words": [
          "Eating",
          "Drinking",
          "Smoking",
          "Intimacy"
        ],
        "difficulty": 3
      },
      {
        "category": "Last 10 Nights of Ramadan",
        "words": [
          "Power",
          "Decree",
          "Destiny",
          "Worship"
        ],
        "difficulty": 4
      }
    ],

  "2025-03-10": [
      {
        "category": "Acts That Multiply Rewards in Ramadan",
        "words": [
          "Charity",
          "Prayer",
          "Dhikr",
          "Quran"
        ],
        "difficulty": 1,
        "hint": "Deeds that bring greater rewards in Ramadan"
      },
      {
        "category": "Sunna Foods for Iftar",
        "words": [
          "Dates",
          "Milk",
          "Water",
          "Vinegar"
        ],
        "difficulty": 2
      },
      {
        "category": "Prophets",
        "words": [
          "Musa",
          "Isa",
          "Ibrahim",
          "Yusuf"
        ],
        "difficulty": 3
      },
      {
      "category": "Islamic Battlefields",
      "words": [
        "Badr",
        "Uhud",
        "Khandaq",
        "Hunayn"
      ],
      "difficulty": 4
      }
    ],
"2025-03-09": [
    {
      "category": "Sins that Nullify Fasting",
      "words": [
        "Lying",
        "Anger",
        "Backbite",
        "Swear"
      ],
      "difficulty": 1,
      "hint": "Acts that reduce the rewards of fasting"
    },
    {
      "category": "Health Benefits of Fasting",
      "words": [
        "Detox",
        "Focus",
        "Healing",
        "Energy"
      ],
      "difficulty": 2
    },
    {
      "category": "Bad Attributes of The Nafs",
      "words": [
        "Desire",
        "Laziness",
        "Ego",
        "Greed"
      ],
      "difficulty": 3
    },
    {
      "category": "Angels",
      "words": [
        "Jibreel",
        "Mikaeel",
        "Ridwan",
        "Israfil"
      ],
      "difficulty": 4
    }
  ],
"2025-03-08": [
      {
        "category": "Fasting Practices",
        "words": [
          "Suhoor",
          "Iftar",
          "Niyyah",
          "Miswak"
        ],
        "difficulty": 1,
        "hint": "Essential acts tied to the daily fast"
      },
      {
        "category": "Taraweeh & Night Prayers",
        "words": [
          "Qiyam",
          "Tahajjud",
          "Witr",
          "Rak'ah"
        ],
        "difficulty": 2
      },
      {
          "category": "Sacred Sites",
          "words": [
            "Kaaba",
            "Aqsa",
            "Rawdah",
            "Mina"
          ],
          "difficulty": 3
        },
      {
        "category": "Virtues of Ramadan",
        "words": [
          "Mercy",
          "Forgiveness",
          "Patience",
          "Taqwa"
        ],
        "difficulty": 4
      }
    ],
  "2025-03-07": [
      {
        "category": "Charity in Ramadan",
        "words": [
          "Zakat",
          "Sadaqah",
          "Fidyah",
          "Kaffarah"
        ],
        "difficulty": 1,
        "hint": "Forms of giving during the holy month"
      },
      {
        "category": "Types of Fasting in Islam",
        "words": [
          "Obligatory",
          "Voluntary",
          "Expiatory",
          "Makeup"
        ],
        "difficulty": 2
      },
      {
        "category": "Foods Mentioned in Hadith",
        "words": [
          "Dates",
          "Milk",
          "Honey",
          "Barley"
        ],
        "difficulty": 3
      },
      {
        "category": "Sunan of Fasting",
        "words": [
          "Iftar",
          "Suhoor",
          "Miswak",
          "Dua"
        ],
        "difficulty": 4
      }
    ],
  "2025-03-06": [
      {
        "category": "Laylatul Qadr Signs",
        "words": [
          "Peaceful",
          "Calm",
          "Radiant",
          "Serene"
        ],
        "difficulty": 1,
        "hint": "Indicators of the most blessed night"
      },
      {
        "category": "Acts of Worship in Ramadan",
        "words": [
          "Prayer",
          "Quran",
          "Charity",
          "Dhikr"
        ],
        "difficulty": 2
      },
      {
      "category": "Themes of the Hereafter",
      "words": [
        "Resurrect",
        "Paradise",
        "Hellfire",
        "Judgment"
      ],
      "difficulty": 3
      },
      {
        "category": "Sins That Invalidate the Fast",
        "words": [
          "Eating",
          "Drinking",
          "Backbite",
          "Lying"
        ],
        "difficulty": 4
      }
    ],
  "2025-03-05": [
      {
        "category": "People Exempt from Fasting",
        "words": [
          "Sick",
          "Traveler",
          "Pregnant",
          "Elderly"
        ],
        "difficulty": 1,
        "hint": "Those allowed to delay or miss fasting"
      },
      {
        "category": "Types of Charity in Ramadan",
        "words": [
          "Zakat",
          "Sadaqah",
          "Fidyah",
          "Kaffarah"
        ],
        "difficulty": 2
      },
      {
        "category": "Quranic Verses on Fasting",
        "words": [
          "Baqara",
          "Nisa",
          "Anfal",
          "Maidah"
        ],
        "difficulty": 3
      },
      {
        "category": "Prohibited Acts While Fasting",
        "words": [
          "Lying",
          "Gossip",
          "Anger",
          "Cursing"
        ],
        "difficulty": 4
      }
    ],
  "2025-03-04": [
    {
      "category": "Acts That Break the Fast",
      "words": [
        "Eat",
        "Drink",
        "Vomit",
        "Menses"
      ],
      "difficulty": 1,
      "hint": "Things that invalidate fasting"
    },
      {
        "category": "Recommended Acts in Ramadan",
        "words": [
          "Charity",
          "Prayer",
          "Dua",
          "Itikaf"
        ],
        "difficulty": 2
      },
      {
        "category": "Sunnah Foods for Suhoor",
        "words": [
          "Dates",
          "Milk",
          "Water",
          "Barley"
        ],
        "difficulty": 3
      },
      {
        "category": "Pillars of Fasting",
        "words": [
          "Niyyah",
          "Sawm",
          "Sunset",
          "Iftar"
        ],
        "difficulty": 4
      }
    ],
  "2025-03-03": [
    {
      "category": "Fasting Practices",
      "words": [
        "Suhoor",
        "Iftar",
        "Niyyah",
        "Miswak"
      ],
      "difficulty": 1,
      "hint": "Essential acts tied to the daily fast"
    },
    {
      "category": "Taraweeh & Night Prayers",
      "words": [
        "Qiyam",
        "Tahajjud",
        "Witr",
        "Rak'ah"
      ],
      "difficulty": 2
    },
    {
      "category": "Ramadan Duas & Supplications",
      "words": [
        "Istighfar",
        "Qunoot",
        "Tawbah",
        "Bismillah"
      ],
      "difficulty": 3
    },
    {
      "category": "Virtues of Ramadan",
      "words": [
        "Mercy",
        "Forgiveness",
        "Patience",
        "Taqwa"
      ],
      "difficulty": 4
    }
  ],
  "2025-03-02": [
    {
      "category": "Charity in Ramadan",
      "words": [
        "Zakat",
        "Sadaqah",
        "Fidyah",
        "Kaffarah"
      ],
      "difficulty": 1,
      "hint": "Giving and generosity in the month of fasting"
    },
    {
      "category": "Historical Ramadan Events",
      "words": [
        "Badr",
        "Conquest",
        "Quran",
        "Hudaibiyah"
      ],
      "difficulty": 2
    },
    {
      "category": "Ramadan Foods & Traditions",
      "words": [
        "Dates",
        "Soup",
        "Laban",
        "Harira"
      ],
      "difficulty": 3
    },
    {
      "category": "Laylatul Qadr",
      "words": [
        "Destiny",
        "Angels",
        "Odd",
        "Peace"
      ],
      "difficulty": 4
    }
  ],
  "2025-03-01": [
    {
      "category": "Ramadan Etiquettes & Adab",
      "words": [
        "Dua",
        "Silence",
        "Modesty",
        "Generosity"
      ],
      "difficulty": 1,
      "hint": "Refining character during the holy month"
    },
    {
      "category": "Fasting Practices",
      "words": [
        "Hunger",
        "Thirst",
        "Patience",
        "Intention"
      ],
      "difficulty": 2
    },
    {
      "category": "Taraweeh & Night Prayers",
      "words": [
        "Imam",
        "Standing",
        "Recitation",
        "Long"
      ],
      "difficulty": 3
    },
    {
      "category": "Virtues of Ramadan",
      "words": [
        "Purify",
        "Gratitude",
        "Barakah",
        "Sincerity"
      ],
      "difficulty": 4
    }
  ],
"2025-02-28": [
    {
      "category": "Games in Islamic History",
      "words": [
        "Chess",
        "Mancala",
        "Polo",
        "Nard"
      ],
      "difficulty": 1,
      "hint": "Popular games played in the Muslim world"
    },
    {
      "category": "Sacred Wells in Islam",
      "words": [
        "Zamzam",
        "Aris",
        "Rumah",
        "Budaah"
      ],
      "difficulty": 2
    },
    {
      "category": "Islamic Calligraphy Styles",
      "words": [
        "Kufic",
        "Diwani",
        "Naskh",
        "Thuluth"
      ],
      "difficulty": 3
    },
    {
      "category": "Islamic Dynasties",
      "words": [
        "Umayyad",
        "Abbasid",
        "Fatimid",
        "Ottoman"
      ],
      "difficulty": 4
    }
  ],
"2025-02-27": [
    {
      "category": "Islamic Agriculture",
      "words": [
        "Date",
        "Saffron",
        "Cotton",
        "Sugarcane"
      ],
      "difficulty": 1,
      "hint": "Crops cultivated spread by Muslim civilizations"
    },
    {
      "category": "Alchemy & Chemistry",
      "words": [
        "Jabir",
        "Elixir",
        "Alembic",
        "Sulfide"
      ],
      "difficulty": 2
    },
    {
      "category": "Islamic Maritime History",
      "words": [
        "Dhow",
        "Karimi",
        "Astrolabe",
        "Musaffah"
      ],
      "difficulty": 3
    },
    {
      "category": "Islamic Finance",
      "words": [
        "Zakat",
        "Murabaha",
        "Takaful",
        "Sukuk"
      ],
      "difficulty": 4
    }
  ],
"2025-02-26": [
    {
      "category": "Lost Islamic Cities",
      "words": [
        "Fustat",
        "Zahra",
        "Baghrawan",
        "Timbuktu"
      ],
      "difficulty": 1,
      "hint": "Once thriving centers of Islamic civilization"
    },
    {
      "category": "Prophet Muhammad’s Letters",
      "words": [
        "Heraclius",
        "Najashi",
        "Muqawqis",
        "Khosrow"
      ],
      "difficulty": 2
    },
    {
      "category": "Islamic Astronomy",
      "words": [
        "Astrolabe",
        "Zij",
        "Sundial",
        "Qibla"
      ],
      "difficulty": 3
    },
    {
      "category": "Sacred Islamic Garments",
      "words": [
        "Ihram",
        "Kufi",
        "Aba",
        "Burnous"
      ],
      "difficulty": 4
    }
  ],
"2025-02-25": [
    {
      "category": "Islamic Healing Practices",
      "words": [
        "Ruqyah",
        "Hijama",
        "Honey",
        "Zamzam"
      ],
      "difficulty": 1,
      "hint": "Traditional remedies from Islamic teachings"
    },
    {
      "category": "Islamic Measurements & Currency",
      "words": [
        "Dirham",
        "Dinar",
        "Sa",
        "Mudd"
      ],
      "difficulty": 2
    },
    {
      "category": "The Role of Jinn in Islamic Tradition",
      "words": [
        "Ifrit",
        "Marid",
        "Qareen",
        "Ghoul"
      ],
      "difficulty": 3
    },
    {
      "category": "Islamic Armor & Weaponry",
      "words": [
        "Saif",
        "Baldric",
        "Miqdam",
        "Tabar"
      ],
      "difficulty": 4
    }
  ],
"2025-02-24": [
    {
      "category": "Coffee & Islam",
      "words": [
        "Yemen",
        "Qahwa",
        "Sufi",
        "Ottoman"
      ],
      "difficulty": 1,
      "hint": "A beloved drink with deep Islamic roots"
    },
    {
      "category": "Islamic Maritime History",
      "words": [
        "Dhow",
        "Murabitun",
        "Ajuran",
        "Calicut"
      ],
      "difficulty": 2
    },
    {
      "category": "Perfume & Fragrance in Islamic Tradition",
      "words": [
        "Musk",
        "Amber",
        "Oud",
        "Rose"
      ],
      "difficulty": 3
    },
    {
      "category": "Clothing & Fashion in Early Islam",
      "words": [
        "Jubba",
        "Imamah",
        "Khimar",
        "Izar"
      ],
      "difficulty": 4
    }
  ],
"2025-02-23": [
    {
      "category": "Prophet's Weapons",
      "words": [
        "Sword",
        "Bow",
        "Lance",
        "Shield"
      ],
      "difficulty": 1,
      "hint": "Tools used in battle"
    },
    {
      "category": "Famous Oaths in the Seerah",
      "words": [
        "Ridwan",
        "Aqabah",
        "Fath",
        "Mutah"
      ],
      "difficulty": 2
    },
    {
      "category": "Delegations to the Prophet",
      "words": [
        "Najran",
        "Hanifa",
        "Kinda",
        "Thaqif"
      ],
      "difficulty": 3
    },
    {
      "category": "Prophet’s Neighbors in Medina",
      "words": [
        "Ayyub",
        "Haritha",
        "Zaid",
        "Sahl"
      ],
      "difficulty": 4
    }
  ],

  "2025-02-22": [
    {
      "category": "Prophet’s Garments",
      "words": [
        "Cloak",
        "Turban",
        "Sandals",
        "Shirt"
      ],
      "difficulty": 1,
      "hint": "Items he wore"
    },
    {
      "category": "People Who Fed the Prophet",
      "words": [
        "Barakah",
        "Saad",
        "Sulaym",
        "Anas"
      ],
      "difficulty": 2
    },
    {
      "category": "Places Where Revelation Descended",
      "words": [
        "Hira",
        "Medina",
        "Mecca",
        "Tabuk"
      ],
      "difficulty": 3
    },
    {
      "category": "Enemies Killed at Badr",
      "words": [
        "Jahl",
        "Utbah",
        "Shaybah",
        "Umayyah"
      ],
      "difficulty": 4
    }
  ],

  "2025-02-21": [
    {
      "category": "Prophet’s Names",
      "words": [
        "Ahmad",
        "Taha",
        "Yasin",
        "Mahi"
      ],
      "difficulty": 1,
      "hint": "Ways he was addressed"
    },
    {
      "category": "Prophet’s Relatives",
      "words": [
        "Aqil",
        "Jafar",
        "Abbas",
        "Hamza"
      ],
      "difficulty": 2
    },
    {
      "category": "Foods the Prophet Enjoyed",
      "words": [
        "Dates",
        "Honey",
        "Milk",
        "Cucumber"
      ],
      "difficulty": 3
    },
    {
      "category": "Lessons from the Madinan Era",
      "words": [
        "Brotherhood",
        "Justice",
        "Tolerance",
        "Diplomacy"
      ],
      "difficulty": 4
    }
  ],

  "2025-02-20": [
    {
      "category": "Prophet’s Household Items",
      "words": [
        "Bowl",
        "Mat",
        "Lamp",
        "Pillow"
      ],
      "difficulty": 1,
      "hint": "Things in his home"
    },
    {
      "category": "Companions Who Memorized Hadith",
      "words": [
        "Hurayrah",
        "Abbas",
        "Anas",
        "Aisha"
      ],
      "difficulty": 2
    },
    {
      "category": "Places the Prophet Sent Letters",
      "words": [
        "Rome",
        "Persia",
        "Egypt",
        "Bahrain"
      ],
      "difficulty": 3
    },
    {
      "category": "Surahs Named After Events",
      "words": [
        "Ahzab",
        "Fath",
        "Isra",
        "Dukhan"
      ],
      "difficulty": 4
    }
  ],

  "2025-02-19": [
    {
      "category": "Prophet’s Actions Before Eating",
      "words": [
        "Bismillah",
        "Washing",
        "Sitting",
        "Sharing"
      ],
      "difficulty": 1,
      "hint": "His etiquette at meals"
    },
    {
      "category": "Companions Known for Poetry",
      "words": [
        "Hassan",
        "Kaab",
        "Abdullah",
        "Labid"
      ],
      "difficulty": 2
    },
    {
      "category": "Early Converts in Mecca",
      "words": [
        "Sumayyah",
        "Yasir",
        "Ammar",
        "Suhaib"
      ],
      "difficulty": 3
    },
    {
      "category": "Prophet’s Miracles in Nature",
      "words": [
        "Water",
        "Tree",
        "Moon",
        "Cloud"
      ],
      "difficulty": 4
    }
  ],

  "2025-02-18": [
    {
      "category": "Prophet’s Favorite Drinks",
      "words": [
        "Water",
        "Milk",
        "Honey",
        "Nabidh"
      ],
      "difficulty": 1,
      "hint": "What he preferred to drink"
    },
    {
      "category": "Companions Buried in Baqi",
      "words": [
        "Uthman",
        "Fatima",
        "Hasan",
        "Aisha"
      ],
      "difficulty": 2
    },
    {
      "category": "Wars After the Prophet’s Passing",
      "words": [
        "Ridda",
        "Yarmouk",
        "Qadisiyyah",
        "Nahawand"
      ],
      "difficulty": 3
    },
    {
      "category": "Seerah Events in Rajab",
      "words": [
        "Isra",
        "Miraj",
        "Tabuk",
        "Hudaibiyah"
      ],
      "difficulty": 4
    }
  ],

  "2025-02-17": [
    {
      "category": "Prophet’s Daily Acts",
      "words": [
        "Prayer",
        "Charity",
        "Fasting",
        "Smile"
      ],
      "difficulty": 1,
      "hint": "His everyday habits"
    },
    {
      "category": "Prophet’s Neighbors in Mecca",
      "words": [
        "Siddiq",
        "Khadija",
        "Ali",
        "Zubair"
      ],
      "difficulty": 2
    },
    {
      "category": "Treaties in the Prophet’s Time",
      "words": [
        "Hudaybiyyah",
        "Najran",
        "Medina",
        "Aqabah"
      ],
      "difficulty": 3
    },
    {
      "category": "Trials in the Meccan Period",
      "words": [
        "Boycott",
        "Taif",
        "Persecution",
        "Shaam"
      ],
      "difficulty": 4
    }
  ],
  "2025-02-16": [
    {
      "category": "Quranic Oaths",
      "words": [
        "Tin",
        "Shams",
        "Lail",
        "Duha"
      ],
      "difficulty": 1,
      "hint": "Oaths"
    },
    {
      "category": "Prophetic Sunnahs",
      "words": [
        "Siwak",
        "Witr",
        "Tahajjud",
        "Smile"
      ],
      "difficulty": 2
    },
    {
      "category": "Islamic Festivals",
      "words": [
        "Fitr",
        "Adha",
        "Mawlid",
        "Ashura"
      ],
      "difficulty": 3
    },
    {
      "category": "Obligations in Islam",
      "words": [
        "Prayer",
        "Zakat",
        "Hajj",
        "Fasting"
      ],
      "difficulty": 4
    }
  ],
  "2025-02-15": [
    {
      "category": "Names of Angels",
      "words": [
        "Jibreel",
        "Mikail",
        "Israfil",
        "Malik"
      ],
      "difficulty": 1,
      "hint": "From the unseen realms"
    },
    {
      "category": "Sacred Months",
      "words": [
        "Muharram",
        "Rajab",
        "Dhulhijjah",
        "RabiulAwal"
      ],
      "difficulty": 2
    },
    {
      "category": "Famous Islamic Scholars",
      "words": [
        "Sina",
        "Ghazali",
        "Tabari",
        "Khaldun"
      ],
      "difficulty": 3
    },
    {
      "category": "Islamic Historical Battles",
      "words": [
        "Badr",
        "Uhud",
        "Khandaq",
        "Hunayn"
      ],
      "difficulty": 4
    }
  ],
  "2025-02-14": [
    {
      "category": "Sacred Texts in Islam",
      "words": [
        "Quran",
        "Tawrah",
        "Injil",
        "Zabur"
      ],
      "difficulty": 1,
      "hint": "Revelations that shaped a faith"
    },
    {
      "category": "Concepts of Tawheed",
      "words": [
        "Lordship",
        "Worship",
        "Devotion",
        "Monotheism"
      ],
      "difficulty": 2
    },
    {
      "category": "Prophets",
      "words": [
        "Nuh",
        "Ibrahim",
        "Musa",
        "Isa"
      ],
      "difficulty": 3
    },
    {
      "category": "Attributes of Allah",
      "words": [
        "Rahman",
        "Qadir",
        "Alim",
        "Hakeem"
      ],
      "difficulty": 4
    }
  ],
  "2025-02-13": [
    {
      "category": "Fruits in the Quran",
      "words": [
        "Dates",
        "Figs",
        "Olives",
        "Grapes"
      ],
      "difficulty": 1,
      "hint": "Nature's bounty"
    },
    {
      "category": "Major Good Deeds",
      "words": [
        "Charity",
        "Prayer",
        "Fasting",
        "Kindness"
      ],
      "difficulty": 2
    },
    {
      "category": "Islamic Calligraphy Styles",
      "words": [
        "Kufic",
        "Thuluth",
        "Diwani",
        "Ruqah"
      ],
      "difficulty": 3
    },
    {
      "category": "Tools of the Prophets",
      "words": [
        "Staff",
        "Ring",
        "Ark",
        "Tablet"
      ],
      "difficulty": 4
    }
  ],
  "2025-02-12": [
    {
      "category": "Famous Islamic Women",
      "words": [
        "Khadijah",
        "Fatimah",
        "Aisha",
        "Asma"
      ],
      "difficulty": 1,
      "hint": "Pioneers of virtue and wisdom in early Islam"
    },
    {
      "category": "Ethics of Neighbors",
      "words": [
        "Courtesy",
        "Help",
        "Respect",
        "Support"
      ],
      "difficulty": 2
    },
    {
      "category": "Islamic Finance Concepts",
      "words": [
        "Zakat",
        "Riba",
        "Murabaha",
        "Takaful"
      ],
      "difficulty": 3
    },
    {
      "category": "Historical Islamic Empires",
      "words": [
        "Umayyad",
        "Abbasid",
        "Ottoman",
        "Mamluk"
      ],
      "difficulty": 4
    }
  ],
  "2025-02-11": [
    {
      "category": "Quranic Surahs",
      "words": [
        "Baqarah",
        "Ikhlas",
        "Nas",
        "Falaq"
      ],
      "difficulty": 1,
      "hint": "Chapters"
    },
    {
      "category": "Levels of the Soul",
      "words": [
        "Nafs",
        "Lawwamah",
        "Mutmainnah",
        "Ammarah"
      ],
      "difficulty": 2
    },
    {
      "category": "Prophetic Traits",
      "words": [
        "Truth",
        "Humility",
        "Generosity",
        "Patience"
      ],
      "difficulty": 3
    },
    {
      "category": "Islamic Jurisprudence",
      "words": [
        "Ijma",
        "Qiyas",
        "Ijtihad",
        "Fiqh"
      ],
      "difficulty": 4
    }
  ],
  "2025-02-10": [
    {
      "category": "Names of the Prophets",
      "words": [
        "Adam",
        "Nuh",
        "Ibrahim",
        "Musa"
      ],
      "difficulty": 1,
      "hint": "Chosen messengers of divine truth"
    },
    {
      "category": "Seerah Events",
      "words": [
        "Hijrah",
        "Badr",
        "Khandaq",
        "Taif"
      ],
      "difficulty": 2
    },
    {
      "category": "Islamic Rituals",
      "words": [
        "Wudu",
        "Salah",
        "Sawm",
        "Hajj"
      ],
      "difficulty": 3
    },
    {
      "category": "Themes of the Hereafter",
      "words": [
        "Resurrection",
        "Paradise",
        "Hellfire",
        "Judgment"
      ],
      "difficulty": 4
    }
  ],
  "2025-02-09": [
    {
      "category": "Islamic Calligraphy",
      "words": [
        "Kufic",
        "Thuluth",
        "Diwani",
        "Naskh"
      ],
      "difficulty": 1,
      "hint": "Art Atyle"
    },
    {
      "category": "Concepts of Iman",
      "words": [
        "Belief",
        "Trust",
        "Submission",
        "Devotion"
      ],
      "difficulty": 2
    },
    {
      "category": "Islamic Etiquettes",
      "words": [
        "Modesty",
        "Courtesy",
        "Gratitude",
        "Respect"
      ],
      "difficulty": 3
    },
    {
      "category": "Historical Milestones",
      "words": [
        "Hijrah",
        "Revelation",
        "Caliphate",
        "Unity"
      ],
      "difficulty": 4
    }
  ],
  "2025-02-08": [
      {
        "category": "99 Names of Allah",
        "words": [
          "Rahman",
          "Quddus",
          "Hakeem",
          "Samad"
        ],
        "difficulty": 1,
        "hint": "Actions of Iblees"
      },
      {
        "category": "Trials of Shaytan",
        "words": [
          "Whispers",
          "Pride",
          "Greed",
          "Despair"
        ],
        "difficulty": 2
      },
      {
        "category": "Animals in the Quran",
        "words": [
          "Ant",
          "Camel",
          "Dog",
          "Crow"
        ],
        "difficulty": 3
      },
      {
        "category": "Branches of Iman",
        "words": [
          "Prayer",
          "Charity",
          "Modesty",
          "Faith"
        ],
        "difficulty": 4
      }
    ],

  "2025-02-07": [
      {
        "category": "Fruits in the Quran",
        "words": [
          "Dates",
          "Figs",
          "Olives",
          "Grapes"
        ],
        "difficulty": 1,
        "hint": "People of the Cave"
      },
      {
        "category": "Virtues of Charity",
        "words": [
          "Reward",
          "Barakah",
          "Unity",
          "Purification"
        ],
        "difficulty": 2
      },
      {
        "category": "Concepts of Jihad",
        "words": [
          "Struggle",
          "Effort",
          "Patience",
          "Perseverance"
        ],
        "difficulty": 3
      },
      {
        "category": "Themes of Surah Al-Kahf",
        "words": [
          "Companionship",
          "Trials",
          "Gratitude",
          "Knowledge"
        ],
        "difficulty": 4
      }
    ],

  "2025-02-06": [
      {
        "category": "Islamic Astronomy",
        "words": [
          "Qibla",
          "Lunar",
          "Hilal",
          "Stars"
        ],
        "difficulty": 1,
        "hint": "Disease of The Heart"
      },
      {
        "category": "Signs of Hypocrisy",
        "words": [
          "Lying",
          "Betrayal",
          "Breaking Trust",
          "Deception"
        ],
        "difficulty": 2
      },
      {
        "category": "Prophetic Duas",
        "words": [
          "Forgiveness",
          "Guidance",
          "Patience",
          "Blessings"
        ],
        "difficulty": 3
      },
      {
        "category": "Trials and Tribulations",
        "words": [
          "Hardship",
          "Illness",
          "Loss",
          "Persecution"
        ],
        "difficulty": 4
      }
    ],

  "2025-02-05": [
      {
        "category": "Famous Islamic Scholars",
        "words": [
          "Ibn Sina",
          "Al-Ghazali",
          "Ibn Khaldun",
          "Al-Kindi"
        ],
        "difficulty": 1,
        "hint": "Used By Prophets"
      },
      {
        "category": "Adab in Islam",
        "words": [
          "Speech",
          "Eating",
          "Neighbors",
          "Elders"
        ],
        "difficulty": 2
      },
      {
        "category": "Sacred Months",
        "words": [
          "Dhul Hijjah",
          "Muharram",
          "Rajab",
          "Dhul Qi’dah"
        ],
        "difficulty": 3
      },
      {
        "category": "Tools of Prophets",
        "words": [
          "Staff",
          "Ark",
          "Ring",
          "Tablets"
        ],
        "difficulty": 4
      }
    ],

  "2025-02-04": [
      {
        "category": "Themes of Surah Maryam",
        "words": [
          "Miracles",
          "Prophets",
          "Devotion",
          "Family"
        ],
        "difficulty": 1,
        "hint": "Surah Named After a Woman"
      },
      {
        "category": "Burial Practices in Islam",
        "words": [
          "Shroud",
          "Ghusl",
          "Dua",
          "Grave"
        ],
        "difficulty": 2
      },
      {
        "category": "Islamic Festivals",
        "words": [
          "Eid al-Fitr",
          "Eid al-Adha",
          "Hajj",
          "Sacrifice"
        ],
        "difficulty": 3
      },
      {
        "category": "Fruits of Jannah",
        "words": [
          "Dates",
          "Pomegranate",
          "Grapes",
          "Bananas"
        ],
        "difficulty": 4
      }
    ],
"2025-02-03": [
    {
      "category": "Duties of Angels",
      "words": [
        "Record",
        "Guard",
        "Deliver",
        "Blow"
      ],
      "difficulty": 1,
      "hint": "Where you want to go"
    },
    {
      "category": "Events of Karbala",
      "words": [
        "Sacrifice",
        "Stand",
        "Betrayal",
        "Martyrdom"
      ],
      "difficulty": 2
    },
    {
      "category": "Attributes of Paradise",
      "words": [
        "Gardens",
        "Rivers",
        "Eternal",
        "Bliss"
      ],
      "difficulty": 3
    },
    {
      "category": "Names of the Quran",
      "words": [
        "Furqan",
        "Kitab",
        "Huda",
        "Dhikr"
      ],
      "difficulty": 4
    }
  ],
"2025-02-02": [
    {
      "category": "Obligatory Prayers",
      "words": [
        "Fajr",
        "Dhuhr",
        "Maghrib",
        "Isha"
      ],
      "difficulty": 1,
      "hint": "Burials"
    },
    {
      "category": "Trials of the Grave",
      "words": [
        "Munkar",
        "Nakir",
        "Questioning",
        "Darkness"
      ],
      "difficulty": 2
    },
    {
      "category": "Themes of Surah Kahf",
      "words": [
        "Patience",
        "Faith",
        "Wisdom",
        "Trial"
      ],
      "difficulty": 3
    },
    {
      "category": "Notable Islamic Scholars",
      "words": [
        "Ghazali",
        "Bukhari",
        "Razi",
        "Tabari"
      ],
      "difficulty": 4
    }
  ],
"2025-02-01": [
    {
      "category": "Pillars of Islam",
      "words": [
        "Shahada",
        "Salah",
        "Zakah",
        "Sawm"
      ],
      "difficulty": 1,
      "hint": "Recommended Acts"
    },
    {
      "category": "Responsibilities of Men in Marriage",
      "words": [
        "Provision",
        "Protection",
        "Kindness",
        "Leadership"
      ],
      "difficulty": 2
    },
    {
      "category": "Prophetic Sunnahs",
      "words": [
        "Miswak",
        "Greeting",
        "Charity",
        "Gratitude"
      ],
      "difficulty": 3
    },
    {
      "category": "Signs of the Day of Judgment",
      "words": [
        "Smoke",
        "Beast",
        "Dajjal",
        "Ya’juj"
      ],
      "difficulty": 4
    }
  ],
"2025-01-31": [
    {
      "category": "Responsibilities of Men in Islam",
      "words": [
        "Provision",
        "Leadership",
        "Justice",
        "Protection"
      ],
      "difficulty": 1,
      "hint": "Gender Responsibilities"
    },
    {
      "category": "Responsibilities of Women in Marriage",
      "words": [
        "Love",
        "Support",
        "Obedience",
        "Nurturing"
      ],
      "difficulty": 2
    },
    {
      "category": "Famous Islamic Scholars",
      "words": [
        "Bukhari",
        "Ghazali",
        "Tabari",
        "Ibn Sina"
      ],
      "difficulty": 3
    },
    {
      "category": "Themes of Surah Al-Kahf",
      "words": [
        "Patience",
        "Trials",
        "Gratitude",
        "Knowledge"
      ],
      "difficulty": 4
    }
  ],
"2025-01-30": [
    {
      "category": "Sacred Texts in Islam",
      "words": [
        "Quran",
        "Tawrah",
        "Injil",
        "Zabur"
      ],
      "difficulty": 1,
      "hint": "Haram Acts"
    },
    {
      "category": "Stages of the Grave",
      "words": [
        "Questioning",
        "Barzakh",
        "Darkness",
        "Punishment"
      ],
      "difficulty": 2
    },
    {
      "category": "Themes of Surah Maryam",
      "words": [
        "Prophethood",
        "Resurrection",
        "Mercy",
        "Miracles"
      ],
      "difficulty": 3
    },
    {
      "category": "Forbidden Acts in Islam",
      "words": [
        "Riba",
        "Zina",
        "Ghiba",
        "Murder"
      ],
      "difficulty": 4
    }
  ],
"2025-01-29": [
    {
      "category": "Events of Prophet Musa",
      "words": [
        "Sea",
        "Staff",
        "Firaun",
        "Manna"
      ],
      "difficulty": 1,
      "hint": "Given Stone Tablets"
    },
    {
      "category": "Forbidden Foods in Islam",
      "words": [
        "Pork",
        "Carrion",
        "Blood",
        "Alcohol"
      ],
      "difficulty": 2
    },
    {
      "category": "Titles of the Prophet Muhammad",
      "words": [
        "Amin",
        "Rasool",
        "Nabi",
        "Mustafa"
      ],
      "difficulty": 3
    },
    {
      "category": "Islamic Historical Sites",
      "words": [
        "Kaaba",
        "Aqsa",
        "Hira",
        "Uhud"
      ],
      "difficulty": 4
    }
  ],
"2025-01-28": [
    {
      "category": "Sunan of Wudu",
      "words": [
        "Intention",
        "Mouth",
        "Nostrils",
        "Feet"
      ],
      "difficulty": 1,
      "hint": "Action Before Prayer"
    },
    {
      "category": "Punishments in Jahannam",
      "words": [
        "Scorching",
        "Chains",
        "Boiling",
        "Fire"
      ],
      "difficulty": 2
    },
    {
      "category": "Companions of the Prophet",
      "words": [
        "Siddiq",
        "Umar",
        "Uthman",
        "Ali"
      ],
      "difficulty": 3
    },
    {
      "category": "Attributes of Allah",
      "words": [
        "Rahman",
        "Qadir",
        "Alim",
        "Hakeem"
      ],
      "difficulty": 4
    }
  ],
"2025-01-27": [
    {
      "category": "Events Relating to Prophet Ibrahim",
      "words": [
        "Fire",
        "Idols",
        "Dream",
        "Haram"
      ],
      "difficulty": 1,
      "hint": "Father of Isaac"
    },
    {
      "category": "Sins Mentioned in the Quran",
      "words": [
        "Lying",
        "Stealing",
        "Murder",
        "Backbiting"
      ],
      "difficulty": 2
    },
    {
      "category": "Rights of Neighbors in Islam",
      "words": [
        "Kindness",
        "Protection",
        "Support",
        "Forgiveness"
      ],
      "difficulty": 3
    },
    {
      "category": "Levels of Jannah",
      "words": [
        "Firdaus",
        "Adn",
        "Naeem",
        "Maqam"
      ],
      "difficulty": 4
    }
  ],
"2025-01-26": [
    {
      "category": "Angels Mentioned in the Quran",
      "words": [
        "Jibreel",
        "Mikail",
        "Israfil",
        "Malik"
      ],
      "difficulty": 1,
      "hint": "Creatures of Light"
    },
    {
      "category": "Sacred Months in Islam",
      "words": [
        "Muharram",
        "Rajab",
        "Dhul Hijjah",
        "Dhul Qadah"
      ],
      "difficulty": 2
    },
    {
      "category": "Events from the Seerah",
      "words": [
        "Badr",
        "Uhud",
        "Hudaybiyah",
        "Hijrah"
      ],
      "difficulty": 3
    },
    {
      "category": "Quranic Commands",
      "words": [
        "Iqra",
        "Sabir",
        "Shukr",
        "Itteba"
      ],
      "difficulty": 4
    }
  ],
"2025-01-25": [
    {
      "category": "Ramadan Practices",
      "words": [
        "Fasting",
        "Taraweeh",
        "Suhoor",
        "Iftar"
      ],
      "difficulty": 1
    },
    {
      "category": "Rabi' al-Awwal Events",
      "words": [
        "Prophet",
        "Mawlid",
        "Celebrations",
        "Seerah"
      ],
      "difficulty": 2
    },
    {
      "category": "Muharram Significance",
      "words": [
        "Ashura",
        "Karbala",
        "Imam Hussein",
        "Martyrdom"
      ],
      "difficulty": 3
    },
    {
      "category": "Dhul-Hijjah Rituals",
      "words": [
        "Hajj",
        "Eid al-Adha",
        "Sacrifice",
        "Stoning"
      ],
      "difficulty": 4
    }
  ],
"2025-01-24": [
    {
      "category": "Importance of Intention",
      "words": [
        "Actions",
        "Niyaa",
        "Sincerity",
        "Reward"
      ],
      "difficulty": 1
    },
    {
      "category": "Trust in Allah",
      "words": [
        "Tawakkul",
        "Reliance",
        "Faith",
        "Submission"
      ],
      "difficulty": 2
    },
    {
      "category": "Kindness to Parents",
      "words": [
        "Respect",
        "Obedience",
        "Dua",
        "Gratitude"
      ],
      "difficulty": 3
    },
    {
      "category": "Forgiveness of Others",
      "words": [
        "Mercy",
        "Pardon",
        "Grudge",
        "Reconciliation"
      ],
      "difficulty": 4
    }
  ],
"2025-01-23": [
    {
      "category": "Gardens of Jannah",
      "words": [
        "Firdaus",
        "Adn",
        "Na'im",
        "Ma'wa"
      ],
      "difficulty": 1
    },
    {
      "category": "Descriptions of Jannah",
      "words": [
        "Rivers",
        "Gardens",
        "Palaces",
        "Springs"
      ],
      "difficulty": 2
    },
    {
      "category": "People of Jannah",
      "words": [
        "Prophets",
        "Martyrs",
        "Believers",
        "Righteous"
      ],
      "difficulty": 3
    },
    {
      "category": "Rewards in Jannah",
      "words": [
        "Peace",
        "Joy",
        "Contentment",
        "Companions"
      ],
      "difficulty": 4
    }
  ],
"2025-01-22": [
    {
      "category": "Names of Angels in Islam",
      "words": [
        "Jibreel",
        "Mikail",
        "Israfil",
        "Malik"
      ],
      "difficulty": 1
    },
    {
      "category": "Duties of Angels",
      "words": [
        "Revelation",
        "Recording",
        "Guarding",
        "Blowing"
      ],
      "difficulty": 2
    },
    {
      "category": "Descriptions of Angels",
      "words": [
        "Wings",
        "Light",
        "Obedient",
        "Pure"
      ],
      "difficulty": 3
    },
    {
      "category": "Encounters with Angels",
      "words": [
        "Cave",
        "Ascension",
        "Battle",
        "Dream"
      ],
      "difficulty": 4
    }
  ],
"2025-01-21": [
    {
      "category": "Signs of the End of Times",
      "words": [
        "Dajjal",
        "Yajuj",
        "Mahdi",
        "Isa"
      ],
      "difficulty": 1
    },
    {
    "category": "Obligations in Islam",
    "words": [
      "Prayer",
      "Zakat",
      "Hajj",
      "Fasting"
    ],
    "difficulty": 2
    },
    {
      "category": "Prophetic Sunnahs",
      "words": [
        "Siwak",
        "Hijama",
        "Tahajjud",
        "Smiling"
      ],
      "difficulty": 3
    },
    {
      "category": "Islamic Art & Architecture",
      "words": [
        "Minaret",
        "Muqarnas",
        "Calligraphy",
        "Dome"
      ],
      "difficulty": 4
    }
  ],
"2025-01-20": [
    {
      "category": "Names of Shaytan",
      "words": [
        "Iblis",
        "Aduw Allāh",
        "Shaytan",
        "Azazil"
      ],
      "difficulty": 1
    },
    {
      "category": "Names of Jinn",
      "words": [
        "Ifrit",
        "Marid",
        "Ghoul",
        "Nasnas"
      ],
      "difficulty": 2
    },
    {
      "category": "Major Sins",
      "words": [
        "Shirk",
        "Sorcery",
        "Murder",
        "Usury"
      ],
      "difficulty": 3
    },
    {
      "category": "Stages of the Soul in Islam",
      "words": [
        "Nafs",
        "Ammarah",
        "Lawwamah",
        "Mutmainnah"
      ],
      "difficulty": 4
    }
  ],
"2025-01-19": [
      {
        "category": "Degrees of Legal Rulings",
        "words": [
          "Wajib",
          "Mustahabb",
          "Mubah",
          "Haram"
        ],
        "difficulty": 1
      },
      {
        "category": "Categories of Purity",
        "words": [
          "Ghusl",
          "Wudu",
          "Tayammum",
          "Istinja"
        ],
        "difficulty": 2
      },
      {
        "category": "People Addressed in the Quran",
        "words": [
          "Believers",
          "Disbelievers",
          "Hypocrites",
          "Jinn"
        ],
        "difficulty": 3
      },
      {
        "category": "Four Rivers in Paradise",
        "words": [
          "Milk",
          "Honey",
          "Wine",
          "Water"
        ],
        "difficulty": 4
      }
    ],
"2025-01-18": [
    {
      "category": "Quranic Oaths",
      "words": [
        "Fig",
        "Olive",
        "Sun",
        "Night"
      ],
      "difficulty": 1
    },
    {
      "category": "Events of the Seerah",
      "words": [
        "Hijrah",
        "Badr",
        "Uhud",
        "Hudaybiyyah"
      ],
      "difficulty": 2
    },
    {
      "category": "Prophetic Foods",
      "words": [
        "Dates",
        "Milk",
        "Barley",
        "Vinegar"
      ],
      "difficulty": 3
    },
    {
      "category": "Levels of Jahannam",
      "words": [
        "Jahannam",
        "Saqar",
        "Ladha",
        "Hawiyah"
      ],
      "difficulty": 4
    }
  ],
"2025-01-17": [
    {
      "category": "Things Associated with Ramadan",
      "words": [
        "Iftar",
        "Suhoor",
        "Tarawih",
        "Laylatul Qadr"
      ],
      "difficulty": 1
    },
    {
      "category": "Islamic Finance Terms",
      "words": [
        "Zakat",
        "Riba",
        "Sukuk",
        "Murabaha"
      ],
      "difficulty": 2
    },
    {
      "category": "Concepts Related to Marriage in Islam",
      "words": [
        "Mahr",
        "Nikah",
        "Khula",
        "Wali"
      ],
      "difficulty": 3
    },
    {
      "category": "Objects Used in Salah",
      "words": [
        "Sutra",
        "Prayer Rug",
        "Qibla",
        "Athan"
      ],
      "difficulty": 4
    }
  ],
"2025-01-16": [
    {
      "category": "Relating to Prophet Musa",
      "words": [
        "Sea",
        "Staff",
        "Plague",
        "Rock"
      ],
      "difficulty": 1
    },
    {
      "category": "Relating to Prophet Isa",
      "words": [
        "Healing",
        "Blindness",
        "Cure",
        "Raising"
      ],
      "difficulty": 2
    },
    {
      "category": "Relating to Prophet Ibrahim",
      "words": [
        "Fire",
        "Sacrifice",
        "Ram",
        "Survival"
      ],
      "difficulty": 3
    },
    {
      "category": "Relating to Prophet Muhammad",
      "words": [
        "Isra",
        "Moon",
        "Quran",
        "Spider"
      ],
      "difficulty": 4
    }
  ],
"2025-01-15": [
    {
      "category": "Uncommon Islamic Dynasties",
      "words": [
        "Qarakhanids",
        "Safavids",
        "Fatimids",
        "Mamluks"
      ],
      "difficulty": 1
    },
    {
      "category": "Islamic Contributions to Medicine",
      "words": [
        "Al-Razi",
        "Ibn Sina",
        "Al-Zahrawi",
        "Kitab al-Mansuri"
      ],
      "difficulty": 2
    },
    {
      "category": "Islamic Sufi Orders",
      "words": [
        "Naqshbandi",
        "Chishti",
        "Qadri",
        "Suhrawardi"
      ],
      "difficulty": 3
    },
    {
      "category": "Islamic Law on Commercial Transactions",
      "words": [
        "Murabaha",
        "Mudarabah",
        "Hawala",
        "Ijarah"
      ],
      "difficulty": 4
    }
  ],
"2025-01-14": [
    {
      "category": "Prophet Lut's Key Events",
      "words": [
        "Sodom",
        "Angels",
        "Punishment",
        "Escape"
      ],
      "difficulty": 1
    },
    {
      "category": "Prophet Jesus' Miracles",
      "words": [
        "Blind",
        "Dead",
        "Wine",
        "Cradle"
      ],
      "difficulty": 2
    },
    {
      "category": "Prophet Abraham's Key Events",
      "words": [
        "Sacrifice",
        "Kaaba",
        "Idols",
        "Fire"
      ],
      "difficulty": 3
    },
    {
      "category": "Prophet Adam's Legacy",
      "words": [
        "Clay",
        "First",
        "Paradise",
        "Tree"
      ],
      "difficulty": 4
    }
  ],
"2025-01-13": [
    {
      "category": "Foods Mentioned in the Quran",
      "words": [
        "Dates",
        "Olives",
        "Figs",
        "Honey"
      ],
      "difficulty": 1
    },
    {
      "category": "Core Beliefs in Aqeedah",
      "words": [
        "Tawhid",
        "Nubuwwah",
        "Akhirah",
        "Angels"
      ],
      "difficulty": 2
    },
    {
      "category": "Islamic Inventions in Astronomy",
      "words": [
        "Astrolabe",
        "Sundial",
        "Celestial Sphere",
        "Armillary Sphere"
      ],
      "difficulty": 3
    },
    {
      "category": "Animals in Prophetic Traditions",
      "words": [
        "Donkey",
        "Camel",
        "Dog",
        "Horse"
      ],
      "difficulty": 4
    }
  ],
"2025-01-12": [
    {
      "category": "Types of Charity in Islam",
      "words": [
        "Zakat",
        "Sadaqah",
        "Fidyah",
        "Kaffarah"
      ],
      "difficulty": 1
    },
    {
      "category": "Sacred Places Mentioned in the Quran",
      "words": [
        "Kaaba",
        "Al-Aqsa",
        "Mount Sinai",
        "Hira Cave"
      ],
      "difficulty": 2
    },
    {
      "category": "Branches of Islamic Law (Fiqh)",
      "words": [
        "Ibadat",
        "Muamalat",
        "Hudud",
        "Qisas"
      ],
      "difficulty": 3
    },
    {
      "category": "Arabic Titles of Prophet Muhammad",
      "words": [
        "Al-Amin",
        "Al-Sadiq",
        "Khatamun Nabiyyin",
        "Rahmatul-lil-Alamin"
      ],
      "difficulty": 4
    }
  ],
  "2025-01-11": [
    {
      "category": "Foods the Prophet Muhammad SAW Disliked",
      "words": [
        "Onions",
        "Garlic",
        "Lizard",
        "Fat of Sheep"
      ],
      "difficulty": 1
    },
    {
      "category": "Clothing Worn During Early Islam",
      "words": [
        "Qamees",
        "Imamah",
        "Rida",
        "Khimar"
      ],
      "difficulty": 2
    },
    {
      "category": "Animals Mentioned in the Quran",
      "words": [
        "Camel",
        "Ant",
        "Elephant",
        "Crow"
      ],
      "difficulty": 3
    },
    {
      "category": "Types of Angels in Islamic Theology",
      "words": [
        "Jibreel",
        "Mikail",
        "Israfil",
        "Malik"
      ],
      "difficulty": 4
    }
  ],
"2025-01-10": [
    {
      "category": "Commands from the Quran",
      "words": [
        "Iqra",
        "Aqimu",
        "Salu",
        "Jahid"
      ],
      "difficulty": 1
    },
    {
      "category": "Fiqh Terminology",
      "words": [
        "Wudu",
        "Zakat",
        "Hajj",
        "Sawm"
      ],
      "difficulty": 2
    },
    {
      "category": "Types of Islamic Punishments",
      "words": [
        "Hadd",
        "Tazir",
        "Qisas",
        "Diyah"
      ],
      "difficulty": 3
    },
    {
      "category": "Sources of Islamic Law",
      "words": [
        "Quran",
        "Sunnah",
        "Ijma",
        "Qiyas"
      ],
      "difficulty": 4
    }
  ],
  "2025-01-09": [
    {
      "category": "Famous Islamic Scholars",
      "words": [
        "Al-Ghazali",
        "Ibn Taymiyyah",
        "Ibn Hanbal",
        "Al-Shafi'i"
      ],
      "difficulty": 1
    },
    {
      "category": "Key Islamic Battles & Conquests",
      "words": [
        "Yarmouk",
        "Badr",
        "Hattin",
        "Qadisiyyah"
      ],
      "difficulty": 2
    },
    {
      "category": "Quranic Surahs & Verses",
      "words": [
        "Al-Fatiha",
        "Al-Ikhlas",
        "An-Nisa",
        "Al-Baqarah"
      ],
      "difficulty": 3
    },
    {
      "category": "Islamic Jurisprudence & Legal Terms",
      "words": [
        "Ijma",
        "Qiyas",
        "Istihsan",
        "Hudud"
      ],
      "difficulty": 4
    }
  ],
  "2025-01-08": [
    {
      "category": "Prophets in Islam",
      "words": [
        "Adam",
        "Musa",
        "Isa",
        "Yusuf"
      ],
      "difficulty": 1
    },
    {
      "category": "Islamic Rituals & Practices",
      "words": [
        "Zakat",
        "Hajj",
        "Salat",
        "Sawm"
      ],
      "difficulty": 2
    },
    {
      "category": "Important Islamic Terms",
      "words": [
        "Tawhid",
        "Shirk",
        "Nubuwwah",
        "Iman"
      ],
      "difficulty": 3
    },
    {
      "category": "Early Islamic Caliphs",
      "words": [
        "Abu Bakr",
        "Umar",
        "Uthman",
        "Ali"
      ],
      "difficulty": 4
    }
  ],
  "2025-01-07": [
    {
      "category": "Islamic Architecture",
      "words": [
        "Dome of the Rock",
        "Al-Masjid al-Haram",
        "Al-Aqsa",
        "Great Mosque of Córdoba"
      ],
      "difficulty": 1
    },
    {
      "category": "Islamic Philosophers & Thinkers",
      "words": [
        "Ibn Rushd",
        "Al-Kindi",
        "Al-Farabi",
        "Ibn Sina"
      ],
      "difficulty": 2
    },
    {
      "category": "Hadith Collections & Types",
      "words": [
        "Muslim",
        "Abu Dawood",
        "Bukhari",
        "Al-Muwatta"
      ],
      "difficulty": 3
    },
    {
      "category": "Famous Islamic Law Cases",
      "words": [
        "Hudaybiyyah",
        "Stolen Shield",
        "Battle of Jamal",
        "Qisas"
      ],
      "difficulty": 4
    }
  ],
  "2025-01-06": [
    {
      "category": "Prophets Mentioned in the Quran",
      "words": [
        "Nuh",
        "Musa",
        "Ibrahim",
        "Isa"
      ],
      "difficulty": 1
    },
    {
      "category": "Islamic Legal Schools of Thought",
      "words": [
        "Hanafi",
        "Maliki",
        "Shafi'i",
        "Hanbali"
      ],
      "difficulty": 2
    },
    {
      "category": "Names of Important Battles",
      "words": [
        "Badr",
        "Uhud",
        "Khaybar",
        "Hunayn"
      ],
      "difficulty": 3
    },
    {
      "category": "Titles of the Companions of the Prophet",
      "words": [
        "As-Siddiq",
        "Al-Farooq",
        "Dhu al-Nurayn",
        "Ameer al-Mu'mineen"
      ],
      "difficulty": 4
    }
  ],
  "2025-01-05": [
    {
      "category": "Companions Buried in Al-Baqi Cemetery",
      "words": [
        "Uthman ibn Affan",
        "Hassan ibn Ali",
        "Fatimah bint Asad",
        "Aisha bint Abu Bakr"
      ],
      "difficulty": 1
    },
    {
      "category": "Regions Conquered During Caliph Umar's Reign",
      "words": [
        "Jerusalem",
        "Damascus",
        "Egypt",
        "Basra"
      ],
      "difficulty": 2
    },
    {
      "category": "Quranic Words Derived from the Root 'ح-ك-م' (H-K-M)",
      "words": [
        "Hikmah",
        "Hakim",
        "Muhkam",
        "Ahkam"
      ],
      "difficulty": 3
    },
    {
      "category": "Historic Mosques in Islamic History",
      "words": [
        "Al-Haram",
        "Al-Aqsa",
        "Quba",
        "Al-Nabawi"
      ],
      "difficulty": 4
    }
  ],

  "2025-01-04": [
    {
      "category": "Prophets Mentioned in Surah Al-Baqarah",
      "words": [
        "Ibrahim",
        "Musa",
        "Adam",
        "Yusuf"
      ],
      "difficulty": 1
    },
    {
      "category": "Key Islamic Cities",
      "words": [
        "Madinah",
        "Mecca",
        "Jerusalem",
        "Kufa"
      ],
      "difficulty": 2
    },
    {
      "category": "Arabic Words from the Root 'س-ل-م' (S-L-M)",
      "words": [
        "Islam",
        "Muslim",
        "Salam",
        "Taslim"
      ],
      "difficulty": 3
    },
    {
      "category": "Epithets of Companions",
      "words": [
        "Asadullah",
        "Dhu’l-Nurayn",
        "Al-Faruq",
        "Siddiq"
      ],
      "difficulty": 4
    }
  ],

  
  "2025-01-03": [
  {
    "category": "Titles of Prophets in the Quran",
    "words": [
      "Khalilullah",
      "Kalimullah",
      "Ruhullah",
      "Nabiullah"
    ],
    "difficulty": 1
  },
  {
    "category": "Famous Battles in Islamic History",
    "words": [
      "Battle of Hunayn",
      "Battle of Yarmouk",
      "Battle of Tabuk",
      "Battle of Mutah"
    ],
    "difficulty": 2
  },
  {
    "category": "Names of Early Islamic Dynasties",
    "words": [
      "Umayyad",
      "Abbasid",
      "Fatimid",
      "Ayyubid"
    ],
    "difficulty": 3
  },
  {
    "category": "Islamic Philosophical and Theological Terms",
    "words": [
      "Tawhid",
      "Qadar",
      "Irja",
      "Ilm al-Kalam"
    ],
    "difficulty": 4
  }
],
  "2025-01-02": [
  {
    "category": "Titles of Prophets in the Quran",
    "words": [
      "Khalilullah",
      "Kalimullah",
      "Ruhullah",
      "Nabiullah"
    ],
    "difficulty": 1
  },
  {
    "category": "Famous Battles in Islamic History",
    "words": [
      "Battle of Hunayn",
      "Battle of Yarmouk",
      "Battle of Tabuk",
      "Battle of Mutah"
    ],
    "difficulty": 2
  },
  {
    "category": "Names of Early Islamic Dynasties",
    "words": [
      "Umayyad",
      "Abbasid",
      "Fatimid",
      "Ayyubid"
    ],
    "difficulty": 3
  },
  {
    "category": "Islamic Philosophical and Theological Terms",
    "words": [
      "Tawhid",
      "Qadar",
      "Irja",
      "Ilm al-Kalam"
    ],
    "difficulty": 4
  }
],

  // Add more daily puzzles here with date keys
};

export const CONNECTION_GAMES = DAILY_PUZZLES;
